const common = {
  CountryList: {
    "Afghanistan": "アフガニスタン",
    "ÅlandIslands": "オーランド諸島",
    "Albania": "アルバニア",
    "Algeria": "アルジェリア",
    "AmericanSamoa": "アメリカ領サモア",
    "Andorra": "アンドラ",
    "Angola": "アンゴラ",
    "Anguilla": "アンギラ",
    "Antarctica": "南極",
    "AntiguaandBarbuda": "アンティグア・バーブーダ",
    "Argentina": "アルゼンチン",
    "Armenia": "アルメニア",
    "Aruba": "アルバ",
    "Australia": "オーストラリア",
    "Austria": "オーストリア",
    "Azerbaijan": "アゼルバイジャン",
    "Bahamas": "バハマ",
    "Bahrain": "バーレーン",
    "Bangladesh": "バングラデシュ",
    "Barbados": "バルバドス",
    "Belarus": "ベラルーシ",
    "Belgium": "ベルギー",
    "Belize": "ベリーズ",
    "Benin": "ベニン",
    "Bermuda": "バミューダ",
    "Bhutan": "ブータン",
    "Bolivia": "ボリビア",
    "BosniaandHerzegovina": "ボスニア・ヘルツェゴビナ",
    "Botswana": "ボツワナ",
    "BouvetIsland": "ブーベ島",
    "Brazil": "ブラジル",
    "BritishIndianOceanTerritory": "英領インド洋地域",
    "BruneiDarussalam": "ブルネイ",
    "Bulgaria": "ブルガリア",
    "BurkinaFaso": "ブルキナファソ",
    "Burundi": "ブルンジ",
    "Cambodia": "カンボジア",
    "Cameroon": "カメルーン",
    "Canada": "カナダ",
    "CapeVerde": "カーボベルデ",
    "CaymanIslands": "ケイマン諸島",
    "CentralAfricanRepublic": "中央アフリカ共和国",
    "Chad": "チャド",
    "Chile": "チリ",
    "China": "中国",
    "ChristmasIsland": "クリスマス島",
    "CocosKeelingIslands": "ココス（キーリング）諸島)",
    "Colombia": "コロンビア",
    "Comoros": "コモロ",
    "Congo": "コンゴ共和国",
    "CongoTheDemocraticRepublicofthe": "コンゴ民主共和国",
    "CookIslands": "クック諸島",
    "CostaRica": "コスタリカ",
    "CoteDIvoire": "コートジボワール",
    "Croatia": "クロアチア",
    "Cuba": "キューバ",
    "Cyprus": "キプロス",
    "CzechRepublic": "チェコ",
    "Denmark": "デンマーク",
    "Djibouti": "ジブチ",
    "Dominica": "ドミニカ",
    "DominicanRepublic": "ドミニカ共和国",
    "Ecuador": "エクアドル",
    "Egypt": "エジプト",
    "ElSalvador": "エルサルバドル",
    "EquatorialGuinea": "赤道ギニア",
    "Eritrea": "エリトリア",
    "Estonia": "エストニア",
    "Ethiopia": "エチオピア",
    "FalklandIslandsMalvinas": "フォークランド諸島 (Falkland Islands)",
    "FaroeIslands": "フェロー諸島",
    "Fiji": "フィジー",
    "Finland": "フィンランド",
    "France": "フランス",
    "FrenchGuiana": "フランス領ギアナ",
    "FrenchPolynesia": "フランス領ポリネシア",
    "FrenchSouthernTerritories": "フランス領南方・南極地域",
    "Gabon": "ガボン",
    "Gambia": "ガンビア",
    "Georgia": "ジョージア",
    "Germany": "ドイツ",
    "Ghana": "ガーナ",
    "Gibraltar": "ジブラルタル",
    "Greece": "ギリシャ",
    "Greenland": "グリーンランド",
    "Grenada": "グレナダ",
    "Guadeloupe": "グアドループ",
    "Guam": "グアム",
    "Guatemala": "グアテマラ",
    "Guernsey": "ガーニジー",
    "Guinea": "ギニア",
    "GuineaBissau": "ギニアビサウ",
    "Guyana": "ガイアナ",
    "Haiti": "ハイチ",
    "HeardIslandandMcDonaldIslands": "ハード島とマクドナルド諸島",
    "VaticanCityState": "バチカン (Holy See)",
    "Honduras": "ホンジュラス",
    "HongKong": "香港",
    "Hungary": "ハンガリー",
    "Iceland": "アイスランド",
    "India": "インド",
    "Indonesia": "インドネシア",
    "IranIslamicRepublicOf": "イラン",
    "Iraq": "イラク",
    "Ireland": "アイルランド",
    "IsleofMan": "マン島",
    "Israel": "イスラエル",
    "Italy": "イタリア",
    "Jamaica": "ジャマイカ",
    "Japan": "日本",
    "Jersey": "ジャージー",
    "Jordan": "ヨルダン",
    "Kazakhstan": "カザフスタン",
    "Kenya": "ケニア",
    "Kiribati": "キリバス",
    "KoreaDemocraticPeopleRepublicof": "北朝鮮",
    "KoreaRepublicof": "韓国",
    "Kosovo": "コソボ",
    "Kuwait": "クウェート",
    "Kyrgyzstan": "キルギスタン",
    "LaoPeopleDemocraticRepublic": "ラオス",
    "Latvia": "ラトビア",
    "Lebanon": "レバノン",
    "Lesotho": "レソト",
    "Liberia": "リベリア",
    "LibyanArabJamahiriya": "リビア",
    "Liechtenstein": "リヒテンシュタイン",
    "Lithuania": "リトアニア",
    "Luxembourg": "ルクセンブルク",
    "Macao": "マカオ",
    "MacedoniaTheFormerYugoslavRepublicof": "北マケドニア",
    "Madagascar": "マダガスカル",
    "Malawi": "マラウイ",
    "Malaysia": "マレーシア",
    "Maldives": "モルディブ",
    "Mali": "マリ",
    "Malta": "マルタ",
    "MarshalIslands": "マーシャル諸島",
    "Martinique": "マルティニーク",
    "Mauritania": "モーリタニア",
    "Mauritius": "モーリシャス",
    "Mayotte": "マヨット",
    "Mexico": "メキシコ",
    "MicronesiaFederatedStatesof": "ミクロネシア連邦",
    "MoldovaRepublicof": "モルドバ",
    "Monaco": "モナコ",
    "Mongolia": "モンゴル",
    "Montserrat": "モントセラト",
    "Morocco": "モロッコ",
    "Mozambique": "モザンビーク",
    "Myanmar": "ミャンマー",
    "Namibia": "ナミビア",
    "Nauru": "ナウル",
    "Nepal": "ネパール",
    "Netherlands": "オランダ",
    "NetherlandsAntilles": "オランダ領アンティル",
    "NewCaledonia": "ニューカレドニア",
    "NewZealand": "ニュージーランド",
    "Nicaragua": "ニカラグア",
    "Niger": "ニジェール",
    "Nigeria": "ナイジェリア",
    "Niue": "ニウエ",
    "NorfolkIsland": "ノーフォーク島",
    "NorthernMarianaIslands": "北マリアナ諸島",
    "Norway": "ノルウェー",
    "Oman": "オマーン",
    "Pakistan": "パキスタン",
    "Palau": "パラオ",
    "PalestinianTerritoryOccupied": "パレスチナ",
    "Panama": "パナマ",
    "PapuaNewGuinea": "パプアニューギニア",
    "Paraguay": "パラグアイ",
    "Peru": "ペルー",
    "Philippines": "フィリピン",
    "Pitcairn": "ピトケアン",
    "Poland": "ポーランド",
    "Portugal": "ポルトガル",
    "PuertoRico": "プエルトリコ",
    "Qatar": "カタール",
    "Reunion": "レユニオン",
    "Romania": "ルーマニア",
    "RussianFederation": "ロシア",
    "Rwanda": "ルワンダ",
    "SaintHelena": "セントヘレナ",
    "SaintKittsandNevis": "セントクリストファー・ネイビス",
    "SaintLucia": "セントルシア",
    "SaintPierreandMiquelon": "セントピエール・ミクロン",
    "SaintVincentandtheGrenadines": "セントビンセント・グレナディーン諸島",
    "Samoa": "サモア",
    "SanMarino": "サンマリノ",
    "SaoTomeandPrincipe": "サントメ・プリンシペ",
    "SaudiArabia": "サウジアラビア",
    "Senegal": "セネガル",
    "SerbiaandMontenegro": "セルビア・モンテネグロ",
    "Seychelles": "セーシェル",
    "SierraLeone": "シエラレオネ",
    "Singapore": "シンガポール",
    "Slovakia": "スロバキア",
    "Slovenia": "スロベニア",
    "SolomonIslands": "ソロモン諸島",
    "Somalia": "ソマリア",
    "SouthAfrica": "南アフリカ",
    "SouthGeorgiaandtheSouthSandwichIslands": "サウスジョージア・サウスサンドウィッチ諸島",
    "Spain": "スペイン",
    "SriLanka": "スリランカ",
    "Sudan": "スーダン",
    "Suriname": "スリナム",
    "SvalbardandJanMayen": "スヴァールバル諸島・ヤンマイエン島",
    "Swaziland": "エスワティニ",
    "Sweden": "スウェーデン",
    "Switzerland": "スイス",
    "SyrianArabRepublic": "シリア",
    "TaiwanProvinceofChina": "台湾",
    "Tajikistan": "タジキスタン",
    "TanzaniaUnitedRepublicof": "タンザニア",
    "Thailand": "タイ",
    "TimorLeste": "東ティモール",
    "Togo": "トーゴ",
    "Tokelau": "トケラウ",
    "Tonga": "トンガ",
    "TrinidadandTobago": "トリニダード・トバゴ",
    "Tunisia": "チュニジア",
    "Turkey": "トルコ",
    "Turkmenistan": "トルクメニスタン",
    "TurksandCaicosIslands": "タークス・カイコス諸島",
    "Tuvalu": "ツバル",
    "Uganda": "ウガンダ",
    "Ukraine": "ウクライナ",
    "UnitedArabEmirates": "アラブ首長国連邦",
    "UnitedKingdom": "イギリス",
    "UnitedStates": "アメリカ合衆国",
    "UnitedStatesMinorOutlyingIslands": "アメリカ合衆国外諸島",
    "Uruguay": "ウルグアイ",
    "Uzbekistan": "ウズベキスタン",
    "Vanuatu": "バヌアツ",
    "Venezuela": "ベネズエラ",
    "VietNam": "ベトナム",
    "VirginIslandsBritish": "ヴァージン諸島（英国領）",
    "VirginIslandsUS": "ヴァージン諸島（米国領）",
    "WallisandFutuna": "ワリス・フツナ",
    "WesternSahara": "西サハラ",
    "Yemen": "イエメン",
    "Zambia": "ザンビア",
    "Zimbabwe": "ジンバブエ"
  },
  fallback: {
    'Something_Went_Wrong': 'Sorry,Something Went Wrong!',
    'We_are_on_it_will_fix_it_asap':
      'We are on it, will fix it as soon as possible',
    'Go_Back': '戻る',
  },

  // Try New UI
  'Try New UI': '新しいUI',

  'NEW':'新しい',
  'SUBMITTED':'提出された',
  'APPROVED':'承認される',
  'REJECTED':'拒否されました',
  // feeback form
  'Share Your Feedback': "新しいUIについてのフィードバックを共有する",
  'Feedback Form': "新しいUIのフィードバック",
  'Subject': "件名",
  'Please input your subject!': "件名を入力してください",
  'Enter Your Message': "メッセージを入力してください",
  'Please input your query!': "内容を入力してください",
  "Try out our New Das Gateway Features. For Older Version": "新しいゲートウェイUIをご利用中です。旧ゲートウェイUIを利用するには",
  "Feel free to share your valuable feedbacks.": "新しいUIに関する問題、フィードバック、または提案がある場合は",
  "Click Here": "こちら",

  // Timestamp Datepicker
  'ABSOLUTE': '絶対',
  'RELATIVE': '相対',
  'Start': '開始',
  'End': '終了',
  'OK': '確認',
  'Days': '日',

  // Legacy Notice
  "Notice": "お知らせ",
  "Legacy Transaction Notice": "レガシー取引(V2)は、2022年9月にV3取引へ移行したため、廃止となります。このレガシー取引(V2)は、一定の期間中、払い戻しおよび異議申し立て処理をサポートいたします。レガシー取引(V2)には新着機能がない場合があります。",
  "Legacy Statement Notice": "レガシー明細(V2)は、2022年9月にV3に移行したため、廃止されます。このレガシー明細(V2)は支払い終了までサポートいたします。レガシー明細(V2)には新着機能がない場合があります。",
  "Legacy Chargeback Notice": "レガシー異議申し立て 管理(V2)は、2022年9月にV3異議申し立て管理に移行するため、廃止されます。レガシー異議申し立て管理(V2)は、チャージバックのために一定の期間サポートされます。レガシー異議申し立て管理(V2)には新着機能がない場合があります。",


  'Sign in to': 'Payment Optionsにサインイン',
  'Payment Options': '',
  'Email Address': 'メールアドレス',
  'Password': 'パスワード',
  'Forgot Password?': 'パスワードを忘れた場合',
  'Not registered yet?': 'まだ登録していませんか？',
  'Create an Account': 'アカウントを作成する',
  'Merchant Email Address': '加盟店のメールアドレスを入力してください',

  //Validation Schema
  'Invalid email': '無効なメールアドレスです',
  'Required': '必要',

  // button
  'Login': 'ログイン',
  // Swiper Login
  'Simplifying Payments,': '決済をシンプルに',
  'Enable Growth': '成長を実現',
  'Your all-in-one digital payment solutions provider, built to accelerate your business growth.': 'ビジネスの成長を加速するために構築された、オールインワンのデジタル決済ソリューションプロバイダー。',
  'Solution Provider,': 'ソリューションプロバイダー',
  'Payment Methods': '決済方法',
  'Start accepting a wide variety of Payment Methods, choose from credit cards, e-wallets, over-the-counter payments and many more.': 'クレジットカード、電子決済、カウンター越しの対面決済など、さまざまな決済方法を利用できます。',
  'Fastening Payments,': '瞬時に決済',
  'Empowering Growth': '成長を促進',
  'Instantly accept online payments on your website or collect payments using our no code solutions.': 'オンライン決済ソリューションを使用して簡単にお支払いが完了します。',

  //Forgot Password
  'Forgot Your Password': 'パスワードを忘れた場合',
  'We will send you help, just enter your email below to receive password instructions.': 'メールアドレスを入力してください。パスワードの手順を送信します。',
  // button
  'Submit': '送信',
  'Submitting': '提出中',
  'Back To Login': 'ログインに戻る',
  // Reset Password
  'Reset Password': 'パスワードをリセット',
  'Enter New Password': '新しいパスワードを入力',
  "Enter Current Password": "現在のパスワードを入力",
  'Confirm New Password': '確認用の新しいパスワードを入力',
  'Password is required': 'パスワードを入力してください。',
  'Password is too short - should be 14 characters minimum.': 'パスワードが短すぎます - 最低14文字必要です。',
  'Your password must include at least one number, one special character, one uppercase letter, and one lowercase letter.': 'パスワードには、少なくとも1つの数字、1つの特殊文字、1つの大文字、1つの小文字を含める必要があります。',
  'Passwords must match': 'パスワードが一致する必要があります',

  //  ResetPasswordSuccessfull
  'Congratulations': 'パスワード再設定完了',
  'Your Password has been successfully changed.': 'パスワードの再設定が完了しました。',

  // Onboading info and buttons
  'Back': "戻る",
  'Next': "次へ",
  'Overall Percentage': "全体の割合",
  //ChooseAccount
  'Choose an Account': 'アカウントの選択',
  'What type of account you want to create?': 'どのタイプのアカウントを作成しますか？',
  'I’m a Merchant': '私は加盟店です',
  'I’m a Partner': '私はパートナーです',
  'Already have an account?': 'すでにアカウントを持っていますか？',
  'Sign In': 'サインイン',
  'Partner Account': 'パートナーアカウントを作成する',
  'Partner': 'パートナー',

  // Notification
  'Notifications': '通知',
  'No updates yet': 'まだ更新はありません',
  'Your password is going to expire in': 'あなたのパスワードは有効期限が切れます',
  'days on': 'デイズ-オン',
  'To change your password': 'パスワードを変更するには',
  'Your password has expired': 'パスワードの有効期限が切れています',


  //AccountsTab
  'Continue': '続ける',


  //Create Password Page
  'Create Password': 'パスワードを作成する',
  'CREATE ACCOUNT': 'アカウントを作成する',
  'Password Requirements': 'パスワードの要件',
  'Minimum password length should be 14 characters': '最小 m パス長疾患 LD は 14 文字のハンド rs です。',
  "password_req_heading_two": "パスワードの長さ：パスワードは14文字以上でなければなりません。",
  "password_req_heading_three": "パスワードの複雑さ：パスワードには少なくとも以下を含める必要があります。",
  'should contain a letter.': '英小文字を1文字以上',
  'should contain a number.': '数字を1文字以上',
  'should contain a uppercase.': '英大文字を1文字以上',
  'and should contain a special character.': '特殊文字を1文字以上',
  'Supported Special characters': '使用可能な特殊文字：',
  'You’re on the last step of registration!': 'まもなくアカウント作成が完了します！',
  'Set your account’s password.': 'アカウントのパスワードを設定してください。',
  'I agree with the': 'に同意します。',
  'Terms and Conditions': '利用規約',
  'Privacy Policy': 'プライバシーポリシー',
  'and': 'と',
  "I/We warrant that": "私は以下を保証します。",

  //OTP Modal
  'Please enter OTP to verify your account': 'ワンタイムパスワードを使用してアカウントを確認してください',
  'Please check your email account for the verification code we just sent you and enter that code in the box below': 'Eメールに記載されている承認コードをご確認の上、以下のボックスにコードを入力してください。',
  'OTP': 'OTP',
  'Didn’t receive code?': 'コードが届かない場合は？',
  'Resend OTP': 'ワンタイムパスワードを再送信',
  'VERIFY': '確認',
  //Create Account Page 
  'Create your': '',
  'Merchant Account': '加盟店アカウントを作成する',
  'Complete all required fields': 'すべての必須項目を入力してください',
  'First Name': '名',
  'Last Name': '姓',
  'Business Location': '事業所所在地',
  'Phone Number': '電話番号',
  'Verify': '確認',
  'Verified': '検証済み',
  //Risk Management page
  'Risk Configuration': 'リスク設定',
  'Choose File': 'ファイルを選択',
  'Add Risk Rule': 'リスクルールを追加する',
  'Home': 'ホーム',
  'Entity Risk Rule': '企業リスクルール',

  // Add Risk Rule 
  'Prohibited Pan List': '禁止PANリスト',
  'Prohibited Country List': '禁止国リスト',
  'Prohibited IP List': '禁止IPリスト',
  'Prohibited Bin List': '禁止Binリスト',

  // Bank account Types
  'Normal': '普通',
  'Current': '当座預金',
  'Savings': '普通預金',
  "Other": "その他",
  //Delete Confirmation Box
  'Delete': '削除',
  'Are you sure?': '本当によろしいですか？',
  'Do you really want to delete this record? This process can not be undone.': 'このレコードを本当に削除しますか？この操作は元に戻せません。',
  'Cancel': 'キャンセル',
  'Upload': 'アップロード',
  //Tab
  'Statement': 'ステートメント',
  'Trigger Type': 'トリガータイプ',
  'PO Entity': 'PO支社',
  'Prohibited': '禁止された',
  'List': 'リスト',
  'Action': 'アクション',
  'Status': 'ステータス',
  'Select_All': "すべて選択",
  "default": "デフォルト",


  'Edit Risk Rule': 'リスクルールを編集する',
  'Prohibited List': '禁止リスト',
  'Allowed List': '許可リスト',
  'Click To Choose New File': '新しいファイルを選択',
  'Click To Choose File': 'ファイルを選択',
  'Download Prohibited List': '禁止リストのダウンロード',
  'Download List': 'ダウンロードリスト',
  'No file chosen': 'ファイルが選択されていません',
  'Blacklist': 'ブラックリスト',
  'Field': 'フィールド',
  'Allowed BIN List': '許可BINリスト',
  'Allowed IP List': '許可IPリスト',

  'PAN': 'PAN',
  'Issuing Country': '発行国',
  'Bin Numbers': 'BIN番号',
  'IP Address': 'IPアドレス',
  'Enabled': '有効',
  'Disabled': '無効',
  'BLACKLIST': 'ブラックリスト',

  //  Options
  'PO Singapore': 'PO Singapore',
  'PO Japan': 'PO Japan',
  'PO Mauritius': 'PO Mauritius',
  'PO Lithuania': 'PO Lithuania',
  'PO Malaysia': 'PO Malaysia',
  'Max Transaction Amount': '最大取引額',
  'Min Transaction Amount': '最小取引額',
  'File is too large, maximum allowed size is $maxSize kb. Current file has $size kb.': 'ファイルが大きすぎます。許可される最大サイズは次のとおりです $maxSize kb. 現在のファイルには $size kb.',
  // ProductRiskConfiguration
  'Threshold': 'しきい値',
  'Velocity': 'ベロシティ',
  'TimeFrame': 'TimeFrame',
  'Risk Controls for': 'リスク管理対象',

  'The value of the number must be greater than 0': 'The value of the number must be greater than 0',
  'Value': 'パラメータ値 ',
  'Value must be greater than 0': 'Value must be greater than 0',
  'Value of the number must be greater than 0': '負数が入力できません',
  'JPY': 'JPY',
  'Configure Rules': 'ルール設定',

  // Error Page
  'ERROR_HEADING': 'おっと！問題が発生しました。',
  'ERROR_MESSAGE': 'リクエストの処理中に問題が発生しました。',
  'ERROR_BUTTON': '最後のページに戻る',

  //billing cycle
  "Billing_Cycle": {
    "Daily": "毎日",
    "Weekly": "毎週",
    "Monthly": "毎月",
    "Quarterly": "四半期ごと",
    "Semiannually": "半年ごと",
    "Annually": "毎年",
  },

  Payment_Cycle: {
    "Daily": "毎日",
    "Weekly": "毎週",
    "Monthly": "毎月",
    "N/A": "N/A",
  },

  SUBSCRIPTION_STATUS: {
    ACTIVE: '有効',
    COMPLETED: '完了',
    PAUSED: '一時停止',
    INITIATED: '保留中',
    PENDING: '保留中',
    CANCELLED: 'キャンセル済み',
    REJECTED: '却下',
    TOKENPAYMENTFAILED: 'トークン決済失敗',
    TOKENEXPIRED: 'トークンの有効期限切れ',
    INACTIVE: '無効'
  },

  //Risk Configuration
  'Payment Attempts': 'Payment Attempts',
  'Months': 'Months',
  'Hours': '時間',
  'Minutes': '分',

  //MFA Screen
  'VERIFY_CODE': '多要素認証で本人確認を行ってください',
  'ENTER_CODE': '認証アプリから提供された確認コードを入力してください',
  'MFA_RESET_BUTTON': '戻る',
  'MFA_SUBMIT_BUTTON': '提出する',
  'MFA_HAVING_TROUBLE': 'お困りですか？',
  'RESET_MFA': 'MFAをリセット',
  'STEP_1': 'ステップ 1',
  'STEP_1_DESC': 'インストール対応アプリケーション一覧',
  'STEP_1_DESC_2': ' そして ',
  'STEP_1_DESC_3': ' モバイルデバイスとコンピューター上のアプリ。',
  'STEP_1_DESC_GOOGLE': 'Google Authenticator',
  'STEP_1_DESC_DUO': 'Duo Mobile',
  'STEP_1_DESC_AUTTY': 'Authy',
  'STEP_2': 'ステップ 2',
  'STEP_2_DESC': '認証アプリを開き、表示されたQRコードをスキャンするか、「秘密鍵を表示」をクリックして手動で認証アプリに入力してください。',
  'STEP_3': 'ステップ 3',
  'STEP_3_DESC': '下に連続する2つのMFAコードを入力してください',
  'ENTER_OTP_1': 'OTP 1を入力',
  'ENTER_OTP_2': 'OTP 2を入力',
  'SKIP_MFA': 'MFAをスキップ',
  'SHOW_SECRET_KEY': '秘密鍵を表示',
  'COPY_SECRET_KEY': '秘密鍵がクリップボードにコピーされました！',
  'FAIL_COPY_SECRET_KEY': '秘密鍵のコピーに失敗しました。',
  'SCAN_QR_CODE': 'QRコードをスキャン',
  'Skip MFA will remain available for this Release. After Next Release, MFA will be required again for added Security.': '「スキップ MFA」ボタンは、今リリースでは引き続き利用可能ですが、次回リリースではセキュリティ強化のため、MFAが必須となりボタンは削除されます。',
  "Multi Factor Authentication Setup": "多要素認証の設定",


  // Dispute
  link: "リンク",
  Choose: "選択",
  "Choose...": "選択してください...",

  Merchant: {
    Login: {
      label: '加盟店 ログイン',
      // 'email-label': 'メールアドレス',
      // 'password-label': 'パスワード',
      // 'not-registered': 'まだ登録していませんか？',
      // 'create-account': 'アカウントを作成する',
      // 'forgot-password': 'パスワードを忘れた場合',
      Session_Timeout: 'セッションタイムアウト',
      validationSchema: {
        // Invalid_email: '無効なメールアドレスです',
        password_not_provided: 'パスワードが提供されていません',
      },
      // button: {
      //   'Login-button': 'ログイン',
      // },

      // Swiper_Login: {
      // headingA: '決済をシンプルに',
      // mainTitleA: '成長を実現',
      // descriptionA:
      //   'ビジネスの成長を加速するために構築された、オールインワンのデジタル決済ソリューションプロバイダー。',
      // headingB: 'ソリューションプロバイダー',
      // mainTitleB: '決済方法',
      // descriptionB:
      //   'クレジットカード、電子決済、カウンター越しの対面決済など、さまざまな決済方法を利用できます。',
      // headingC: '瞬時に決済',
      // mainTitleC: '成長を促進',
      // descriptionC:
      //   'オンライン決済ソリューションを使用して簡単にお支払いが完了します。',
      // },
      // },
      // ForgotPassword: {
      // label: 'パスワードを忘れた場合',
      // description:
      //   'メールアドレスを入力してください。パスワードの手順を送信します。',
      // Fields: {
      //   'email-label': 'メールアドレス',
      // },
      // button: {
      // 'Submit-button': '送信',
      // 'Login-button': 'ログインに戻る',
      // },
    },
    ResetPassword: {
      // label: 'パスワードをリセット',
      Fields: {
        'otp-label': 'ワンタイムパスワードを入力',
        // 'new-password-label': '新しいパスワードを入力',
        // 'confirm-password-label': '確認用の新しいパスワードを入力',
      },
      errorMessage: {
        // Required: 'パスワードを入力してください。',
        // PasswordLength: 'パスワードが短すぎます - 最低8文字必要です。',
        // PasswordLatin:
        //   'パスワードには、少なくとも1つの数字、1つの特殊文字、1つの大文字、1つの小文字を含める必要があります。',
        // PasswordMatch: 'パスワードが一致する必要があります',
        PasswordShouldNotMatch:
          "パスワードはユーザー名または 'admin' と同じではいけません。",
      },
      // button: {
      //   'Reset-button': 'パスワードをリセット',
      // },
    },
    ResetPasswordSuccessfull: {
      // label: 'パスワード再設定完了',
      // description: 'パスワードの再設定が完了しました。',
      button: {
        'Login-button': 'ログインに戻る',
      },
    },
    AccountsTab: {
      MerchantAccont: '加盟店アカウントの作成',
      PartnerAccont: 'パートナーアカウントを作成する',
      ComingSoon: ' 近日公開予定',
      // Continue: '続ける',
    },
  },
  TransactionsResult: {
    columnDefs: {
      'Action': 'アクション',
      'TransactionRefID': '取引参照ID',
      'Amount': '金額',
      'status': 'ステータス/タイプ',
      'Date': '取引日',
      "UpdatedTransactionDate": "更新日",
      'StartDate': 'スタート日付',
      'EndDate': '締め日付',
      'DASMID': 'DASMID',
      'Scheme': 'スキーム',
      'Merchant': '加盟店アカウント',
      "PaymentType": "付款类别",
      'Acquirer': 'アクワイアラ',
      'Type': '決済タイプ',
      'TransactionType': '取引タイプ',
      'TimeZone': '取引タイムゾーン',
      'IntegrationMethod': '統合方法',
      "IntegrationType": "統合型",
      'CardNumber': 'カード番号',
      'MerchantRefID': '加盟店参照ID',
      'trackID': 'トラックID',
      'AcquirerMID': 'アクワイアラMID',
      'AuthCode': '承認コード',
      'CurrencyCode': '通貨',
      'subscriptionID': 'サブスクリプションID',
      "TerminalID": "ターミナルID",
      "TerminalName": "ターミナル名",
      'productType': '商品タイプ',
      "GatewayError": "ゲートウェレスポンス",
      "ResponseCode": "レスポンスコード",
      "TransactionID": "取引ID",
      "LinkName": "リンク名",
      "MerchantAccountEnglish": "マーチャントアカウント（英語）",
      "Reseller": "パートナー",
      "Tokenization": "トークン化",
      "Yes": "はい",
      "No": "いいえ"
    },
    BreadCrumb: {
      Home: 'ホーム',
      'Search-Transaction-Result': '取引結果の検索',
    },
    'DownloadCSV': 'トランザクションのダウンロード',
    'Refresh': '更新',
    'AdditionalColumn': '追加コラム',
    'AdditionalFields': '追加フィールド',
    'SelectAll': 'すべて選択',
    'Search': '検索',
    'note': "ご注意:",
    'description': "上記のリストから選択した追加の列は、ユーザー設定として保存されます。設定を更新するまで、取引リストビューに含まれます。",
    'filterInfoDescription': 'デフォルトでは、過去1か月のフィルタがトランザクションに適用されます。',
  },
  TransactionDetailDrawerBody: {
    'TransactionHistory': '取引履歴',
    'Status_Heading': '取引ステータスの編集',
    'Should be 6 characters long': "長さは6文字にする必要があります。",
    ApprovePopup: {
      'title': '承認',
      'heading': '本当によろしいですか？',
      'content': 'Are you sure you want to change the transaction status?',
      button: {
        'cancel': 'Cancel',
        'submit': '承認',
      },
    },
    SubscriptionDetails: {
      'Heading': 'Subscription History',
      'BillingCycle': 'Billing Cycle:',
    },
    "TokenizationDetails": {
      "Heading": "Tokenization History"
    },
    ChargebackHistory: {
      'Heading': "拒付历史"
    },
    TransactionReportDownload: {
      'TransactionDownload': "トランザクションのダウンロード",
      'ScheduleReport': "スケジュールレポート",
      'DownloadReportTitle': "トランザクションの詳細",
      'Default Applied Filter': "トランザクション参照IDフィルターを使用すると、複数のトランザクションを一度に検索できます。トランザクション参照IDをカンマで区切って入力してください。",
      'PleaseApply': "トランザクションレポートをダウンロードするにはフィルターを適用してください",
      'RequestDateRange': "ダウンロードをリクエストするには日付範囲を選択してください。",
      'PleaseDownload': "リクエストされたトランザクションレポートをダウンロードしてください",
      'FileTimeLimit': "最近ダウンロードした取引レポート : (14日間利用可能)",
      'AppliedFilters': "適用されたフィルター",
      'RequestDownload': "ダウンロードをリクエスト",
      'MaxLimitReachedTitle': "取引ダウンロード制限を超えました",
      'MaxLimitReachedMessage': "300,000件以上の取引をダウンロードしようとしています。このリクエストについてはサポートチームにお問い合わせいただくか、追加のフィルターを使用して検索を絞り込んでください。",
      'DownloadReport': "レポートをダウンロード",
      'ReportType': "レポート形式",
      "Total Records": "合計レコード数",
      ColumsnDefs: {
        'Action': "アクション",
        'FileName': "レポート名",
        'FileFormat': "レポート形式",
        'CreatedAt': "作成日時",
        'Filter': "適用されたフィルター",
        'Status': "ステータス",
        'NoOfRecords': "#レコード",
        'Preferred Report Name': "優先レポート名",
      },
      ReportStatus: {
        'Initiated': "イニシエートされた",
        'InProgress': "進行中",
        'Ready': "準備完了",
        'Failure': "失敗的"
      },
      "SensitiveColumns": {
        "Include Sensitive Columns": "機密列を含める",
        "Include Whitelisted Transactions": "Include Whitelisted Transactions",
        "ECI VALUE": "ECI値",
        "AVS": "AVS",
        "ACQUIRER MID": "アクワイアラーMID",
        "HASH CARD NUMBER": "カード番号（ハッシュ化）",
        "EXPIRY DATE (MM/YY)": "有効期限 (MM/YYYY)",
      }
    }
  },
  SideMenu: {
    MenuItems: {
      'Dashboard': 'ダッシュボード',
      'Transactions': '取引',
      'Merchants': '加盟店',
      'Acquirers': 'アクワイアラ',
      'Entity': 'リスク管理',
      'Statements': '明細書',
      'Paybylink': '支払いリンク',
      'Disputemanagement': '異議申し立て管理',
      'OnBoarding': '登録',
      'Contact': 'ヘルプ＆サポート',
      'SalesLead': 'セールスリード',
      'Partner': 'パートナー',
      "LegacyTransactions": "レガシー取引",
      "LegacyDisputemanagement": "レガシー異議申し立て管理",
      "LegacyStatement": "レガシー明細",
      "Reseller": "パートナー",
      "Hash Card": "ハッシュカード",
    },
  },
  MenuAppBar: {
    UserProfileItems: {
      'LastLogin': '最終ログイン:',
      'Entity': 'PO支社:',
      'Access': 'アクセスグループ:',
      'Logout': 'ログアウト',
      'Settings': '設定',
      'Change Password': 'パスワードを変更',
      'User Settings': 'ユーザー設定',
      "Sign In As A Merchant": "マーチャントとしてサインインする",
      "Sign Out as Merchant": "販売者としてサインアウト",
    },
    ToggleText: {
      'Test': 'テスト',
      'Live': 'ライブ',
    },
  },
  FilterPopup: {
    button: {
      'Filter': 'フィルター',
      'NextGenFilter': '次世代フィルター'
    },
    PoEntityName: {
      'PO Singapore': 'PO Singapore',
      'PO Japan': 'PO Japan',
      'PO Mauritius': 'PO Mauritius',
      'PO Europe': 'PO Europe',
      'PO Hong Kong': 'PO Hong Kong',
      'PO China': 'PO China',
    }
  },
  MerchantList: {
    Merchants_View_ColumnDefs: {
      'Action': 'アクション',
      'MerchantAccount': '加盟店アカウント',
      'MerchantID': 'マーチャントID',
      'LegalNameInEnglish': '加盟店アカウント（英語）',
      'LegalName': '販売者アカウント',
      'Products': '製品',
      'Country': 'PO支社',
      'CreatedDate': '作成日',
      'Status': 'ステータス',
      'StartDate': '',
      'EndDate': '',
      'DASMID': 'DASMID',
      'ReferredCode': '紹介コード',
      'AcquirerName': 'アクワイアラ名',
    },
    Product_View_ColumnDefs: {
      'Action': 'アクション',
      'MerchantName': '加盟店アカウント',
      'ProductName': '商品名',
      'type': '商品タイプ',
      'MCC': '加盟店カテゴリーコード',
      'DASMID': 'DASMID',
      'AcquirerCode': 'アクワイアラ名',
      Tooltip: {
        'View_Details': '決済情報',
        'AddRiskRule': 'リスクルールを追加',
        'AddPayByLink': 'リンク決済を追加',
        'EnableMID': 'MIDを有効にする',
        'DisableMID': 'MIDを無効化',
        'EditPayByLink': 'Edit Cart Item',
      },
    },
    tabs: {
      'Merchant': '加盟店の画面',
      'Product': '商品ビュー',
    },
    MerchantDetailsTabs: {
      'Merchant Details': '加盟店の情報',
      'Product Details': '決済方法',
      'User Management': 'ユーザーアクセス管理',
      'Catalog': ' 加盟店カタログ',
      'Merchant Settings': '加盟店設定',
      'Device Management': 'Device Management',
    },
    MerchantSettingsTabs: {
      'IP Whitelisting': 'IPホワイトリスト設定',
      'Webhook URL': 'Webhook URLの設定',
      'Update Public Key': '公開鍵の更新',
      'Gateway Public Key': 'ゲートウェイ公開鍵',
      'Tax Configuration': '税設定',
      'Refund Balance': '払い戻し残高の概要',
      'IP_Whitelisting': {
        'Add Ip Address': 'IPアドレスの追加',
        'Edit Ip Address': 'IPアドレスの編集',
        "Previous Comments": "前のコメント",
        "Column_Def": {
          "IP Address": "IPアドレス",
          "Status": "ステータス",
          "Created Date": "作成日",
          "Created By": "によって作成された",
          "Updated Date": "更新日",
          "Updated By": "によって更新されました"
        },
        "Form_Fields": {
          "IP Address": "IPアドレス",
          "Status": "ステータス",
          "Comments": "コメント",
        },
        'ApprovePopup': {
          'titleAdd': 'IPアドレスの追加',
          'titleEdit': 'IPアドレスの更新',
          'heading': '本気？',
          'contentAdd': 'IPアドレスを追加してもよろしいですか？',
          'contentEdit': 'IPアドレスを更新してもよろしいですか？',
          'button': {
            'cancel': 'キャンセル',
            'submit': '提出する',
          },
          "Validation": {
            "ExactIPAddress": "無効なIPアドレス",
            "MaxLength": "最大128文字のみ。"
          },
        },
      },

      'Webhook_Url': {
        'Webhook URL Configure': 'Webhook URLの設定',
        'Add Webhook Url': 'Webhook Urlの追加',
        'Edit Webhook Url': 'Webhook Urlの編集',
        "Previous Comments": "前のコメント",
        "No Webhook Url Configured": "Webhook Urlが設定されていません",
        "Please proceed to configure Webhook Url": "Webhook Urlの設定に進んでください。",
        "Column_Def": {
          "Webhook Url": "Webhook Url",
          "Status": "ステータス",
          "Created Date": "作成日",
          "Created By": "によって作成された",
          "Updated Date": "更新日",
          "Updated By": "によって更新されました",
          "Comments": "コメント",
        },
        "Form_Fields": {
          "Webhook Url": "Webhook Url",
          "Status": "ステータス",
          "Comments": "コメント",
        },
        'ApprovePopup': {
          'titleAdd': 'WEBHOOK URLの追加',
          'titleEdit': 'WEBHOOK URLを更新する',
          'heading': '本気？',
          'contentAdd': 'Webhook Urlを追加してもよろしいですか？',
          'contentEdit': 'Webhook Urlを更新してもよろしいですか？',
          'button': {
            'cancel': 'キャンセル',
            'submit': '提出する',
          },
          "Validation": {
            "ExactIPAddress": "無効なWebhook Url",
            "MaxLength": "最大128文字のみ。"
          },
        },
      },
      'Public_Key': {
        'CardTitle': 'ゲートウェイ公開鍵',
        'FlowTitle': '決済ゲートウェイ公開鍵（推奨）',
        'FlowDescription': '決済ゲートウェイがRSA鍵ペアを生成します。公開鍵は、ゲートウェイに送信する前に機密性の高いカードデータを暗号化するために共有されます。',
        'FlowStep1': 'ゲートウェイがRSA-2048/4096鍵ペアを生成します。',
        'FlowStep2': '公開鍵がマーチャントに提供されます。',
        'FlowStep3': 'マーチャントはゲートウェイ公開鍵を使用してカードデータを暗号化します。',
        'FlowStep4': 'ゲートウェイはHSM/KMSに保存された秘密鍵を使用してペイロードを復号します。',
        'No Public Key Available': 'ゲートウェイ公開鍵は利用できません',
        'No Public Key Available Message': '決済ゲートウェイ公開鍵はまだ利用できません。アクセスが必要な場合はサポートにお問い合わせください。',
        'CopyKey': '鍵をコピー',
        'GenerateKey': '鍵を生成',
        'DownloadKey': '鍵をダウンロード',
        'CopySuccess': '公開鍵をクリップボードにコピーしました。',
        'CopyFailed': '公開鍵のコピーに失敗しました。',
        'DownloadFailed': '公開鍵のダウンロードに失敗しました。',
        'GenerateConfirm': {
          'title': '公開鍵を生成',
          'heading': '本気？',
          'contentGenerate': '新しいゲートウェイ公開鍵を生成してもよろしいですか？',
          'contentRegenerate': '新しい鍵を生成すると、既存のゲートウェイ公開鍵が置き換えられます。続行してもよろしいですか？',
          'cancel': 'キャンセル',
          'submit': '提出する',
        },
        'UsageNote': 'この公開鍵を使用して、決済ゲートウェイに送信する前にカードデータを暗号化してください。',
        'KeyContentUnavailable': '「鍵をダウンロード」ボタンを使用して、ゲートウェイ公開鍵のPEMファイルをダウンロードしてください。',
        'EncryptionGuide': {
          'title': 'カードデータの暗号化方法',
          'description': 'ダウンロードしたゲートウェイ公開鍵を使用して、決済APIに送信する前に機密性の高いカード情報を暗号化します。暗号化はRSA-OAEP（SHA-256）を使用し、暗号文はBase64エンコードする必要があります。',
          'step1': '- 上の「鍵をダウンロード」ボタンでゲートウェイ公開鍵のPEMファイルをダウンロードします。',
          'step2': '- カード番号、有効期限、CVVなどの機密フィールドを含むJSONオブジェクトを作成します。',
          'step3': '- 公開鍵を使用してJSON文字列をRSA-OAEP（SHA-256）で暗号化します。',
          'step4': '- Base64エンコードされた暗号文を決済APIリクエスト（例：encryptedData）に含めて送信します。',
          'note': 'JSONペイロードは小さく保ってください。RSA-4096鍵では平文の最大サイズに制限があります（通常500バイト未満）。暗号化前のカードデータをログに記録したり保存したりしないでください。',
          'CopyCode': 'コードをコピー',
          'CopySuccess': 'コードサンプルをクリップボードにコピーしました。',
          'CopyFailed': 'コードサンプルのコピーに失敗しました。',
        },
        'Column_Def': {
          'Key Alias': 'キーエイリアス',
          'Key Spec': 'キー仕様',
          'Merchant ID': 'マーチャントID',
          'Key Name': '鍵名',
          'Public Key': '公開鍵',
          'Status': 'ステータス',
          'Created Date': '作成日',
          'Updated Date': '更新日',
        },
      },
      'Tax_Configuration': {
        'CardTitle': '税設定',
        'Column_Def': {
          'TaxRegistrationNumber': '税務登録番号',
          'TaxName': '税名',
          'Subsidiary': '子会社',
          'TaxOnMDR': 'MDRにかかる税金（%）',
          'TaxOnOtherFees': 'その他の手数料にかかる税金（%）',
        },
        'EnableLabel': 'マーチャントカタログで{{taxName}}を有効にする',
        'NoConfigTitle': '利用可能な税設定がありません',
        'NoConfigMessage': 'この加盟店の子会社にはまだ税設定が構成されていません。',
        'EnableConfirm': {
          'titleEnable': '税設定を有効にする',
          'titleDisable': '税設定を無効にする',
          'heading': '本気？',
          'contentEnable': 'マーチャントカタログで{{taxName}}を有効にしてもよろしいですか？',
          'contentDisable': 'マーチャントカタログで{{taxName}}を無効にしてもよろしいですか？',
          'cancel': 'キャンセル',
          'submit': '提出する',
        },
      },
    },
    MerchantCatalogs: {
      "MerchantCategory": {
        "Add Category": "カテゴリを追加",
        "Edit Category": "カテゴリの編集",
        "View Products": "商品を見る",
        "Delete Category": "カテゴリの削除",
        "Go Back": "カテゴリに戻る",
        "ColumnsDefs": {
          "CategoryName": "カテゴリ名",
          "CategoryDesc": "説明",
          "CategoryStatus": "ステータス",
          "CategoryID": "カテゴリID",
          "CreatedAt": "で作成された",
          "UpdatedAt": "で更新",
        },
        "FormFields": {
          "CategoryName": "カテゴリ名",
          "CategoryDesc": "説明",
          "CategoryStatus": "ステータス",
        },
        ApprovePopup: {
          'titleAdd': 'カテゴリを追加',
          'titleEdit': 'カテゴリを更新',
          'heading': '本気？',
          'contentAdd': 'カタログカテゴリを追加してもよろしいですか？',
          'contentEdit': 'カタログカテゴリを更新してもよろしいですか？',
          'button': {
            'cancel': 'キャンセル',
            'submit': '提出する',
          },
        },
      },
      "MerchantCategoryProducts": {
        "Add Product": "製品を追加",
        "Edit Product": "製品の編集",
        "View Products": "商品を見る",
        "Delete Product": "製品の削除",
        "ColumnsDefs": {
          "ProductName": "製品名",
          "ProductDesc": "説明",
          "ProductFoodType": "食品タイプ",
          "ProductSize": "部分のサイズ",
          "ProductStatus": "ステータス",
          "CategoryID": "カテゴリID",
          "ProductPrice": "価格",
          "ProductID": "製品ID",
          "ProductImage": "イメージ",
          "ProductCode": "製品SKU/コード",
          "CreatedAt": "で作成された",
          "UpdatedAt": "で更新",
          "ProductStock": "在庫",
        },
        "FormFields": {
          "ProductName": "製品名",
          "ProductDesc": "説明",
          "ProductStatus": "ステータス",
          "ProductPrice": "価格",
          "ProductImage": "イメージ",
          "ProductCode": "製品SKU/コード",
          "ProductStock": "在庫",
          "Currency": "通貨",
          "ServiceFee": "サービス料（%）",
          "EnableServiceFee": "有効にする",
          "FoodType": "食品タイプ",
          "Size": "部分のサイズ",
          "foodSizeOptions": {
            "Regular": "レギュラー",
            "Medium": "ミディアム",
            "Large": "大きい",
          },
          "foodTypeOptions": {
            "Non-Veg": "非野菜",
            "Veg": "ベジタブル",
          },
        },
        ApprovePopup: {
          'titleAdd': '製品を追加',
          'titleEdit': '製品の更新',
          'heading': '本気？',
          'contentAdd': 'あなたは製品を追加してもよろしいですか？',
          'contentEdit': '製品を更新してもよろしいですか？',
          'button': {
            'cancel': 'キャンセル',
            'submit': '提出する',
          },
        },
      }
    },
    breadcrumbs: {
      'Home': 'ホーム',
      'Merchants': '加盟店',
    },
    MerchantTable: {
      'View_Details': '決済情報',
    },
    ApprovePopup: {
      'title': 'MIDを無効化',
      'heading': '本当によろしいですか？',
      'content': 'このMIDを無効にしてもよろしいですか？',
      button: {
        'cancel': 'キャンセル',
        'submit': '承認',
      },
    },
    DeclinePopup: {
      title: 'MIDを有効にする',
      heading: '本当によろしいですか？',
      content: 'このMIDを有効にしてもよろしいですか？',
      button: {
        cancel: 'キャンセル',
        submit: '承認',
      },
    },
    EnableDisableMID: {
      placeholder: 'Enable disable MID',
      Active: '有効',
      Terminate: '終了',
      Pending: '保留中',
    },
    Action: 'アクション',
    TerminalId: 'ターミナルID',
    TerminalName: 'ターミナル名',
    LocationId: '場所ID',
  },
  AcquirerList: {
    AcquirerList_ColumnDefs: {
      Action: 'アクション',
      AcquirerName: 'アクワイアラ名',
      AcquirerCode: 'アクワイアラ識別子',
      SettlementOffset: '相殺処理',
      DateInserted: '作成日',
      Status: 'ステータス',
    },
    breadcrumbs: {
      Home: 'ホーム',
      Acquirer: 'アクワイアラ',
    },
    AddAcquirer: 'アクワイアラを追加',
    EditAcquirer: 'アクワイアラを編集',
    AddAcquirerDetails: 'アクワイアラMIDの詳細を追加',
    AddAcquirerDetail: {
      fields: {
        'Acquirer MID': 'アクワイアラMID',
        'INTEGRATION METHOD': '統合方式',
        'ACQUIRER IDENTIFIER': 'アクワイアラ識別子',
        'STATUS': 'ステータス',
        'DESCRIPTION': '説明',
        'Transaction Type': '取引タイプ',
        'Username': 'ユーザー名',
        'Password': 'パスワード',
        'Is Recurring': '定期支払い',
        'Is Tokenised': 'トークン化されている',
        'Is Dynamic MCC': '動的なMCCコード',
        'Is Block Refund': 'ブロック払い戻しはありますか',
        'Google MID': 'グーグル MID',
        'Google MID Validation': 'グーグル MID は英字と数字のみを含む必要があります'
      },
    },
    EditAcquirerDetails: 'アクワイアラMIDの詳細を編集',
  },
  TransactionDetail: {
    TransactionDetailHeading: '取引詳細',
    Edit_button: 'ステータスの編集',
    breadcrumb: {
      Home: 'ホーム',
      SearchTransactionDetails: '取引結果の検索',
    },
    TransactionTile: {
      "Total Sales": "总销售额",
      "Today Sales": "本日の売上",
      "Total Refund": "退款总额",
      "Today Refund": "本日の払い戻し",
      "Approval Ratio": "批准比率",
    },
    TransactionInfo: {
      label: '取引情報',
      fields: {
        TransactionRefID: '取引参照ID',
        DASMID: 'DASMID',
        Merchant: '加盟店アカウント',
        LegalNameInEnglish: '加盟店アカウント（英語）',
        TransactionType: '取引タイプ',
        ReferenceRemark: '参照',
        Date: '取引日',
        Amount: '金額',
        CurrencyCode: '通貨',
        Response: 'レスポンスコード',
        Status: 'ステータス',
        AuthCode: '承認コード',
        RequestID: 'リクエストID',
        CVVResponse: 'CVVレスポンス',
        GatewayError: 'ゲートウェレスポンス',
        TransactionID: '取引ID',
        TrackID: 'トラックID',
      },
    },
    CustomerDetails: {
      label: 'カード所有者詳細',
      field: {
        CardNumber: 'カード番号',
        HashCardNumber: 'Hash カード番号',
        Scheme: 'スキーム',
        ExpiryDate: '有効期限（月/年）',
        CardHolder: 'カード所有者',
        EmailAddress: 'メールアドレス',
        Phone: '電話番号',
        BillingCountry: '請求国',
        BillingPostcode: '請求郵便番号',
        BillingAddress: '請求先住所',
        BillingCity: "請求都市",
        ShippingCountry: '配送国',
        ShippingPostcode: '配送郵便番号',
        ShippingAddress: '配送先住所',
        ShippingCity: "発送都市",
        PaymentType: "付款类别",
      },
    },
    AdditionalInformation: {
      label: '追加情報',
      fields: {
        IssuingBank: '発行銀行',
        IssuingCountry: '発行国',
        BIN: 'BIN',
        TransactionTimezone: '取引タイムゾーン',
        MerchantCategoryCode: '加盟店カテゴリーコード',
        MerchantIP: '加盟店IP',
        CustomerIP: '顧客IP',
        MerchantRefNumber: '加盟店参照ID',
        Acquirer: 'アクワイアラ',
        AcquirerMID: 'アクワイアラMID',
        AcquirerReferenceNumber: 'アクワイアラ参照番号',
        eci: 'ECI値',
        ACQError: 'アクワイアラレスポンス',
        Isrecurring: 'Isrecurring',
        Memo: "メモ",
        TerminalID: "端末ID",
        TerminalName: "端末名",
        PBLLinkName: "リンク名",
        ProductType: "製品タイプ",
      },
    },
    BrowserInformation: {
      label: '浏览器信息',
      fields: {
        acceptHeader: 'アクセプトヘッダー',
        screenColorDepth: '画面の色深度',
        javaEnabled: 'Javaの有効性',
        challengeWindowSize: '挑战窗口大小',
        language: '言語',
        screenHeight: '画面縦幅',
        screenWidth: '画面横幅',
        challengeWindow: 'チャレンジウィンドウ',
        userAgent: 'ユーザーエージェント',
      },
    },
    TransactionHistory: {
      label: '取引履歴',
    },
    TransactionListButtonPopper: {
      button: {
        Details: '詳細',
      },
    },
    actionButton: {
      REFUND: '払い戻し',
      CAPTURE: '確定',
      DISPUTE: '異議申し立て',
      Void_Authorisation: '承認取消',
      heading: '本当によろしいですか？',
      content:
        'この取引を無効にしてもよろしいですか？このプロセスは元に戻せません。',
      message: {
        refundFailed: '返金が失敗しました！',
        captureFailed: 'キャプチャーが失敗しました！',
      },
      button: {
        submit: '送信',
        cancel: 'キャンセル',
      },
    },
    rufundButton: '払い戻し',
    voidButton: '取消',
    TransactionTabList: {
      'Transaction History': '取引履歴',
      'Subscription History': 'サブスクリプション履歴',
      'Tokenization History': 'トークン化履歴',
      'Audit Log': '監査ログ',
      'Case History': 'ケース履歴',
      'Chargeback History': '拒付历史',
      'Order Overview': '注文概要'
    }
  },
  ActionButtons: {
    TransactionEvent: '取引イベント',
    PENDING: '未確定',
    REFUSED: '拒否された',
    CANCELLED: 'キャンセル',
    PURCHASED: '購入完了',
    CAPTURED: 'キャプチャ完了',
    AUTHORISED: '承認済み',
    REFUNDED: '返金完了',
    ACQERROR: 'アクアイアラエラー',
    VOIDED: '無効された',
    PARTIALLY_CAPTURED: '一部キャプチャされた',
    PARTIALLY_REFUNDED: '一部返金処理された',
    PRECONDITION_FAILED: '前提条件を失敗',
    NOT_ACCEPTABLE: '受け付けできません',
    UNKNOWN_ERROR: '不明なエラー',
    TIMEOUT: 'タイムアウト',
    DECLINED: '拒否された',
  },
  RefundTransaction: {
    title: '払い戻し要求を出す',
    Amount: '元の金額',
    RemainingAmount: '残額',
    RefundAmount: '払い戻し金額',
    Reference: '参照（任意）',
    ConfirmRefundCheckbox:
      '私は返金処理が取り消せないを認識し、返金処理リクエストを依頼します。返金処理の開始をお願いします。',
    helperText: {
      RefundAmount_helperTxt_JP: '数字の値は1より大きくなければなりません',
      RefundAmount_helperTxt: '数値は0より大きくする必要があります',
      OptionalMessage: '最大128文字まで。',
    },
    message: {
      ConfirmRefundCheckbox:
        'Please confirm if you want to proceed with this request.',
      RefundAmount: '数値は小数点以下 2 桁までにする必要があります',
      ref_max_Character: '最大128文字まで。',
    },
  },
  Merchant_Detail: {
    MerchantDetail: {
      label: '加盟店の情報',
      fields: {
        LegalName: '加盟店アカウント',
        LegalNameInEnglish: '加盟店アカウント (English)',
        RegistrationNumber: '法人番号',
        SubsidiaryID: 'PO支社',
        Company_Address_Information: '登記上の住所 ',
        City: '市区町村',
        PostalCode: '郵便番号',
        Country: '国',
        ResellerName: 'パートナー名',
        ResellerNames: 'パートナー名一覧',
        MCC: '加盟店カテゴリーコード',
      },
    },
    API_keys: {
      label: 'APIキー',
      fields: {
        "Live_API_key": 'ライブAPIキー',
        "Test_API_key": 'テストAPIキー',
        "Live Key Visible": "ライブキーが表示されます。",
        "Live Key Hidden": "ライブキーが隠されています。",
        "Test Key Visible": "テストキーが表示されます。",
        "Test Key Hidden": "テストキーが隠されています。",
        "Live Key Encoded": "ライブキーがエンコードされています。",
        "Live Key Decoded": "ライブキーがデコードされました。",
        "Test Key Encoded": "エンコードされたテストキー。",
        "Test Key Decoded": "テストキーがデコードされました。",
        "Live Key Copied": "ライブキーがコピーされました。",
        "Test Key Copied": "テストキーがコピーされました。",
        "Failed to show Key": "キーの表示に失敗しました。",
        "Failed to Copy": "コピーに失敗しました。",
        "Failed to Encode / Decode": "エンコード/デコードに失敗しました。",
      },
    },
    Product_Information: {
      label: '決済方法',
      columnDefs: {
        Action: 'アクション',
        Name: '名前',
        Type: '決済タイプ',
        MCC: '加盟店カテゴリーコード',
        DASMID: 'DASMID',
        AcquirerMID: 'アクワイアラーMID',
        OneTimeSetUpFee: 'Setup Fee',
        MonthlyFee: 'Monthly Fee',
        AnnualFee: 'Annual Fee',
        FraudMonitorFee: 'Fraud Monitoring Fee',
        FraudMonitorFeeFrequency: 'Fraud Monitoring Fee (Frequency)',
        SettlementTransferFee: 'Settlement Transfer Fee',
        TransactionFee: 'Success Fee',
        BankFee: 'Decline Fee',
        RefundFee: 'Refund Fee',
        ChargebackFee: 'Chargeback Fee',
        MinFeeAmt: 'Pre-Arbitration Fee',
        MaxFeeAmt: 'Representment Fee',
        RetrievalFee: 'Retrievals Fee',
        MDR: 'MDR',
        MicroMDR: 'Micro MDR',
        RollingReserve: 'Rolling Reserve %',
        RollingReserveHeld: 'Rolling Reserve Held (YTD)',
      },
      View_Details: '詳細を見る',
      Add_Risk_Rule: 'Add Risk Rule',
      Edit_Risk_Rule: 'Edit Risk Rule',
      view_subscription_Plan: 'サブスクリプションプランの詳細',
      Edit_Subscription_Plan: '定期購読プランの編集',
      View_Subscriber: '加入者の詳細',
      Edit_Subscriber: '加入者を編集する',
      View_Subscriptions: '定期購読の表示',
      Create_Subscription: 'サブスクリプションを作成する',
      Edit_Subscription: '定期購読の編集',
      View_Scheduler: 'View Scheduler',
    },
    User_Management: {
      label: 'ユーザーアクセス管理',
      columnDefs: {
        Action: 'アクション',
        First_Name: '名',
        Last_Name: '姓',
        Email: 'メールアドレス',
        User_Role: 'ユーザーの役割',
        Recieve_Notifications: '通知を受け取る',
        User_Access_Level: 'ユーザーアクセスレベル',
        Status: 'ステータス',
        Join_Date: '参加日',
        Last_Login: '最終ログイン',
        DASMID: 'DASMID',
        Products: '製品',
        Notifications: {
          Recieve_Notifications: '通知を受け取る',
          Chargeback: 'チャージバック',
          Statement: '明細',
          Help_Support: 'ヘルプ＆サポート',
          Emergency_Holiday: '休暇',
          Monthly_Public_Holiday: '公休日',
        },
      },
      Edit_User: 'ユーザーアクセスの編集',
      Reset: 'パスワードのリセット',
      Deactivate: 'ユーザーの無効化',
      Delete: 'ユーザーの削除',
      button: {
        cancel: 'キャンセル',
        submit: '送信',
      },
      Add_New_User: {
        add_label: '新しいユーザーの追加',
        edit_label: 'ユーザーの編集',
      },
      User_Roles: {
        Admin: '管理者',
        Viewer: '閲覧者',
        Editor: '編集者',
        Customer: 'CUSTOMER',
        Staff: 'スタッフ',
      },
      Status: {
        Active: '有効',
        Inactive: '無効',
        Expired: '期限切れ',
      },
      DeletePopup: {
        title: '削除',
        heading: '本当によろしいですか？',
        content: 'ユーザーを削除しますか？このプロセスは取り消せません。',
        button: {
          cancel: 'キャンセル',
          submit: '削除',
        },
      },
      DeactivatePopup: {
        title: '無効にする',
        heading: '本当によろしいですか？',
        content: 'ユーザーを無効にしますか？このプロセスは取り消せません。',
        button: {
          cancel: 'キャンセル',
          submit: '確認',
        },
      },
      ActivatePopup: {
        title: '有効にする',
        heading: '本当によろしいですか？',
        content: 'ユーザーを有効にしますか？このプロセスは取り消せません。',
        button: {
          cancel: 'キャンセル',
          submit: '確認',
        },
      },
      ResetPasswordPopup: {
        title: 'パスワードのリセット',
        heading: '本当によろしいですか？',
        content:
          'パスワードをリセットしますか？ユーザーに通知するためにメールが送信されます。このプロセスは取り消せません。',
        button: {
          cancel: 'キャンセル',
          submit: '確認',
        },
      },
      ApiMessages: {
        Delete: {
          UserDelete: 'User Deleted successfully.',
          UserDeleteFailed: 'User Deletion Failed.',
        },
      },
    },
    Subscription: {
      label: 'サブスクリプション',
      tabs: {
        subscriptionsPlans: ' サブスクリプションプラン',
        Subscriptions: 'サブスクリプション',
        Subscribers: '加入者',
      },
      columnDefs: {
        action: 'アクション',
        planName: 'プラン名',
        billingCycle: '請求サイクル',
        amount: '金額',
        trialPeriod: 'トライアル期間',
        discount: '割引',
        Subscribers: '加入者',
        status: 'ステータス',
        subscriptionName: '定期購読者名',
        subscriptionPlan: 'サブスクリプションプラン',
        subscriptionID: 'サブスクリプションID',
        subscriberName: '加入者名',
        startDate: '開始日',
        endDate: '終了日',
        nextBilling: '次回請求',
        nextBillingDate: '次回請求',
        cycleBilling: '請求サイクル',
        source: 'ソース',
        planID: 'プランID',
        subscriptionLink: 'サブスクリプションリンク',
        trialPeriodFree: 'トライアル期間（無料日数）',
        Days: '日',
        Months: '月',
        emailAddress: 'Eメールアドレス',
        firstName: '名',
        lastName: '姓',
        includes: '含む',
        immediately: '即時',
        specificDate: '特定の日付',
        forever: '終了日なし',
        after: 'あと',
        cycles: 'サイクル',
        linkExpiryDate: 'リンクの有効期限',
        sendSubscriptionLink: '加入者にサブスクリプションリンクを送る',
        billedCycle: '請求サイクル',
        phoneNum: '電話番号',
        CardNumber: 'カード番号',
        expiryDate: '有効期限',
        country: '国',
        subscriptions: 'サブスクリプション',
        cvv: 'CVV番号',
        postCode: '郵便番号',
        billingCountry: '請求国',
        browse: '参照',
        currency: '通貨',
        CreateSubscription: 'Create Subscription',
        firstPercentage: '% First',
        SpecificStartDate: '開始日',
        SpecificEndDate: '終了日',
        'Subscription Type': 'サブスクリプションタイプ',
        'Discount Percentage': '割引率',
        'Discount Month': '割引月',
        'SUBSCRIBER DETAILS': '利用者の詳細',
        'SUBSCRIPTION DETAILS': 'サブスクリプションの詳細',
        'Comments': 'コメント'
      },
      buttons: {
        view: '詳細を見る',
        copyLink: 'リンクをコピー',
        edit: '編集',
        duplicatePlan: 'プランを複製',
        duplicate: '複製',
        delete: '削除',
        cancel: 'キャンセル',
        submit: '送信',
        addSubscriptionPlan: '新しいサブスクリプションプランを作成する',
        addSubscription: '新しい定期購読を作成する',
        uploadSubscription: '定期購読をインポートする',
        regenerateLink: 'リンクの再生成',
        createSubscription: 'サブスクリプションを作成する',
        pauseButton: 'Pause',
        resumeButton: 'Resume',
      },
      drawer: {
        subscriptionPlanDetails: 'サブスクリプションプランの詳細',
        addSubscriptionPlan: '新しい定期購読プランを作成する',
        EditSubscriptionPlan: '定期購読プランの編集',
        editSubscriptionPlanDetails: '定期購読プランの編集',
        createSubscription: 'サブスクリプションを作成する',
        SubscriptionDetails: 'サブスクリプションの詳細',
        EditSubscription: '定期購読の編集',
        ViewSubscriber: '加入者の詳細',
      },
      subscriptionDetailsDrawer: {
        subscriberDetails: '加入者の詳細',
        subscriptionDetails: 'サブスクリプションの詳細',
      },
      deletePopup: {
        deleteSubscriptionPlan: 'サブスクリプションプランを削除する',
        deleteSubscriber: 'サブスクライバーを削除する ',
        warningMsg: '本当によろしいですか？',
        deleteSubscription: 'サブスクリプションを削除',
        subscriptionPlanContent:
          'この定期購読プランを削除してもよろしいですか？このプロセスは元に戻せません。',
        subscriptionContent:
          'この定期購読をキャンセルしてもよろしいですか？このプロセスは元に戻せません。',
        subscriberContent:
          'この定期購読者を削除してもよろしいですか？このプロセスは元に戻せません。',
        subscriptionPlanDeleteMsg:
          'サブスクリプションプランは正常に削除されました！',
        subscriberDeleteMsg: 'Subscriber deleted successfully!',
        pauseSubscription: 'Pause Subscription',
        resumeSubscription: 'Resume Subscription',
        pauseSubscriptionMsg:
          'Are you sure you want to pause this subscription ?',
        resumeSubscriptionMsg:
          'Are you sure you want to resume this subscription ?',
        cancelDescription: 'Cancel Subscription',
      },
      downloadPopup: {
        subscriptionsCSVImport: '定期購読のCSVインポート',
        popupHeader: 'CSV形式で定期購読リストをアップロードしてください。',
        uploadCSVFile: 'CSVファイルをアップロード',
      },
      duplicatePopup: {
        duplicateSubscription: 'すでに定期購読が存在しています',
        heading: 'この定期購読者はすでに定期購読プランを持っています:',
        changePlan: 'プランの変更',
        overwriteSubscription: '定期購読の上書き',
      },
      Subscriber: {
        editSubscriber: '加入者を編集する',
        paymentDetails: '支払詳細 ',
      },
      subscriberCount: 'このサブスクリプションプランには既に加入者がいます ',
      activeSubscriber: 'サブスクライバーはアクティブです ',
      subscriptionCreatedSuccessfully:
        'サブスクリプションが正常に作成されました',
      subscriptionUpdatedSuccessfully:
        'サブスクリプションが正常に更新されました',
    },
    ContactDetail: {
      label: '連絡先情報',
      fields: {
        FirstName: '名',
        MiddleName: 'ミドルネーム',
        LastName: '姓',
        TelephoneNumber: '連絡番号',
        EmailAddress: 'メールアドレス',
      },
    },
    breadcrumbs: {
      Home: 'ホーム',
      Merchants: '加盟店',
      MerchantsDetails: '加盟店情報',
    },
  },
  ProductModal: {
    'Merchant Account': '加盟店アカウント',
    'Shop Processing URL': '加盟店ホームページ',
    'customerServiceNumber':'Customer Service Number',
    'Merchant Category Code': '加盟店カテゴリーコード',
    'Settlement Currency': '決済通貨',
    'Processing Currency': '処理通貨',
    'Acquirer MID': 'アクワイアラーMID',
    'Recurring Acquirer MID': 'Recurring アクワイアラーMID',
    'Auth Acquirer MID': 'Auth アクワイアラーMID',
    'ApplePay MID': 'ApplePay MID',
    'GooglePay MID': 'GooglePay MID',
    'GCash MID': 'GCash MID',
    'PAYPAY MID': 'PAYPAY MID',
    'Purchase Acquirer MID': 'Purchase アクワイアラーMID',
    'DAS MID': 'DASMID',
    'Billing Descriptor': '請求名',
    'Merchant Logo URL': '加盟店ロゴURL',
    'Scheme Types': 'カードブランド',
    'Acquirer Code': 'アクワイアラ名',
    'Customer Service Number': '顧客サービス番号',
    ConnectionMethods: {
      'Connection Methods': '統合型',
      value: {
        HPP: 'ホストペイメントページ',
        SERVERTOSERVERAPI: 'サーバーツサーバー接続',
      },
    },
    TransactionType: {
      'Transaction Type': '取引タイプ',
      value: {
        '3DSecure': '3Dセキュア',
        Non3DSecure: '未3Dセキュア',
        'CVV2/CVC2': 'CVV2/CVC2',
        'NonCVV2/CVC2': '未CVV2/CVC2',
        Recurring: '定期支払い',
        Tokenised: 'トークン化された',
        DynamicMCC: '動的な商店カテゴリーコード',
      },
    },
    button: {
      closeButton: '閉める',
    },
  },
  Acquirer_Details: {
    AcquirerDetails: {
      label: 'アクワイアラ詳細',
      fields: {
        AcquirerName: 'アクワイアラ名',
        TimeZone: 'タイムゾーン',
        URL1: 'Url',
        Country: '国',
        ChargebackInvestigationDays: 'チャージバック調査期間',
        AcquirerIndentifier: 'アクワイアラ識別子',
        RetrievalInvestigationDays: 'リトリーバル統合日数',
        SettlementOffset: '相殺処理',
        Token: 'トークン',
        Sender: '送信者',
        SenderHelperText: 'Acquirer MID for Acquirer MineSec.',
        Channel: 'チャンネル',
        ChannelHelperText: 'Terminal ID (TID) for Acquirer MineSec.',
        Status: 'ステータス',
      },
    },
    AcquirerMID: {
      label: 'アクワイアラMIDの詳細',
      fields: {
        AcquirerMID: "アクワイアラMID",
        MerchantCodes: 'Merchant Codes',
        PaymentCurrency: 'Payment Currency',
        SettlementCurrency: 'Settlement Currency',
        Description: '説明',
        EnterMsg: 'Enter Message',
      },
    },
    breadcrumbs: {
      Home: 'ホーム',
      Acquirer: 'アクワイアラ',
      AcquirerDetails: 'アクワイアラ詳細',
    },
  },
  Add_Acquirer: {
    AddAcquirer: {
      label: 'アクワイアラを追加',
      fields: {
        AddAcq: 'アクワイアラ名',
        TimeZone: 'タイムゾーン',
        URL1: 'Url',
        Country: '国',
        ChargebackInvestigationDays: 'チャージバック調査期間',
        AcquirerIndentifier: 'アクワイアラ識別子',
        RetrievalInvestigationDays: 'リトリーバル統合日数',
        SettlementOffset: '相殺処理',
        Status: 'ステータス',
        Token: 'トークン',
        Sender: '送信者',
        Channel: 'チャンネル',
        URLMaxLimitMessage: '最大256文字まで。',
        NameMaxLimitMessage: '最大128文字のみ。',
        CodeMaxLimitMessage: '最大45文字のみ。',
      },
      breadcrumb: {
        Home: 'ホーム',
        Acquirer: 'アクワイアラ',
        AddAcquirer: 'アクワイアラを追加',
      },
      button: {
        Submit: '送信',
        Cancel: 'キャンセル',
      },
    },
  },
  EditAcquirer: {
    label: 'アクワイアラーの詳細を編集する',
    breadcrumb: {
      Home: 'ホーム',
      Acquirer: 'アクワイアラ',
      AcquirerDetails: 'アクワイアラ詳細',
      EditAcquirer: 'アクワイアラを編集',
    },
  },
  Filter: {
    AdvancedFilters: '高度なフィルター',
    Add_New_Filter: '新しいフィルターを追加',
    button: {
      Reset: 'リセット',
      Apply: '適用',
    },
    field: 'フィールド',
    Value: '値',
    NoReferredMerchants: '紹介先加盟店がありません',
    AUTHORISATION: '承認',
    PURCHASE: '購入',
    CAPTURE: '確定',
    VOIDAUTHORISATION: '承認取消',
    REFUND: '払い戻し',
    SUCCESSFUL: '成功',
    NOTSUCCESSFUL: '失敗',
    PENDING: '未確定',
    SELECTDATERANGE: '日付範囲を選択',
  },
  ISSUE_A_REFUND: {
    label: '払い戻し要求を出す',
    button: {},
  },
  FormTemplate: {
    button: {
      Submit: '送信',
      Cancel: 'キャンセル',
    },
  },
  ProductRiskRuleDrawerModal: {
    currency: {
      // JPY: 'JPY',
      SGD: 'SGD',
    },
    DownloadProhibitedList: '禁止リストのダウンロード',
    RISK_CONFIGURATION: 'リスク設定',
    'transaction-title': 'Risk Controls for',
    // Statement: 'ステートメント',
    Trigger_Type: 'トリガータイプ',
    Action: 'アクション',
    // Configure_Rules: 'ルール設定',
    Blacklist: 'ブラックリスト',
    Threshold: 'しきい値',
    Velocity: 'ベロシティ',
    Whitelist: "ホワイトリスト",
    Refund_Percentage: '返金率',
    // Field: 'フィールド',
    TimeFrame: '時間枠',
    Select_Currency: "通貨を選択",
    Total_payout: "総支払い額",
    Allowable_Refund: '許容される返金率',
    Refund_Balance: '許容払い戻し額',
    Remaining_Refund_Amount: '残りの払い戻し額',
    Settlement_Period: '決済期間',
    Payment_Cycle: '支払いサイクル',
    Statement_Status: 'Statement Status',
    // Value: 'パラメータ値 ',
    // ProhibitedList: '禁止された国リスト',
    // Edit_Ridk_Rule: 'リスクルールを編集する',
    Add_Risk_configuration: 'Add Risk Configuration',
    button: {
      Submit: '送信',
      Cancel: 'キャンセル',
    },
    // helperText: {
    // Threshold: '負数が入力できません',
    // TimeFrame: 'Value must be greater than 0',
    // Value: 'The value of the number must be greater than 0',
    // },
    option: {
      IssuingCountry: 'イシュアの国',
      // PAN: 'PAN',
      // IPAddress: 'IP Address',
      Field: 'Max Transaction Amount',
      MaxTransactionAmount: '最大取引額',
      MinTransactionAmount: '最小取引額',
      "REFUND": "Refund Count",
      "REFUND_VOLUME": "Refund Volume"
    },
    message: {
      Value: '数値は小数点以下 2 桁までにする必要があります',
    },
  },
  ProductEnableDisableMid: {
    heading: 'MIDを有効化 / 無効化',
  },
  TransactionCaptureDrawerBody: {
    ISSUE_A_CAPTURE: '確定要求を出す',
    fields: {
      Original_Amount: '元の金額',
      Remaining: '残額',
      CaptureAmount: '確定金額',
      Reference: '参照（任意）',
      ConfirmCaptureCheckbox:
        'はい、金額を確定することを望み、このアクションが不可逆であることを理解しています。確定プロセスの開始を進めてください。*',
    },
    helperText: {
      CaptureAmountJP: '数字の値は1より大きくなければなりません',
      CaptureAmount: '数値は0より大きくする必要があります',
      OptionalMessage: '最大128文字まで。',
    },
    message: {
      ConfirmCaptureCheckbox:
        'Please confirm if you want to proceed with this request.',
      CaptureAmount: '数値は小数点以下 2 桁までにする必要があります',
      notification: 'キャプチャー額が残り金額を超えられないです。',
      ref_max_Character: '最大128文字まで。',
    },
    button: {
      Submit: '送信',
      Cancel: 'キャンセル',
    },
  },
  TransactionRefundDrawerBody: {
    notification: '返金処理額が残り金額を超えられないです。',
  },
  TransactionCSVDownload: {
    heading: 'CSVダウンロードオプション',
    subTitle: 'CSVをダウンロードするための日付範囲を選択してください',
    label: '日付範囲を選択',
  },
  EntityRiskConfiguration: {
    label: 'Risk Controls for',
    // Risk_ColumnDefs: {
    // Statement: 'ステートメント',
    // Type: 'トリガータイプ',
    // POEntity: 'PO支社',
    // action: 'アクション',
    // enabled: 'ステータス',
    // },
    Confirmation_Dialog: {
      title: '削除',
      heading: '本当によろしいですか？',
      content:
        'このレコードを本当に削除しますか？この操作は元に戻せません。',
    },
    fields: {
      subsidiaryID: 'PO支社',
      statement: 'ステートメント',
      type: 'トリガータイプ',
      // fieldBlackList: 'フィールド',
      // blacklisteditems: '禁止された国リスト',
      // blacklistedbins: '禁止されたBINリスト',
      // blacklistedpan: '禁止されたPANリスト',
      // blacklistedip: '禁止されたIPリスト',
      enabled: 'ステータス',
      errorMessage:
        'ファイルが大きすぎます。許可される最大サイズは次のとおりです $maxSize kb. 現在のファイルには $size kb.',
    },
    form_title: 'ルール設定',
    file_upload: {
      label: 'Prohibited List',
    },
    button: {
      Submit: '送信',
      Cancel: 'キャンセル',
    },
    breadcrumbs: {
      Home: 'ホーム',
      Rules: '企業リスクルール',
    },
    options: {
      Singapore: 'PO Singapore',
      Japan: 'PO Japan',
      Mauritius: 'PO Mauritius',
      Lithuania: 'PO Lithuania',
      Malaysia: 'PO Malaysia',
    },
    TriggerType: 'Blacklist',
    TriggerTypeValues: {
      VELOCITY: "速度",
      BLACKLIST: "ブラックリスト",
      THRESHOLD: "しきい値",
      WHITELIST: "ホワイトリスト",
      REFUND: "返金"
    }
    // BinNumbers: 'Bin Numbers',
    // IP_Address: 'IP Address',
    // IssuingCountry: 'イシュアの国',
    // PAN: 'PAN',
    // Status: {
    //   Enabled: 'Enabled',
    //   Disabled: 'Disabled',
    // },
  },
  PayByLinkConfiguration: {
    'Pay By Link': 'リンク決済',
    'Das Pay By Link': 'リンクでDASPAY',
    PayByLink_ColumnDefs: {
      action: 'アクション',
      link: 'リンクID',
      linkname: "リンク名",
      linknameoptional: "リンク名（任意）",
      generateddate: '生成日',
      amount: '合計金額',
      expirydate: '有効期限',
      reminderdate: 'Reminder Date',
      status: 'ステータス',
    },
    PayByLink_ColumnDefs_Buttons: {
      'View Details': '詳細を見る',
      'View Link': 'リンクを表示',
      'Copy Link': 'リンクをコピー',
    },
    Create_link_button: {
      'Create New Link': '新しいリンクを作成',
    },
    'Pay By Link For': 'の支払いリンク',
    Link_fields: {
      'Set Reminder': 'Set Reminder',
      'Expiry Date': '有効期限',
      'Let customer adjust quantity': 'Let customer adjust quantity',
      'Allow Promocodes': 'Allow Promocodes',
    },
    Pbl_button: {
      'Generate Link': 'リンクを生成',
      'Deactivate Link': 'キャンセル',
    },
    message: {
      'Value is not a number': '入力は数字ではありません',
    },
    Generate_button: {
      copy: 'コピー',
      preview: 'Preview',
    },
    Cart_Details: {
      'Cart Items': 'カートのアイテム',
      'Total': '合計:',
    },
    Message_Update: {
      PayByLINK_Details_Updated: '支払いリンクの内容をアップデートしました',
      Order_Link_Desactivated: '注文リンクが無効化されました',
    },
    Confirmation_Dialog: {
      'LEAVE PAGE': 'ページから離れますか？',
      'Are you sure': 'このページを離れてもよろしいですか？',
      'you want to leave this page': '',
      'content': '変更は保存されません。決済リンクを再度生成してください。',
      'STAY': '残る',
      'EXIT': '退出',
    },
    Confirmation_Delete_Dialog: {
      'Delete': '削除',
      'Are you sure': '本当によろしいですか？',
      'content':
        'このレコードを本当に削除しますか？この操作は元に戻せません。',
      'cancel': 'キャンセル',
      'submit': '送信',
    },
    Confirmation_Deactivate_Dialog: {
      title: 'キャンセル',
      heading: '本当によろしいですか？',
      content:
        'このリンクを無効にしてもよろしいですか?このプロセスは取り消せないです。',
      cancel: 'キャンセル',
      submit: '送信',
    },
    PblDelete_item: {
      delete_item:
        'カートには少なくとも1つのアイテムが追加されている必要があります。',
    },
    file_upload: {
      fileSize:
        'ファイルが大きすぎます。許可される最大サイズは次のとおりです $maxSize kb. 現在のファイルには $size KB.',
      imageType: '画像形式がサポートされていません.',
    },
    PblProduct_ColumnDefs: {
      action: 'アクション',
      photo: '写真',
      products: '商品',
      quantity: '数量',
      price: '単価',
      totalPrice: '合計金額',
    },
    PblProduct_ColumnDefs_Buttons: {
      'Edit Item': '商品を編集',
      'Delete Item': '商品を削除',
    },
    Add_Product_button: {
      'Add New Item': '新しいアイテムを追加',
    },
    Product_fields: {
      productname: '商品名',
      quantity: '数量',
      currency: '通貨を選択',
      price: '単価',
      upload: '写真をアップロード',
      wantToUploadImage: '画像をアップロードしますか',
      Yes: 'はい',
      No: 'いいえ',
      errorMsg: {
        'MaxLimit Message': '最大255文字まで。',
        'Price Min ZeroDecimal': '1 {{currency}} 以上の値を入力してください',
        'Price Max ZeroDecimal': '{{currency}} は 9,999,999 以下の値を入力してください',
        'Price Min': '0.01 以上の値を入力してください',
        'Price Max': '9,999,999.99 以下の値を入力してください',
        'Price Whole Number': '{{currency}} は整数で入力してください',
        'Price Decimal Places': '小数点以下は最大2桁までです。'
      }
    },
    Product_button: {
      'Add To Cart': 'カートに追加',
      'Cancel': 'キャンセル',
    },
    BreadCrumb: {
      Home: 'ホーム',
      paybylink: '支払いリンク',
    },
  },
  CreateThresholdEndAdornment: {
    Payment_Attempts: 'Payment Attempts',
  },
  // CreateTimeFrameAdornment: {
  //   Months: 'Months',
  //   Hours: 'Hours',
  //   Minutes: 'Minutes',
  // },
  PoMidSchema: {
    QR: {
      Merchant_Name: '加盟店名',
      'Merchant Category Code': '加盟店カテゴリーコード',
      'Currency': '通貨',
      'Acquirer MID': 'アクワイアラMID',
      'DAS MID': 'DASMID',
      'Location Name': '場所',
      'Terminal ID': 'ターミナルID',
      'Terminal Name': 'ターミナル名',
      'Merchant Logo URL': '加盟店ロゴURL',
      'Billing Descriptor': '請求名',
      'Scheme Types': 'カードブランド',
      TransactionType: {
        'Transaction Type': '取引タイプ',
        value: {
          '3DSecure': '3Dセキュア',
          'CVV2/CVC2': 'CVV2/CVC2',
          'NonCVV2/CVC2': '未CVV2/CVC2',
          Non3DSecure: '未3Dセキュア',
        },
      },
      Generate_label: 'QRコードを生成する通貨を選択してください',
      button: {
        Download_QR: 'QRをダウンロード',
        Generate_QR: 'QRコードを生成する',
      },
    },
  },
  PoMidSchemaPBL: {
    PBL: {
      Merchant_Name: '加盟店名',
      MCC: '加盟店カテゴリーコード',
      Currency: '通貨',
      Acquirer_MID: 'アクワイアラMID',
      DASMID: 'DASMID',
      Location_name: '場所',
      TerminalID: 'ターミナルID',
      MerchantLogoURL: '加盟店ロゴURL',
      BillingDescriptor: '請求名',
      SchemeTypes: 'カードブランド',
      TransactionType: {
        label: '取引タイプ',
        value: {
          '3DSecure': '3Dセキュア',
          'CVV2/CVC2': 'CVV2/CVC2',
          'NonCVV2/CVC2': '未CVV2/CVC2',
          Non3DSecure: '未3Dセキュア',
          Recurring: '定期支払い',
        },
      },
    },
  },
  PoMidSchemaSCHEDULER: {
    SCHEDULER: {
      Merchant_Name: '加盟店名',
      MCC: '加盟店カテゴリーコード',
      Currency: '通貨',
      Acquirer_MID: 'アクワイアラMID',
      DASMID: 'DASMID',
      Location_name: '場所',
      TerminalID: 'ターミナルID',
      MerchantLogoURL: '加盟店ロゴURL',
      BillingDescriptor: '請求名',
      SchemeTypes: 'カードブランド',
      TransactionType: {
        label: '取引タイプ',
        value: {
          '3DSecure': '3Dセキュア',
          'CVV2/CVC2': 'CVV2/CVC2',
          'NonCVV2/CVC2': '未CVV2/CVC2',
          Non3DSecure: '未3Dセキュア',
          Recurring: '定期支払い',
        },
      },
    },
  },
  PoMidSchemaMOTO: {
    MOTO: {
      Merchant_Name: '加盟店名',
      MCC: '加盟店カテゴリーコード',
      Currency: '通貨',
      Acquirer_MID: 'アクワイアラMID',
      DASMID: 'DASMID',
      Location_name: '場所',
      TerminalID: 'ターミナルID',
      MerchantLogoURL: '加盟店ロゴURL',
      BillingDescriptor: '請求名',
      SchemeTypes: 'カードブランド',
      TransactionType: {
        label: '取引タイプ',
        value: {
          '3DSecure': '3Dセキュア',
          'CVV2/CVC2': 'CVV2/CVC2',
          'NonCVV2/CVC2': '未CVV2/CVC2',
          Non3DSecure: '未3Dセキュア',
          Recurring: '定期支払い',
        },
      },
    },
  },
  AddNewProduct: {
    Tooltip: '戻る',
    Title: 'カートの商品',
  },
  constants: {
    Failure: {
      ACTION_INVALID_USER: 'ユーザー名、またはパスワードが間違っています',
    },
    SUCCESS: {
      ACTION_VOID_AUTHORIZATION: '取引は成功裏に無効になりました。',
      ACTION_CAPTURE: '金額は成功裏に確定されました。',
      ACTION_REFUND: '金額は成功裏に払い戻しされました。',
    },
  },
  validation: {
    Required: '必要',
    MIN_NUMBER_VALUE: '最小入力金額は1でなければなりません',
    CHARGEBACK_MIN_NUMBER_VALUE: '最小の入力額は0より大きくする必要があります',
    MAX_NUMBER_VALUE_JPY: '最大入力金額は9999999でなければなりません',
    MAX_NUMBER_VALUE_OTHER: '最大入力金額は9999999.99でなければなりません',
    TWO_DECIMAL_PLACES: '小数点以下は2桁まで許可されています',
    InvalidStringCharacters: '使用できる文字: 文字、数字、スペース、&.、\'"()-_/\\: – $ @ # *',
    InvalidStringCharactersSQL: '使用できない文字',
    OnlySpacesNotAllowed: 'このフィールドにスペースのみを入力することはできません',
    charMaxLimitMessage: "最大100文字のみ",
    NameMaxLimitMessage: "最大128文字のみ。"
  },
  AG_GRID_LOCALE: {
    Page: 'ページ',
    to: 'まで',
    of: '/',
    more: 'meer',
  },
  NO_RECORD_FOUND: 'レコードが見つかりません',
  NO_ROWS_TO_SHOW: '表示する行はありません',
  ConfirmationDialogRaw: {
    actionButton: {
      title: '承認取消',
      heading: 'よろしいですか?',
      content:
        'この取引を無効にしてもよろしいですか？このプロセスは元に戻せません。',
      Submit: '送信',
      Cancel: 'キャンセル',
    },
    voidButton: {
      title: '承認取消',
      heading: 'よろしいですか?',
      content:
        'この取引を無効にしてもよろしいですか？このプロセスは元に戻せません。',
      Cancel: 'キャンセル',
      Submit: '送信',
    },
    riskRule: {
      title: '削除',
      heading: '本当によろしいですか？',
      content:
        'このレコードを本当に削除しますか？この操作は元に戻せません。',
      submit: '送信',
      cancel: 'キャンセル',
    },
  },
  RiskRule: {
    TabLabel: 'リスク設定',
    tooltipTitle: 'Add New Risk Rule',
    Configure_Rules: 'ルール設定',
    Risk_Control_for: 'Risk Controls for',
    button: {
      Close: 'Close',
    },
    FileType: 'Only CSV file format is supported.',
  },
  FinanceStatements: {
    msg: {
      "EDIT_MSG": "ステートメントを再生成してください"
    },
    breadcrumbs: {
      'Home': 'ホーム',
      'Statements': 'ファイナンス',
      'ClearSelections': '選択をクリア'
    },
    Statement_Transactions: {
      "Statement Transactions": "明細ID",
      "Merchant Account": "加盟店アカウント",
      "Merchant Account (English)": "加盟店アカウント（英語）",
      "DASMID": "DASMID",
      "Statement Date": "明細日",
      "Statement Status": "明細状態",
      "Sync": "同期",
      "Is Whitelisted": "Is Whitelisted",
      "PopupData": {
        "No Whitelist": "Whitelist No",
        "Yes Whitelist": "Whitelist Yes",
        'Are you sure?': 'Are you sure?',
        "Are You Sure you want to disable Whitelist feature": "Do yo really want to mark this transaction as Whitelist No?",
        "Are You Sure you want to enable Whitelist feature": "Do yo really want to mark this transaction as Whitelist Yes?",
        "Approve": "Approve",
        "Close": "Close",
      }
    },
    Statement_ColumnDefs: {
      'STATEMENT_ID': '明細ID',
      'Date': '明細日',
      'TRANSACTION_START_DATE': '取引開始日',
      'TRANSACTION_END_DATE': '取引終了日',
      'DASMID': 'ダスミッド',
      'Payout_Date': '支払日',
      'PaymentType': '付款类别',
      'Acquirer': 'アクワイアラ',
      'amount': '総支払額',
      'Recon_Status': 'リコンサイル状況',
      'STATUS': '明細状態',
      'Wired_Status': '送金状態',
      'action': 'アクション',
      'ROLLING_RESERVE_HELD': 'ローリングリザーブ(%)',
      'ROLLING_RESERVE_HELD_AMOUNT': '保留中のローリングリザーブ',
      'ROLLING_RESERVE_RELEASED': '解放されたローリングリザーブ',
      'CUMULATIVE_RESERVES': '累積リザーブ',
      'TransactionDate': '取引日',
      'OnHoldStatus': 'Statement Release Status',
      'FixedDepositHeldYTDAmount': '保持された定期預金',
      'AdjustmentsAmount': '調整額',
      'NET_SALES': '純売上',
      'TOTAL_FEES': '総手数料',
      'ReleasedDate': 'リリース日',
      'PO_Entity': 'POエンティティ',
    },
    Popper_Buttons: {
      'edit': '編集',
      'view': '見る',
      'download': 'ダウンロード',
      'settle': '清算',
      'generate': '生成する',
      'approve': '承認',
      'download_pdf': 'PDFファイル',
      'regenerate': '再生成',
      'Report': 'レポート',
      "Select To Download": "ダウンロードする項目を選択",
      "Multiple Statements on": "複数の明細書の",
      "Selection limit reached You can download 25 statements only": "選択制限に達しました: ダウンロードできる明細書は 25 件のみです。",
    },
    StatusTypes: {
      'PENDING': '保留中',
      'APPROVED': '承認済み',
      'RECONCILED': '和解済み',
      'DISCREPANCY': '相違',
      'NOT_PAID': '未払い',
      'PAID_OUT': '清算済み-入金済み',
      'CARRY_FORWARD': '繰り越し',
      'CARRYFORWARDUNAPPROVED': 'CF未承認',
      'ACTIVE': '有効',
      'ON_HOLD': '保留',
      'SUBMITTED': '提出済み',
      'COMPLETED': '完了済み',
      'INACTIVE': '無効',
    },
    tabs: {
      'Account': 'リコンサイル（照合）',
      'Merchant': '加盟店明細書',
      'MerchantHeading': '加盟店明細書',
      'Holiday': '公休日',
    },
    EditMerchantStatements: {
      'title': '加盟店明細書の編集',
      Edit_form_Fields: {
        'NET_SALES': '純売上',
        'TOTAL_FEES': '合計額',
        'GROSS': '決済額',
        'ROLLING_RESERVE_HELD': 'ローリングリザーブ(%)',
        'ROLLING_RESERVE_HELD_AMOUNT': '保留中のローリングリザーブ',
        'ROLLING_RESERVE_RELEASED': '解放されたローリングリザーブ',
        'amount': '総支払額',
        'CUMULATIVE_RESERVES': '累積リザーブ',
        'TAX_PLACEHOLDERS': '税プレースホルダー',
        'ADJUSTMENT': '調整',
        'ADJUSTMENT_NOTE': '調整注記',
        'STATUS': 'ステータス',
        'Wired_Status': '送金状態',
        'FixedDepositHeldYTDAmount': '保持された定期預金',
        button: {
          'SAVE': '保存',
          'CANCEL': 'キャンセル',
        },
        helperText: {
          'OptionalMessage': '128文字以内で入力ください',
        },
      },
    },
    ViewMerchantStatements: {
      'title': 'MERCHANT STATEMENT DETAILS',
      Statement_Settlement: {
        'LABEL': 'SETTLEMENT STATEMENT',
        fields: {
          'CLIENT_NAME': 'Client Name',
          'CLIENT_CODE': 'Client Code',
          'STATEMENT_ID': '明細ID',
          'BillingDescriptor': 'Billing Descriptor',
          'Currency': '通貨',
          'STATEMENT_DATE': '明細日',
          'STATEMENT_PERIOD': 'Statement Period',
          'PAYMENT_TRANSFER_DAY': 'Payment Transfer Day',
          'RESERVES': 'RESERVES',
        },
        EditMerchantStatements: {
          'title': '明細を編集する',
          Edit_form_Fields: {
            'NET_SALES': '純売上',
            'TOTAL_FEES': '総手数料',
            'GROSS': '総入金額',
            'ROLLING_RESERVE_HELD': 'ローリングリザーブ(%)',
            'ROLLING_RESERVE_HELD_AMOUNT': '保留中のローリングリザーブ',
            'ROLLING_RESERVE_RELEASED': '解放されたローリングリザーブ',
            'amount': '支払総額',
            'CUMULATIVE_RESERVES': '累積リザーブ',
            'TAX_PLACEHOLDERS': 'TAX PLACEHOLDERS',
            'ADJUSTMENT': '調整',
            'ADJUSTMENT_NOTE': '調整注記',
            'STATUS': 'ステータス',
            'Wired_Status': '送金状態',
            'FixedDepositHeldYTDAmount': '保持された定期預金',
            button: {
              'SAVE': '保存',
              'CANCEL': 'キャンセル',
            },
            helperText: {
              'OptionalMessage': '128文字以内で入力ください',
            },
          },
        },
        SelectLanguagePopup: {
          'title': '言語オプション',
          'heading': 'ファイルのダウンロードに使用する言語を選択してください。',
          message: {
            'settlementFailed': 'Language change is failed..!',
            'settlementSuccess': 'Language is successfully changed..!',
          },
          button: {
            'cancel': 'キャンセル',
            'submit': 'ダウンロード',
          },
        },
        ApprovePopup: {
          'title': '承認',
          'heading': 'ご確認ください。?',
          'content':
            '選択されたすべての明細を承認しますか？このプロセスは元に戻せません。',
          message: {
            'settlementFailed': 'Statement Approval failed..!',
            'settlementSuccess': 'Statement is Approved..!',
          },
          button: {
            'cancel': 'キャンセル',
            'submit': '承認',
          },
        },
        confirmPopup: {
          'title': 'SETTLEMENT',
          'heading': '本当によろしいですか？',
          'content':
            'Are you sure you want to settle all the selected statements? This process can not be undone.',
          message: {
            'settlementFailed': 'Statement setteled failed..!',
            'settlementSuccess': 'Statement is setteled..!',
          },
          button: {
            'cancel': 'キャンセル',
            'submit': '送信',
          },
        },
        DownloadconfirmPopup: {
          'title': 'ダウンロード',
          'heading': '本当によろしいですか？',
          'content':
            'Are you sure you want to download all the selected statements? This process can not be undone.',
          message: {
            'downloadFailed': 'Download failed..!',
            'downloadSuccess': 'Downloaded successfully..!',
          },
          button: {
            'cancel': 'キャンセル',
            'submit': '送信',
          },
        },
      },
    },
    SelectLanguagePopup: {
      title: '言語オプション',
      heading: 'ファイルのダウンロードに使用する言語を選択してください。',
      message: {
        settlementFailed: 'Language change is failed..!',
        settlementSuccess: 'Language is successfully changed..!',
      },
      button: {
        cancel: 'キャンセル',
        submit: 'ダウンロード',
      },
    },
    ApprovePopup: {
      title: '承認',
      heading: 'ご確認ください。?',
      content:
        '選択されたすべての明細を承認しますか？このプロセスは元に戻せません。',
      message: {
        settlementFailed: 'Statement Approval failed..!',
        settlementSuccess: 'Statement is Approved..!',
      },
      button: {
        cancel: 'キャンセル',
        submit: '承認',
      },
    },
    WiredPopup: {
      'content':
        'Are you sure you want to approve the wire status of all selected statements? This process can not be undone.',
    },
    confirmPopup: {
      title: 'SETTLEMENT',
      heading: '本当によろしいですか？',
      content:
        'Are you sure you want to settle all the selected statements? This process can not be undone.',
      message: {
        settlementFailed: 'Statement setteled failed..!',
        settlementSuccess: 'Statement is setteled..!',
      },
      button: {
        cancel: 'キャンセル',
        submit: '送信',
      },
    },
    DownloadconfirmPopup: {
      title: 'ダウンロード',
      heading: '本当によろしいですか？',
      content:
        'Are you sure you want to download all the selected statements? This process can not be undone.',
      message: {
        downloadFailed: 'Download failed..!',
        downloadSuccess: 'Downloaded successfully..!',
      },
      button: {
        cancel: 'キャンセル',
        submit: '送信',
      },
    },
  },
  Holiday: {
    'AddButton': ' 休日/臨時休業の追加',
    'EditButton': '休日・緊急休暇の編集',
    'Public Holiday List': '祝日一覧',
    'InvalidUploadFile': 'Invalid file format. Please use the correct template.',
    'UploadFileLable': 'Upload Holiday List (Excel format)',
    'InvalidUploadTemplate': 'Please use a valid template.',
    'InvalidUploadFileType': 'Please use a valid file format.',
    'UploadBtn': 'Upload',
    'CancelBtn': 'Cancel',
    'Uploading': '処理...',
    'UploadFailed': 'ファイルのアップロードに失敗しました',
    Schema: {
      'Name': '名前',
      'Type': '決済タイプ',
      'Date': '日付',
      'Country': 'PO支社',
      'SendEmailCheckbox': 'メール通知送信',
    },
    ColumnDefs: {
      'HolidayName': 'I休日の名前',
      'Type': '決済タイプ',
      'Month': '日付',
      'Day': '日',
      'Country': 'PO支社',
    },
    type: {
      'PublicHoliday': '公休日',
      'EmergencyOff': '緊急時オフ',
    },
    DeletePopup: {
      'title': '削除',
      'heading': '本当によろしいですか？',
      'content': 'この記録を本当に削除しますか？このプロセスは元に戻せません。',
      button: {
        'cancel': 'キャンセル',
        'submit': '送信',
      },
    },
    Button: {
      'Add': '送信',
      'Cancel': 'キャンセル',
    },
  },
  OnBoarding: {
    VirusScan: {
      'NoVirus': 'スキャン完了',
      'VirusDetectedFileRemoved': 'ウイルススキャンにより感染したファイルが削除されました。ファイル識別子を削除して再アップロードしてください。',
      'VirusDetectedFileRemoved_1': 'ウイルススキャンにより感染したファイルが削除されました。新しいファイルをアップロードしてください。',
      'VirusScanInProg': 'アンチウイルススキャン中',
    },
    welcomeContent: {
      "Welcome": 'Payment Options - DAS GATEWAYへようこそ',
      "details": 'アカウント設定のための詳細情報を入力してください',
      "Business": '事業情報',
      "Business_details":
        'ビジネスを適切にサポートするために、いくつかの情報を入力してください',
      "Stakeholder": 'ステークホルダー情報',
      "Stake_details": 'ご本人確認の手続きのため、情報を入力してください',
      "Payment": '入金情報',
      "Payment_details": '入金の手続きのための銀行情報を入力してください',
      "detail_second": '必要情報の記入は途中からも再開できます',
      "first_description":
        ' 完了する前に、すべての項目が埋められているか確認しましょう。',
      "second_description": '進捗情報はいつでも確認できます',
      "arrow_description_left": '完了していない記入事項',
      "arrow_description_right": 'フォームの完了までの進捗状況',
      Buttons: {
        "Next": '次へ',
        "Start": '今すぐ始めましょう',
      },
    },
    SideNav: {
      "Complete": '登録手順',
      "Your_registration": '',
      "fill_out_required_fields":
        '次のセクションを通じて必要な全ての項目を記入してください',
      "through_the_following_section": '',
      "Sales_Heading": '加盟店登録',
    },
    ChooseAccount: {
      // label: 'アカウントの選択',
      // type: 'どのタイプのアカウントを作成しますか？',
      Merchant_label: {
        "first_title": '私は',
        // second_title: '私は加盟店です',
      },
      Partner_label: {
        "first_title": '私は',
        // second_title: '私はパートナーです',
      },
    },
    BreadCrumbs: {
      "MerchantTitle": '加盟店登録',
      "SalesTitle": '申請が承認されました。',
      "ResellerTitle": 'パートナー登録',
    },
    Prompt_Message: {
      "IfSubmittedTrue": '登録が完了しました。5〜8営業日程度で審査が完了します。',
      "IfSubmittedFalse":
        '登録はまだ完了していません。ここをクリックして、申請書を送信してください。',
      "MissingInfoMessage":
        '不足している情報のリクエストを受け取りました。要求された詳細を提供するためにリンクをクリックしてください。',
      "TCDisagreed_1": '利用規約に同意しなかったため、申請プロセスは',
      "TCDisagreed_2": '日以内に永久に削除されます。',
      "TCDisagreed_3":
        '利用規約に同意しなかったため、申請プロセスは本日中に永久に削除されます。',
      "requiredUBO":
        '最終的な実益所有者（UBO）として、少なくとも1名のステークホルダーをマークしてください',
      "primaryContact": '主要なステークホルダーの詳細を入力してください。',
      "SolePercentage": '割合は、個人事業主のための100％でなければなりません。',
      "SolePercenatgeErrorMsg": '個人事業主の持株比率は100%としてください。',
      "requiredAuthorizedSignatory":
        '少なくとも一名のステークホルダーを承認署名者として設定してください',
      'Please_Click_On-Edit_Primary_Stakeholder':
        '主要利害関係者の詳細を完了するには編集ボタンをクリックしてください',
      Buttons: {
        "ClickHere": 'ここをクリック',
      },
      deletePreviouslyUploadedFile: {
        'title': '更新してください',
        'heading':
          'この選択を変更すると、対応するファイルをアップロードする必要があります。アップロードしたファイルが選択したオプションと一致することを確認してください。',
        'ok': 'OK',
      },
    },
    // OTP_MODAL: {
    // TITLE: 'ワンタイムパスワードを使用してアカウントを確認してください',
    // DESCRIPTION:
    //   'Eメールに記載されている承認コードをご確認の上、以下のボックスにコードを入力してください。',
    // VERIFY: '確認',
    // RESEND_OTP: 'ワンタイムパスワードを再送信',
    'VERIFIED': '認証しました',
    //   DIDNT_RECIEVED: 'コードが届かない場合は？',
    //   OTP: 'OTP',
    // },
    // Password_requirements: {
    //   heading: 'パスワードの要件',
    //   pass_one: '文字を含む必要があります。',
    //   pass_two: '数字を含む必要があります。',
    //   pass_three: '大文字を含む必要があります。',
    //   pass_four: 'そして、特殊文字を含む必要があります。',
    //   pass_five: 'サポートされる特殊文字',
    // },
    ABOUT_BUSSINESS: {
      'About_Business': '事業について',
      'Business_Location': '事業所所在地',
      'Business_Name': '会社名',
      'Name': '氏名',
      'Select_Date': '日付を選択',
      'Doing_Business': '店舗/ブランド名',
      'Unique_Entity_Number': '法人登記番号',
      'Monthly_Revenue': '月間収益',
      'BusinessLicense': '事業運営にライセンスが必要ですか？ (はい/いいえ)',
      'MailingAddress': '送付先住所は異なりますか？ (はい/いいえ)',
      'MainMailingAddress': '住所',
      'Registered_Address': '登録住所',
      'AddressLine1': '住所1行目',
      'AddressLine2': '住所2行目',
      'Postcode': '郵便番号',
      'City': '市区町村',
      'Country': '国',
      'IncorporationDate': '設立日',
      'Company_Type': '会社の種類',
      'Company_Type_Other': '会社の種類（その他）',
      'NEXT': '次へ',
      'UploadDocuments': '登記簿謄本設立証明書',
      'UploadDocuments_Required':
        '会社登記簿謄本または法人設立証明書が必要です。 株主記載事項証明書/ 住所証明書類',
      'UploadDocuments_CertOfIncorp': '法人設立証明書／事業登録証明書',
      'UploadDocuments_CompanyConstitution': '定款（Company Constitution）',
      'Right_Panel_Text':
        '最終ステップで会社登記簿謄本または会社組織を説明する書類のアップロードを求められますので、あらかじめご用意ください。後で登録作業を再開することもできます。',
      'ToolTip_Text': '登記簿謄本の商号を指します。',
      'JP_Business_Name': '加盟店アカウント（英語）',
      'Stock_Code': '株式コード',
      'noOfEmployees': '従業員数',
      'DocumentUpload': 'ファイルをアップロード',
      BusinessTooltips: {
        'Registered_Address': '私書箱は受付不可',
        'This amount represents the fee for each individual transaction': 'この金額は、各取引ごとにかかる手数料です。'
      },
      Business_Name_Messages: {
        'Name': '身分証明書に基づく名前',
      },
      POSTCODE_MESSAGES: {
        'Merchant_Min_Value': '7桁の有効な郵便番号を入力してください',
        'Merchant_Max_Value': '7桁の有効な郵便番号を入力してください',
        'Partner_Min_Value': '少なくとも2桁の有効な郵便番号を入力してください。',
        'Partner_Max_Value': '最大10桁の有効な郵便番号を入力してください。',
      },
      COMPANY_TYPES: {
        'Company': '株式会社',
        'Liability': '合同会社',
        'PrivateLimitedSG': 'プライベート・リミテッド・カンパニー（株式会社）',
        'Partnership': '合名会社',
        'Limited': '合資会社',
        'NonProfit': '特定非営利活動法人',
        'IncorporatedAssociation': '一般社団法人',
        'IncorporatedFoundation': '一般財団法人',
        'Sole': '個人事業主',
      },
      'CorporateWebsite': 'コーポレートウェブサイト/ソーシャルメディア」',
      MU: {
        'CertOfIncorporation': '設立証明書',
        'CompanyConstitution': '会社定款',
        'DirectorsShareholdersUboRegistry': '取締役・株主・実質的所有者登録簿',
        'DirectorsRegistry': '取締役登録簿',
        'ShareholdersRegistry': '株主登録簿',
        'UboRegistry': '実質的所有者登録簿',
        'BusinessLicense': 'グローバルビジネスライセンス',
        'GoodStandingOrIncumbency': '現況証明書または在職証明書',
        'GoodStanding': '現況証明書',
        'Incumbency': '在職証明書',
        'BusinessPlan': '事業計画書',
        'ProofOfBusinessAddress': '営業所住所証明書',
      },
      CORPPASS: {
        'Log_In_With_Singpass': 'Log in with Singpass',
        'Log_In_With': 'Log in with',
        'As_Corppass_User': 'Corppassユーザーとして',
        'Verify_Again': '再確認する',
        'Verified': '確認済み',
        'Connecting_To_Corppass': 'Corppassに接続しています...',
        'Corppass_Init_Failed': 'Myinfo Businessの取得を開始できませんでした。もう一度お試しいただくか、手動で入力してください。',
        'Retry': '再試行',
      },
    },
    SUPPORTED_COUNTRY: {
      'SupportedCountries': 'ビジネス情報',
      'BANNER_SUBTITLE': 'サービス対象外の国（地域）です',
      'FIRST_PARAGRAPH':
        '申し訳ございません。現在、DASGATEWAYのサービス対象外の地域です。',
      'MIDDLE_PARAGRAPH': 'サービス開始次第、いち早くお知らせいたします',
      'SECOND_PARAGRAPH': 'その間、以下の国（地域）が選択可能です',
      'SPEAKTOUS': '私達に話して下さい',
      'LOCATEUS': '世界中どこからでもご相談いただけます：',
      'BUTTON': '登録を継続',
      'Business_Location': 'DASGATEWAYのサービス対象国 (地域)',
    },
    CREATE_ACCOUNT: {
      'LEFT_SUBTITLE': 'アカウントを取得して、新しい決済手段を導入しましょう',
      'RESELLER_SUBTITLE':
        '情報を入力し、リセラーアカウントを作成して手数料収入の受け取りを開始しましょう。',
      // Create_Your: 'ントを作成する',
      // Merchant_Account: 'マーチャントアカウントントを作成する',
      'Last_Step': 'まもなくアカウント作成が完了します！',
      'Set_Password': 'アカウントのパスワードを設定してください。',
      // Complete_all_required_fields: 'すべての必須項目を入力してください',
      // First_Name: '名',
      Middle_Name: 'ミドルネーム',
      // Last_Name: '姓',
      // Phone_Number: '電話番号',
      // Business_Location: '事業所所在地',
      // Email_Address: 'メールアドレス',
      'Verify': '確認',
      'Verified': '認証しました',
      'Create_Password': 'パスワードを作成する',
      'Confirm_Password': 'パスワードの確認',
      'I_agree_with_all': 'に同意します。',
      'terms_&_conditions': '利用規約',
      'privacy_policy': 'プライバシーポリシー',
      'and': 'と',
      'CREATE_ACCOUNT': 'アカウントを作成する',
      'Or_Sign_Up_with_your_social_media_account':
        'Or Sign Up with your social media account',
      // 'already-registered': 'すでにアカウントを持っていますか？',
      // 'signin-account': 'サインイン',
      CreateAccountTooltips: {
        'Name': '名前はローマ字で、身分証明書またはパスポートと一致するように入力してください。',
      },
      ValidationMessages: {
        "Please input your first name": "名を入力してください",
        "Invalid first name": "無効な名前",
        "Please input your last name": "姓を入力してください",
        "Invalid last name": "無効な姓",
        "Please select country Code": "国コードを選択してください",
        "Please input your phone number": "電話番号を入力してください",
        "Invalid phone number": "無効な電話番号",
        "Please input your business location": "ビジネス拠点を入力してください",
        "Please input your email": "メールアドレスを入力してください",
        "Please input your password": "パスワードを入力してください",
        'Please confirm your password!': 'パスワードをご確認ください！',
        'The new password that you entered do not match!': '入力した新しいパスワードが一致しません！',
        "Password is too short - should be 14 characters minimum.": "パスワードが短すぎます - 最低14文字必要です。",
        "Your password cannot be the same as your username or admin": "パスワードはユーザー名または 'admin' と同じではいけません。",
        "Your password must include at least one number, one special character, one uppercase letter, and one lowercase letter.": "パスワードには、少なくとも1つの数字、1つの特殊文字、1つの大文字、1つの小文字を含める必要があります。",
        "You must accept the terms and privacy policy to register your account": "アカウントを登録するには、利用規約とプライバシーポリシーに同意する必要があります"
      }
    },
    PAYMENT_METHODS: {
      'Payment_Methods': '決済方法の選択',
      'Choose_payment_acceptance': '受け入れ支払い方法の選択',
      'Scheme': 'スキーム',
      'SchemeLabel': '決済方法',
      'Cards': 'クレジットカード',
      'Processing_Currency': '処理通貨',
      'Processing_Website': '販売サイト',
      'Processing_Website_required': 'ウェブサイトのフィールドは必須です',
      'Processing_Website_invalid': '無効なウェブサイト',
      Option: {
        '3DSecure': '3D Secure',
        'NON3DSecure': 'NON 3D Secure',
        'Recurring': 'Recurring',
      },
      'TypeOfIntegration': '統合の種類',
      'DescribeTheProducts': '販売する商品・サービス',
      'Countries': '主な取引国',
      countriesOptions: {
        'Japan': '日本',
        'Singapore': 'シンガポール',
      },
      'Average_Transaction_Amount': '平均取引額',
      'Maximum_Transaction_Amount': '最大取引額',
      'Total_Annual_Projection': '年間予想売上',
      'is_Store_Customer_Info': '顧客のクレジットカード情報を保存していますか？',
      'hasTechnologicalArchitecture':
        '貴社の技術アーキテクチャは、クレジットカード決済の安全基準（PCIDSS）に準拠していますか？',
      'is_Process_Card_trans': 'カード決済を行ったことがありますか？',
      'Refund_Rate': '返金率',
      'Average_Refund': '平均返金額',
      'Chargeback_Rate': 'チャージバック率',
      'Average_Chargeback': '平均チャージバック額',
      'HPP': '決済ページ',
      'SERVER_API': 'サーバーツーサーバー接続（API)',
      'PAYMENT_LINK': '支払いリンク',
      'QR_CODE': 'QRコード',
      'SUBSCRIPTION': 'サブスクリプション',
      'isRecurringText':
        '貴社のビジネスは、リカーリングまたはサブスクモデルですか？',
      'DECIMAL_ERROR': '小数点なしの数字を入力してください。',
      'Refund_Rate_MAX_VALIDATOR': '払い戻し率は 100% 以下である必要があります',
      'Refund_Rate_MIN_VALIDATOR':
        '返金率には0.01%を超える値を入力してください。',
      'Chargeback_Rate_MAX_VALIDATOR':
        'チャージバック率は 100% 以下である必要があります',
      'Chargeback_Rate_MIN_VALIDATOR':
        'チャージバック率には0.01%を超える値を入力してください。',
      'Chargeback_Rate_REQUIRED': 'チャージバック率を入力してください。',
      'Refund_Rate_REQUIRED': '返金率を入力してください。',
      'Average_Refund_REQUIRED': '平均返金額を入力してください。',
      'Average_Refund_MIN_VALIDATOR':
        '平均返金額には1より大きい数字を入力してください。',
      'Average_Chargeback_REQUIRED': '平均チャージバック額を入力してください。',
      'Average_Chargeback_MIN_VALIDATOR':
        '平均チャージバック額には1より大きい数字を入力してください。',
      'Average_Transaction_Required': '平均取引額を入力してください。',
      'Maximum_Transaction_Amount_Required': '最大取引額を入力してください。',
      'Total_Annual_Projection_Required': '年間総額（予想）を入力してください。',
      'Average_Transaction_MIN':
        '平均取引額には1より大きい数字を入力してください。',
      'Maximum_Transaction_Amount_MIN':
        '最大取引額には1より大きい数字を入力してください。',
      'Total_Annual_Projection_MIN':
        '年間総額（予想）には1より大きい数字を入力してください。',
      'Days': '日々',
      'ID_Of_The_Individual':
        ' 有効なパスポート/ マイナンバーID/ 運転免許証/ 健康保険証',
      'Proof_Of_Address':
        '銀行口座の情報 / 公共料金の請求書 / 賃貸契約書（過去3ヶ月以内）',
    },
    PAYOUT_DETAILS: {
      'Payout_Details': '決済詳細',
      'Add_New_Payout_Details': '支払い詳細を追加する',
      'Edit_Payout_Details': '支払い詳細の編集',
      'View_Payout_Details': '支払い詳細の表示',
      Account_Number: {
        'label': '口座番号',
        'tooltip':
          '過去3か月以内に発行された銀行取引明細書のコピーをアップロードしてください',
      },
      'Settlement_Currency': '決済通貨',
      'Settlement_Currency_Required': '決済通貨 必要です',
      Bank_Country: {
        'Country_of_Bank': '銀行口座の所在国',
        option: {
          'Japan': '国内銀行口座',
          'Singapore': 'シンガポール',
          'International': '国際銀行口座',
        },
      },
      'Bank_Name': '銀行名',
      'Branch_Code': '支店コード',
      'Bank_Code': '銀行コード',
      'Bank_Account_Name': '銀行口座名',
      'Swift_Code': 'SWIFTコード',
      'How-often_to_paid': {
        'label': '支払い頻度',
        option: {
          'Daily': '毎日',
          'Bi-Weekly': '隔週',
          'Weekly': '毎週1回',
          'Monthly': '毎月',
        },
      },
      'How-often_to_paid_helper_text': '最小入金金額 – JPY 40,000',
      'How-often_to_paid_helper_text_for_hkd': '最小入金金額 – HKD 1,500',
      'Min-settlement-amount': '最小入金金額 – JPY 10,000',
      'UploadDocuments':
        '通帳の表紙・見開き部分のコピー、またはネットバンキングの銀行口座（銀行名・口座番号・口座名義）のスクリーンショット',
      'IBAN': 'IBANコード',
      'UploadDocuments_Message': '銀行取引明細書が必要です。',
      'AccountType': '口座の種類',
      Account_Type: {
        'Normal': '普通',
        'Current': '当座',
        'Savings': '貯蓄',
        'Others': 'その他',
      },
    },
    EXTRA_DOCUMENTS: {
      'heading': '必要情報が欠落しています',
      'Upload_more_documents': 'さらに書類をアップロード',
      'Upload_Documents_heading': '書類/証明書',
      'Upload_Missing_Info': '不足情報をアップロード',
      'Request': 'リクエスト',
      'No_Data_Found': 'データが見つかりません',
      'fileDownloadOptions': '書類ダウンロード',

    },
    ENTITIES: {
      'Entities': '事業体',
      'Payment_Options_Entities': '支払いオプション事業体',
      'Please_Select_Merchant_Entities': "あなたの商人の事業体を選択してください：",
    },
    REGISTRATION_COMPLETED: {
      'REGISTRATION_COMPLETED': '登録完了',
      'FIRST_PARAGRAPH': 'お申し込みいただきまして誠にありがとうございます。審査結果に関しましては、次の5-8営業日以内にメールにてご連絡差し上げます。',
      'SECOND_PARAGRAPH': '何かご不明点やご質問等がございましたら、下記の連絡先までお気軽にご連絡ください。',
      'Shibuya_Office': '渋谷オフィス',
      'Singapore_Office': 'シンガポールオフィス',
      'Address': '所在地 :',
      'Dogenzaka_Address': '東京都渋谷区道玄坂2-23-14　道玄坂225ビル1F/2F',
      'Singapore_Address': '9 Temasek Boulevard, Suntec City Tower 2, #19-02, Singapore 038989',
      'Email': 'メールアドレス:',
      'Opening_Time': '営業時間：',
      'Opening_Days_And_Time': '月曜〜金曜、午前10時より午後7時まで',
      'Explore_As_Test_Mode': '尚、審査中でも当社の決済ゲートウェイのテストモードをご利用いただき、機能をお試しいただけます。',

    },
    REGISTRATION_COMPLETED_RESELLER: {
      'REGISTRATION_COMPLETED': '登録完了',
      'THANK_REGISTRATION_WITH_US': 'ご登録いただきありがとうございます',
      'FIRST_PARAGRAPH':
        '5〜8営業日程度で審査が完了します。本人確認（KYC）の申請にあたり別途確認が必要な場合はご連絡いたします。審査完了までは、ペイメントゲートウェイをテストモードでご利用ください。',
      'MIDDLE_PARAGRAPH': '',
      'LAST_PARAGRAPH': '',
    },
    STAKEHOLDERS_INFO: {
      'About_your_Stakeholders': 'ステークホルダーについて',
      'Add_New_Stakeholders': '新しいステークホルダーを追加',
      'Add_New_Payout': '支払い詳細を追加する',
      columnDefs: {
        'Action': 'アクション',
        'First_Name': '名',
        'Last_Name': '姓',
        'Nationality': '国籍',
        'UBO': '株式保有率%',
        'Auth_Signatory': '承認署名者',
        'KYC_Status': 'シングルステータス',
        'Applicant_Status': '状態',
      },
      'ISAUTHORIZED_YES': 'はい',
      'NA': 'N/A',
    },
    UPLOAD_DOCUMENTS: {
      'VirusScanIssues_text_1': 'ウイルススキャン中です。しばらくお待ちください...',
      'VirusScanIssues_text_2': '感染したファイルを削除して再アップロードしてください。',
      'Upload_Documents': '最終ステップ',
      'Company_Registration_Certificate': '会社登記書類/法人証明書',
      'No_order_doc': '6ヶ月以内に発行された書類をアップロードしてください。',
      'Drop_File_to_Upload': 'ファイルをアップロード',
      'ID': '身分証明書: 有効なパスポート/ マイナンバーカード/ 運転免許証/ 健康保険証',
      'Bank_Statement':
        '3ヶ月以内に発行された銀行預金残高証明書または取引明細書。',
      'Confirmation_Dialog':
        '私が提供するすべての情報が真実であり正確であることを確認します。送信後に登録情報の変更はできません。送信後に登録情報を変更する必要がある場合は、',
      'Support_Team': 'サポートチームまでご連絡ください。',
      button: {
        'SUBMIT': '送信',
      },
      'Identification_Document': '本人確認書類が必要です',
      'TERMS_CONDITION': '利用規約に同意します',
      'Hooray': 'おめでとうございます！最終ステップに到達しました！',
      'Neccessary': '必須項目の入力が完了されていません',
      'Neccessary_text':
        '審査へ進む前に、すべての必須項目が入力されていることを確認してください',
      'TERMS_CONDITION_DESCRIPTION':
        '本申請書を提出することにより、加盟店およびその代表者は、以下の宣言に記載されている通り、PAYMENT OPTIONSに対して保証および表明するものとします。さらに、取引に関する取引伝票をPAYMENT OPTIONSへ送信することは、顧客がサービス利用規約に同意し、承諾したものとみなされます。顧客の代表者が本申請書を提出する場合、または取引伝票や取引の証拠書類を当社へ送信する場合、顧客は、本申請書、利用規約、および運用ガイドで構成される契約書に含まれる条件に同意し、承諾したものとみなされます。顧客は、本申請書、利用規約、運用ガイドおよび適用される全ての法律、規則、規制（該当するカードスキームの規則および規制を含む）を遵守することに同意し、これらに違反した場合、サービスの提供が終了される可能性があることを理解します。本申請書に明確に定義されていない語句は、利用規約において定められた意味を持つものとします。',
      'TERMS_CONDITION_DESCRIPTION_RESELLER':
        '本申請書を提出することにより、第三者およびその代表者は、以下の宣言に記載されている通り、PAYMENT OPTIONSに対して保証および表明するものとします。さらに、取引に関する取引伝票をPAYMENT OPTIONSへ送信することは、顧客がサービス利用規約に同意し、承諾したものとみなされます。顧客の代表者が本申請書を提出する場合、または取引伝票や取引の証拠書類を当社へ送信する場合、顧客は、本申請書、利用規約、および運用ガイドで構成される契約書に含まれる条件に同意し、承諾したものとみなされます。顧客は、本申請書、利用規約、運用ガイドおよび適用される全ての法律、規則、規制（該当するカードスキームの規則および規制を含む）を遵守することに同意し、これらに違反した場合、サービスの提供が終了される可能性があることを理解します。本申請書に明確に定義されていない語句は、利用規約において定められた意味を持つものとします。',
      'Attestation': '宣誓',
      'Attestation_Description':
        '私/私たちは、契約に拘束されることを読み、理解し、同意します。契約（および随時行われる修正）は、Payment Optionsが私/私たちに提供するサービスのリセラーに適用されます。私/私たちは以下を保証します：• この申請書に記載された情報および提供された追加資料におけるサービス提供または私/私たちの事業状況に関連する情報は、真実で正確かつ完全であることを保証します。• 私/私たちは、私/私たちの事業/会社の所有者または代表者であり、リセラープログラムの申請に関連する最終的な決定権限を持っていることを保証します。• 私/私たちは、Payment Optionsが申請を辞退する権利を有し、その理由を一切開示せずに申請を辞退する場合でも、一切の責任を負わないことを認識します。• 私/私たちの事業/会社は[ ]に登録されており、提供するサービスや商品を販売または宣伝するために必要なすべてのライセンスと許可を持っています。第三者の代表者によるこの申請書の提出は、第三者が契約書に含まれる条項および条件を受諾し、同意することを意味します。これには、この申請書、利用規約、および関連資料が含まれます。第三者は、この申請書、利用規約、および関連する法律、規則、規制（カードスキームの規則および規制を含む）を遵守することに同意し、遵守しない場合はサービスの終了が行われる可能性があることを理解しています。この申請書に明示的に定義されていない用語やフレーズは、契約書で定義されている意味と同じ意味を持ちます。私は第三者を代表して、正式な署名者としてこの申請を提出しています。',
      'AGREE_LABEL':
        '「同意する」を選択することにより、上記の条件に同意したものとみなされます。',
      'I_AGREE': '同意する',
      'I_DISAGREE': '同意しない',
      'Merchant-Attestation': '私は、利用規約（および本申請書に関連する運用ガイドおよび付随する資料、以下「契約書」）を読み、理解し、その内容に拘束されることに同意します。契約書（および随時行われる修正）は、私/当社が申し込むサービスおよびPAYMENT OPTIONSが随時提供することに同意するサービスに適用されるものとします。',
      "Merchant_termsData": {
        "TextA": "本申請書およびサービス提供または当社の事業状態に関連して提出する追加資料において提供された情報は、すべての点において真実、正確かつ完全であること。",
        "TextB": "私/当社は、当社の事業/会社の所有者または代表者であり、PAYMENT OPTIONSの加盟店プログラムに申請するにあたり最終決定を行う権限を有すること。",
        "TextC": "PAYMENT OPTIONSが、完全な裁量により、いかなる理由も開示することなく私/当社の申請を拒否する権利を有することを認識していること。",
        "TextD": "私たちのビジネス/会社は",
        "TextDD": "に登録されており、",
        "TextE": "提供されているサービスおよび/または商品を販売またはマーケティングするために必要なすべてのライセンスおよび許可を有しています。",
      },
      "Merchant_ApplicationSubmissitionText": "顧客の代表者が本申請書をPAYMENT OPTIONSに提出する場合、または取引伝票や取引の証拠書類をPAYMENT OPTIONSに送信する場合、それは本申請書、利用規約、運用ガイドおよび関連資料で構成される契約書に含まれる条件に対する顧客の同意および承諾を構成するものとします。顧客は、本申請書、利用規約、運用ガイドおよび該当する全ての法律、規則、規制（カードスキームの規則および規制を含む）を遵守することに同意し、これらに違反した場合、決済サービスの提供が終了される可能性があることを理解します。本申請書において特定されていない語句は、利用規約において定められた意味を持つものとします。",
      "Merchant_behalf": "私は、加盟店のために正当な権限を有する署名者として、この申請を提出します。",
      'Partner-Attestation': '私は、本契約書（および随時行われる修正）が、PAYMENT OPTIONSが私/当社に提供するサービスの再販に適用されることを理解し、同意します。',
      "Partner_termsData": {
        "TextA": "本申請書およびサービス提供または当社の事業状態に関連して提出する追加資料において提供された情報は、すべての点において真実、正確かつ完全であること。",
        "TextB": "私/当社は、当社の事業/会社の所有者または代表者であり、PAYMENT OPTIONSの再販プログラムへの申請に関して最終決定を行う権限を有すること。",
        "TextC": "PAYMENT OPTIONSが、完全な裁量により、いかなる理由も開示することなく私/当社の申請を拒否する権利を有することを認識していること。",
        "TextD": "私たちのビジネス/会社は",
        "TextDD": "に登録されており、",
        "TextE": "提供されているサービスおよび/または商品を販売またはマーケティングするために必要なすべてのライセンスおよび許可を有しています。",
      },
      "Partner_ApplicationSubmissitionText": "第三者の代表者が本申請書をPAYMENT OPTIONSに提出する場合、それは第三者が本申請書、利用規約および関連資料で構成される契約書に含まれる条件に同意し、承諾したものとみなされます。第三者は、本申請書、利用規約、および適用される全ての法律、規則、規制（カードスキームの規則および規制を含む）を遵守することに同意し、これらに違反した場合、サービスの提供が終了される可能性があることを理解します。本申請書において特定されていない語句は、本契約書において定められた意味を持つものとします。",
      "Partner_behalf": "私は、第三者を代表し、正当な権限を有する署名者としてこの申請を提出します。",
      Confirmation_Dialog_Content: {
        'title': '削除する',
        'heading': '本当に削除しますか？',
        'content':
          '本規約に同意されない場合、お客様の申し込みは回復されることなく7日以内に削除される予定です。この期間中であれば、削除をキャンセルし、申し込みデータとユーザーログインを失うことなく、申し込みを完了するために戻ることができます。本当に削除しますか？',
        button: {
          'submit': '送信',
          'cancel': 'キャンセル',
        },
      },
    },
    ADD_NEW_STAKEHOLDER: {
      'Add_New_StakeHolder': '新しいステークホルダーを追加',
      'EDIT_StakeHolder': 'ステークホルダーの編集',
      'Delete_Stakeholder': 'ステークホルダーを削除',
      'Select_Date': '日付を選択',
      'StakeHolder_Info': 'ステークホルダーの表示',
      'First_Name': '名前（名）',
      'Last_Name': '名前（姓）',
      'DOB': '生年月日',
      'Nationality': '国籍',
      'PhoneNumber': '電話番号',
      'ID_Number': '身分証番号',
      'ID_Type': '身分証の種類',
      'Job_Title': '役職',
      'Rigth_to_Sign_Doc': '公認の署名者です',
      'Ultimate_Beneficiary_Owner': 'この人物は最終的な実益所有者です',
      'A_Sole_Proprietor': 'この方は個人事業主です。',
      'Percentage_in_Ownership': '持株比率 ',
      'Percentage_in_Ownership_Validate': '所有率は必須です',
      'Percentage_in_Ownership_NUM': '25〜100までの数字を入力してください。',
      'overallPercentage': '全体の割合は100を超えることはできません。',
      'Country_of_Residence': '居住国',
      'Postcode': '郵便番号',
      'City': '市区町村',
      'Address': '住所',
      'Update_KYC': 'KYCを更新する',
      button: {
        'SUBMIT': '提出する',
        'CANCEL': 'キャンセル',
      },
      'tooltip_title':
        '各ステークホルダーの本人確認書類のコピーをアップロードしてください',
      'Percentage_in_Ownership_MAX_VALIDATOR':
        '出資比率には100%以下の値を入力してください。',
      'Percentage_in_Ownership_MIN_VALIDATOR':
        '出資比率が25%を超えるように入力してください。',
      'CHECKBOX_ERROR':
        '実質的支配者名または署名権限者名、いずれかの入力が必須です。',
      Stakeholder_Tooltips: {
        'Name': '名前（名）',
        'Surname': '姓',
        'Ultimate_Beneficiary_Owner': '会社の投票権/株式の25％以上を持つ自然人',
        'Auth_Signatory':
          ' 会社によって合法的に任命された自然人で、会社を代表して取引を署名および実行するためのもの。',
        'Registered_Address': '私書箱は受付不可',
      },
      'EmptyEmailErrorMsg': 'メールアドレスを入力してください',
      'validEmailErrorMsg': '入力されたものは有効なメールではありません',
      'expiryDate': '有効期限',
      'issuedDate': '発行日',
      IDTYPES: {
        'Passport': 'パスポート ',
        'NationalID': '国民ID',
        'MyNumberCard': 'マイナンバーカード ',
        'DriverLicense': '運転免許証',
        'InsuranceCard': '保険証 ',
        'ResidenceCard': '在留カード ',
      },
      MU: {
        'ProofOfAddress': '住所証明書',
        'Cv': '履歴書',
      },
    },
    RegistrationComplete: {
      'EXPLORE_THE_GATEWAY': '決済ゲートウェイを試す',
    },
    'API_ERROR_MESSAGE': 'もう一度お試しください。',
    'UPLOAD_FILE_SIZE_ERROR': 'ファイルサイズが最大5MBを超えています。',
    'FILE_UPLOAD_TEXT': 'ファイルをアップロード',
    'BROWSE': 'ファイルをブラウズする',
    'IS_REQUIRED': ' 必要です',
    ResellerOnboarding: {
      COMPANY_PROFILE: {
        'Company_Profile': '事業内容',
        'Doing_Business_As_Name': '事業名',
        'Company_Registration_Number': '法人番号',
        'Company_Registration_Number_sole': '法人番号 (該当しない場合はNA)',
        'Country_Company_Incorporated': '登記上の国',
        'Settlement_currency': '決済通貨',
        'Country_Business_Operations': '事業展開をしている国',
        'Country_Payment_Options_Business_Operations':
          'Payment Optionsのサービスを提供する国',
        'Company_Type': '会社の種類',
        'Corporate_Website': 'ウェブサイト',
        'No_Of_Employees': '従業員数',
        'Business_Industry': '事業内容',
        'Type_ThirdParty': 'パートナーの種類',
        'Other_Third_Party': 'その他（第三者タイプ）',
        'Type_ThirdPary': '第三者タイプ',
        'Other_Business_Industry': 'その他（業界）',
        'MailingAddress': '事業運営にライセンスが必要ですか？ (はい/いいえ)',
        'MainMailingAddress': '登記上の住所',
        'doingBusinessDBA': '運営上の住所',
        'RegistrationAddressTooltip': '私書箱は受付不可',
        'BusinessAsDBA':
          '運営上の住所と登記上の住所が異なる場合は、本社の住所と郵便番号をご記入ください。私書箱は不可です。',
        'SameAsRegistration': '登記上の住所と同じ',
        'PostCode': '郵便番号',
        'City': '市区町村',
      },
      STAKEHOLDERS_INFO: {
        'Stakeholders_Info': '関係者情報',
        'BusinessRepresentativeInfo': '代表者情報',
        'BusinessRepresentativeInfoToolTip':
          '業務執行権を有する取締役または契約締結署名者が代表者として登録できます。業務執行権を有する取締役とは、会社の日常業務を管理するために会社によって任命された執行役員や上級管理職など、会社の管理・監督に大きな責任を持つ個人を指します。契約締結署名者は、取締役会の決議、または業務執行権を有する取締役が署名した委任状により、 会社を代表して取引に署名し、執行するよう任命された個人のことです。',
        'controllingPerson': '支配者/事業主/株主/最終受益者情報',
        'controllingPersonTooltip':
          'UBOは上場企業以外の自然人でなければならず、25％以上保有しているUBOを登録してください。25%以上の保有者がいない場合は、上位3名のUBOを入力してください。',
        'Contact_Number': '電話番号',
        'Email_Address': 'メールアドレス',
        'Name': '氏名',
        'Registration_Address_Proof':
          '署名者の署名権限を証明する書類（認可書や承認決議書）',
        'UltimateBeneficialOwner': '最終受益者',
        'IndividualShareholder': '個人株主',
        'CorporateShareholder': '法人株主',
        'AuthorisedRepresentative': '授権代表者',
        'ControllingDirector': '支配役員',
        'Position': '役職',
        columnDefs: {
          'Name': '氏名',
          'Position': '役職',
          'ShareholdingPercent': '持株比率 （%)',
        },
        ADD_NEW_STAKEHOLDER: {
          'Name': '氏名',
          'Ultimate_Beneficiary_Owner':
            ' 実質的支配者（UBO）とは：実質的支配者は「UBO」とも呼ばれており、法人の事業経営を実質的に支配することが可能となる者と定義されています。議決権総数のうち、25%を超える議決権を有するもの、または取締役会の過半数を解任する権利や事業活動時に支配的な絶対の影響力を有すると認められる者*などを指します。（*実質的支配者に誰が該当するかについては、事業形態や資本関係等により異なる.',
          'Individual_Shareholder': '個人株主',
          'Corporate_Shareholder': '法人株主',
          'GovtID':
            '株式保有割合が25%以上の署名者、取締役、支配者、株主、受益者の政府関連機関発行の身分証明書',
          'Registry_Verification':
            '最終的な受益所有権の確認のための株式名簿',
          'Proof_Of_Address':
            '株式保有割合が25%以上の株主と最終受益者の政府関連機関発行の身分証明書に住所の記載がない場合の住所証明　　　- 直近の3ヶ月以内に発行された公共料金の請求書や銀行明細、過去12ヶ月以内に地方自治体または国から発行された各種請求書や給付明細',
        },
      },
      BUSINESS_INFO: {
        'Business_Info': '事業内容',
        'Heading': '顧客のクレジットカード情報を保存しますか？',
        'SubHeading':
          'I御社のシステムはPCIDSS（Payment Card Industry Data Security Standard）に準拠していますか？',
        'Yes': 'はい',
        'No': 'いいえ',
      },
      PAYOUT_SETTLEMENT_INFORMTION: {
        'Payout_Settlement_Information': '支払い/入金情報',
        'Currency': '通貨',
        'HKD': 'HKD',
        'MYR': 'MYR',
        'PHP': 'PHP',
        'THB': 'THB',
        'JPY': 'JPY',
        'BankName': '銀行名',
        'Bank_Identification_Code': '支店コード',
        'Bank_Account_Name': '銀行口座名',
        'Bank_Account_Number': '口座番号',
        'Settlement_Doc_Upload': '決済銀行口座のコピー。',
        'Settlement_Doc_Upload_Msg':
          '銀行口座の書類は、過去3ヶ月以内に発行され、口座名義人の名前、住所、口座番号、日付を含む必要があります。',
      },
      UPLOAD_DOCUMENTS: {
        'Upload_Documents': '最終確認',
        'mailingAddressUploadDocuments':
          '事業/ライセンスのコピー - 運営または事業開始に必要な場合。',
        'certificateOfIncorporation':
          '登記簿謄本、確定申告書の写し等、政府関連機関発行の証明書類',
        'AuthorisedSignatoryName': '署名者名',
        'AuthorisedSignatoryChecked':
          'この申請をサードパーティを代表し、署名者として提出します。',
        'Position': '役職',
        'Signature': '役職',
        'Date': '日付',
        'Browse': 'ファイル検索',
        'NotificationOfCommencement': '1. 個人事業の開業届',
        'ConfirmationOfTaxDeclaration':
          '2. 確定申告の書類 / 青色申告の書類/ 開業届通知',
        'SolePropPDF_first': '税務署 - オフィス開設.pdf',
        'SolePropPDF_Second': '税務署 - 青色申告.pdf',
        'AllFOrmats': 'すべてのファイル形式に対応しています。',
        'Doc_required': '書類が必要です。',
        'BoardResolution': '取締役会決議書／授権書',
        'ProofOfResidentialAddress': '住所証明書',
        'NricPassportDirectors': '取締役、実質的所有者、授権署名者のNRIC/パスポート',
      },
      ENTITIES: {
        'Entities': '事業体',
      },
      ResellerCompanyType: {
        default: {
          'SOLE': '個人事業主/個人トレーダー',
          'PARTNER': 'パートナーシップ',
          'PUBLIC': '有限会社パブリック-リミテッド',
          'PRIVATE': '有限会社プライベート-リミテッド',
          'STOCK': '株式上場',
          'INDIVIDUAL': '個人',
          'OTHER': 'その他',
        },
        JP: {
          'SOLE': '個人事業主',
          'PRIVATE': '株式会社',
          'GODOKAISHA': '合同会社',
          'INDIVIDUAL': '個人',
          'OTHER': 'その他',
        },
        Malaysia: {
          'SOLE': '個人事業主/個人トレーダー',
          'PARTNER': 'パートナーシップ',
          'PUBLIC': 'パブリックリミテッド（BDH）',
          'PRIVATE': 'プライベート-リミテッド(SDN BDH)',
          'INDIVIDUAL': '個人',
          'OTHER': 'その他',
        },
      },
      businessIndustry: {
        'FOOD': '食品-飲料',
        'RETAILGOODS': '小売商品',
        'TRANSPORTATION': '交通',
        'TOBACCO': 'タバコ',
        'FURNITURE': '家具',
        'JEWELLERY': 'ジュエリー',
        'ELECTRONICS': '電子機器',
        'FINANCIALSERVICE': '金融サービス',
        'REALESTATE': '不動産',
        'TRAVEL': '旅行',
        'HOTELS': 'ホテル＆宿泊施設',
        'MEMBORG': '会員組織',
        'MEDIA': 'ソーシャルメディア',
        'DRUGS': '薬、薬局',
        'MARKETING': 'ダイレクトマーケティング',
        'DATING': 'デートとエスコートサービス',
        'GAMBLING': 'ギャンブル',
        'OTHER': 'その他',
      },
    },
    UploadMessage: {
      'size': 'ファイルサイズが2MBの制限を超えています',
      'limit': 'アップロード制限に達しました',
      'helpertext':
        '最大5つのファイルをアップロードできます各ファイルのサイズは2MBに制限されています',
      'helpertext2':
        ' 銀行口座の名前、住所、口座番号、および日付を検証するため。',
      'fileFormat': 'は有効なファイルフォーマットではありません。',
      'SelectDocumentType': '書類の種類を選択してください',
      'SelectDocumentTypeRequired': 'アップロードしたすべてのファイルに書類の種類を選択してください。',
    },
  },
  ActivateAccount: {
    'title': 'アカウントを有効にする',
    'description':
      'マーチャントアカウントが作成されました。アカウントの有効化とパスワードの再設定を行なってください',
    breadcrumb: {
      'Home': 'ホーム',
      'activate': 'アカウントを有効にする',
    },
    buttons: {
      'Activate': 'アカウントを有効にする',
    },
  },
  RiskManagement: {
    CreateRule: '新しいルールを作成',
    NoLevels: 'レベルがありません',
    Schema: {
      tooltip: {
        fieldSelect: 'ルール評価に使用するトランザクション属性を選択してください',
        valueText: '選択したフィールドと比較する値を入力してください',
        valueSelect: '選択したフィールドと比較する値を選択してください',
        levelField: 'ルール評価に使用するレベルを選択してください',
        levelValue: '選択したレベルタイプと比較するレベル値を入力してください',
      }
    }
  },
  DisputeManagement: {
    'Dispute Management': '異議申し立て管理',
    'Status_Heading': 'EDIT CHARGEBACK CASE',
    InformationCards: {
      TOTALDISPUTES: {
        'heading': '紛争件数合計',
      },
      TOTALAMOUNTSGD: {
        'heading': '合計金額',
        'currencySGD': 'SGD',
      },
      TOTALAMOUNTJAPAN: {
        'heading': '合計金額',
        'currencyJPY': 'JPY',
      },
    },
    DrawerType: {
      StatusType: {
        'open': '係争中',
        'progress': '進行中',
        'represented': 'Not Represented',
        'closed': '解決済',
        'expired': '期限切れ',
      },
    },
    DisputeDetailHeading: '異議申し立て詳細',
    CaseDiscussion: {
      'label': 'ケース討論',
      fields: {
        'Message': 'Message',
        'AddFile': 'Add File',
      },
      button: {
        'Submit': '送信',
      },
    },
    ChallangeDispute: '異議申し立て',
    CaseHistory: {
      'label': 'ケース履歴',
      'RetrievalRequest': 'リトリーバルリクエスト',
      'FirstChargeback': '初回チャージバック',
      'SecondChargeback': '第2回チャージバック',
      'InternalDispute': '内部紛争',
      'AutoRepresentment': '自動再代表',
      'ChargebackReversal': 'チャージバック取消',
      'EvidenceUnderReview': '証拠を審査中',
      'Reversal': 'チャージバック取消',
      'LostFund': '紛失資金',
      'CaseClosed': '事件終了',
      'CaseCreated': '作成されたケース',
      'CaseReopened': 'ケースがリニューアルオープンしました',
      'CaseUpdated': 'ケースを更新しました',
    },
    OrignalHistory: {
      'Orignal Transaction History': '取引履歴',
    },
    columnDefs: {
      'Action': 'アクション',
      'ChargebackCaseID': 'ケースID',
      'DASMID': 'DASMID',
      'Merchant': '加盟店アカウント',
      'MerchantInEnglish': '加盟店アカウント（英語）',
      'CaseType': 'ケースタイプ',
      'ReasonID': 'Reason ID',
      'ReasonCategory': '理由の説明',
      'STATUS': 'ステータス',
      'Amount': '異議申し立て金額',
      'Currency': '通貨',
      'IssueDate': '発行日',
      'DueDate': '期限日',
      'UpdatedAt': '更新日',
      'ARN': '決済確認番号',
      'Acquirer': 'アクワイアラ',
      'OrderCode': '注文コード',
      'Fees': '手数料',
      'StatementID': 'Statement ID',
      'Statement_ID': 'ステートメントID'
    },
    DetailInfo: {
      'Case Info': 'ケース情報',
      fields: {
        'Chargeback Case ID': 'ケースID',
        'Merchant': '加盟店アカウント',
        'MerchantInEnglish': '加盟店アカウント（英語）',
        'ARN': '決済確認番号',
        'Auth Code': '承認コード',
        'Case Type': 'ケースタイプ',
        'Date': '発行日',
        'Cycle': 'Cycle',
        'Reason Category': '理由',
        'Card Number': 'カード番号',
        'Amount': '異議申し立て金額',
        'Currency': '通貨',
        'Due Date': '期限日',
        'DASMID': 'DASMID',
        'Acquirer': 'アクワイアラ',
        'STATUS': 'ステータス',
        'Order Code': '注文コード',
        'Time Left': 'Time Left',
        'Fees': '手数料',
        'StatementID': 'ステートメントID'
      },
    },
    BreadCrumb: {
      'Home': 'ホーム',
      'list': '異議申し立て管理',
    },
    DownloadCSV: 'CSVダウンロード',
    SentToAcquirer: 'アクアイアラに送信',
    IssueChargeback: '新規作成',
    DisputeListButtons: {
      'Details': '内容',
      'Complete': 'アクアイアラに送信',
      'Accept': '紛争の受理',
      'Challenge': '係争状況',
      'Evidence': '証拠の提出',
      'Missing Info': '情報が不足しています。',
      'Missing Information': '情報が不足しています',
      'label': '紛争解決に必要な証拠をアップロードしてください。.',
      'Case Close': 'ケースクローズ',
    },
    Status: {
      'CASE STATUS': 'ケースステータス',
      'open': '係争中',
    },
    FilterStatus: {
      'open': '係争中',
      'closed': '解決済',
    },
    AutoLodge: {
      'Title': 'チャージバック案件の自動申立て',
      'Button': '自動申立て',
      'UploadInstruction': 'チャージバック案件の自動申立てファイルをアップロードしてください (Format XLSX)',
      'DragDropText': 'ファイルをここにドラッグ＆ドロップしてください',
      'FormatNote': 'Note: Please ensure your file follows the required template format. Only .xlsx files are accepted. The sheet must be named "Chargeback".',
      'InvalidFileType': '無効なファイル形式です。Excelファイル(.xlsx)をアップロードしてください',
      'FileTooLarge': 'ファイルサイズが5MBを超えています',
      'NoFileSelected': 'ファイルを選択してください',
      'UploadSuccess': 'チャージバック案件が正常にアップロードされました',
      'UploadFailed': 'チャージバック案件のアップロードに失敗しました。再度試してください。',
      'DownloadTemplate': 'テンプレートをダウンロード',
      'TemplateHint': '正しい形式にするためにこのテンプレートを使用してください',
      'TemplateDownloaded': 'テンプレートが正常にダウンロードされました',
      'TemplateDownloadFailed': 'テンプレートのダウンロードに失敗しました',
      'RequiredColumns': '必要な列 (順番に並べてください)',
      'MandatoryNote': '* 列にはアスタリスク(*)とオレンジ色の境界線が付いている列は必須です',
      'Validating': 'ファイルを検証しています...',
      'ValidationSuccess': 'ファイルの検証が正常に完了しました! アップロード準備ができました。',
      'ValidationFailed': '検証に失敗しました。以下のエラーを修正してください。',
      'ValidationError': '検証中にエラーが発生しました',
      'ValidationErrors': '検証エラー',
      'AllRowsValid': 'すべての行が正常に検証されました。アップロード準備ができました。',
      'ValidationErrorsFound': '検証エラーが見つかりました。エラーを修正して再度アップロードしてください。',
      'FixValidationErrors': '検証エラーを修正してからアップロードしてください',
      'MoreErrors': '...および{{count}}個のエラーがあります',
      'Columns': {
        'Case Type': '案件種別',
        'Merchant Account': '加盟店アカウント',
        'Acquirer': 'アクワイアラー',
        'DASMID': 'DASMID',
        'Dispute Amount': '申立金額',
        'Issue Date (SGT)': '発行日 (SGT)',
        'Due Date': '期限日',
        'Card Number': 'カード番号',
        'Transaction Date (SGT)': '取引日 (SGT)',
        'Transaction Amount': '取引金額',
        'Transaction Ref Id': '取引参照ID',
        'Reason Code': '理由コード',
        'ARN': 'ARN',
      },
    },
  },
  MDR: {
    'Add_MDR_Rates': 'ADD MDR RATES',
    'Same_MDR_Rates': 'すべての製品には同じMDRレートが適用されます',
    buttons: {
      'mdrRates': 'MDR料金',
      'submit': '送信',
      'confirm': '確認',
      'cancel': 'キャンセル',
    },
    Confirmation_Dialog: {
      'sub_content':
        'のMDR料金を提出してもよろしいですか？このプロセスは元に戻すことができません。',
    },
  },
  AcceptChargebackDrawer: {
    'Accept_Chargeback': 'ACCEPT CHARGEBACK',
    'Info': 'Accepting chargeback will issue a refund to this transaction and will be deducted from your next payout.',
    fields: {
      'Original_Amount': 'Chargeback Amount',
      'Remaining': 'Refund Amount',
    },
    helperText: {
      'CaptureAmount': 'Value of the number must be greater than 0',
    },
    button: {
      'Submit': 'Accept Chargeback',
      'Cancel': 'キャンセル',
    },
  },
  DeclineChargebackDrawer: {
    'Decline_Chargeback': 'チャージバックを拒否する',
    'Info': 'Kindly provide evidence and upload supporting files to present your case.',
    fields: {
      'Description': 'Description',
      'FileUpload': 'Upload File',
    },
    helperText: {
      'CaptureAmount': 'Value of the number must be greater than 0',
    },
    button: {
      'Submit': 'チャージバックを拒否する',
      'Cancel': 'キャンセル',
    },
  },
  SubmitEvidenceDrawer: {
    'Heading': '証拠の提出',
    fields: {
      'message': 'メッセージ入力',
      'document': 'ファイルの添付',
      'upload': 'Click to Upload',
      'helperText': {
        'OptionalMessage': '最大250文字まで。',
        'OptionalDesMessage': '最大128文字のみ。',
      },
      file_upload: {
        'fileSize':
          'ファイルが大きすぎます。許可される最大サイズは $maxSize MB です。現在のファイルには $size MB があります。',
        'imageType': 'PDFファイル形式のみ対応',
      },
      button: {
        'send': '送信',
        'cancel': 'キャンセル',
      },
    },
    'successMessage': 'チャージバック案件は正常に更新されました。.',
  },
  SearchChargebackTransaction: {
    'Heading': '取引の検索',
    fields: {
      'CardNumber': 'カード番号',
      'Date': ' 取引日',
      'Acquirer': 'アクワイアラ',
      'Amount': '金額',
      'AuthCode': '承認コード',
      'Scheme': 'スキーム'
    },
    helperText: {
      'CaptureAmount': 'Value of the number must be greater than 0',
    },
    button: {
      'Submit': '検索',
      'Cancel': 'キャンセル',
      'Reset': 'リセット',
    },
    'TransactionResult': '取引結果',
    columnDefs: {
      Action: 'アクション',
      TransactionRefID: '取引参照ID',
      V2UUID: 'V2 ID',
      DASMID: 'DASMID',
      Date: '日付',
      Amount: '金額',
      AuthCode: '承認コード',
    },
    'ActionButton': '見る',
    'EditButton': 'リンク',
  },
  IssueChargebackDrawer: {
    'Issue_Chargeback': 'チャージバック/リトリーバル',
    fields: {
      'TransactionRefID': '取引参照ID',
      'ChargebackARN': '決済確認番号',
      'Acquirer': 'アクワイアラ',
      'ChargebackIssuedDays': '発行日',
      'DueDate': '期限日',
      'Amount': '金額',
      'ReasonCategory': '理由の説明',
      'Cycle': 'ケースタイプ',
      'OrderID': '注文ID',
    },
    AcquirerValues: {
      'Worldpay': 'WorldPay',
    },
    helperText: {
      'CaptureAmount': 'Value of the number must be greater than 0',
    },
    button: {
      'Submit': '送信',
      'Cancel': 'キャンセル',
    },
    message: {
      'notification': 'Amount should not be more than original amount.',
    },
    ApprovePopup: {
      'title': '完了',
      'heading': 'ご確認ください。?',
      'content':
        '選択した取引を完了してもよろしいですか？このプロセスは元に戻せません。',
      message: {
        'settlementFailed': 'Dispute completeion failed..!',
        'settlementSuccess': 'Dispute complete is Approved..!',
      },
      button: {
        'cancel': 'キャンセル',
        'submit': '完了',
      },
    },
    AcceptDisputePopup: {
      'title': '異議申し立てを承認する',
      'heading': 'ご確認ください',
      'content':
        '本当にこの異議申し立てを承認しますか このプロセスは取り消すことができません ',
      message: {
        'settlementFailed': 'Accept dispute failed..!',
        'settlementSuccess': 'Accept dispute is Approved..!',
      },
      button: {
        'cancel': 'キャンセル',
        'submit': '承認',
      },
    },
    CaseClosePopup: {
      'title': 'ケースを閉じる',
      'heading': 'ご確認ください。?',
      'content':
        'このケースを閉じてもよろしいですか？このプロセスは元に戻せません。',
      message: {
        'settlementFailed': 'Case close failed..!',
        'settlementSuccess': 'Case close is Approved..!',
      },
      button: {
        'cancel': 'キャンセル',
        'submit': '承認',
      },
    },
    CaseCloseDrawer: {
      'title': 'ケースを閉じる',
      'fields': {
        'reason': '理由',
        'comment': 'コメント',
      },
    },
  },
  CreateCurrencyFrameAdornment: {
    SGD: 'SGD',
    JPY: 'JPY',
    USD: 'USD',
  },
  Footer: {
    button: {
      TERMS_BUTTON: '利用規約',
      PRIVACY_BUTTON: 'プライバシーポリシー',
    },
  },
  'React-Tour': {
    Configuration: {
      Transactions: {
        heading: '取引',
        content:
          '全ての決済を確認きる他、個別の決済に対して返金やキャプチャを行うことができます。',
      },
      Statements: {
        heading: '明細書',
        content:
          '加盟店決済の明細は画面上での確認以外にダウンロードも可能です。',
      },
      Merchants: {
        heading: '加盟店',
        content: '加盟店情報やDASMIDの情報はこちらからご覧いただけます。',
      },
      'dispute-Management': {
        heading: '異議申し立て管理',
        content:
          'チャージバック案件が発生した場合、通知ベルが表示されますので、アイコンをクリックして詳細を確認できます。',
      },
      Filter: {
        heading: '検索フィルター',
        content:
          '高度なフィルターを使用して、定義済みの基準で検索結果のリストをフィルター処理します。',
      },
      language: {
        heading: '言語の設定',
        content: 'GATEWAYで使用する言語を選択できます。',
      },
      user: {
        heading: 'ユーザー情報',
        content: 'ユーザー設定の確認やサインアウトはこちら。',
      },
      Buttons: {
        LetsGo: '行こう',
      },
    },
    ResellerConfiguration: {
      SalesLead: {
        heading: 'セールスリード',
        content:
          'あなたの紹介コードを使用して提出された加盟店の申請は、ここに承認のためにリストされています。これらの申請を拒否または承認することができます。',
      },
      Partner: {
        heading: 'パートナー',
        content:
          'パートナーアカウントプロファイルにアクセスして、紹介の詳細を表示します。ゲートウェイに接続を希望する見込みのある加盟店に紹介リンクを送ることができます。',
      },
      Filter: {
        heading: '検索フィルター',
        content:
          '高度なフィルターを使用して、定義済みの基準で検索結果のリストをフィルター処理します。',
      },
      language: {
        heading: '言語の設定',
        content: 'GATEWAYで使用する言語を選択できます。',
      },
      user: {
        heading: 'ユーザー情報',
        content: 'ユーザー設定の確認やサインアウトはこちら。',
      },
      Buttons: {
        LetsGo: '行こう',
      },
    },
  },
  ContactUs: {
    BreadCrumb: {
      'Home': 'ホーム',
      'Help & Support': 'ヘルプ＆サポート',
    },
    tabs: {
      Contact: 'お問い合わせ',
    },
    SupportForm: {
      'Send us your request': 'お問い合わせ内容',
      fields: {
        'Subject': '件名',
        'Ticket Type': 'カテゴリー',
        values: {
          'Technical Issue': 'テクニカルトラブル',
          'sales': 'ビジネス・営業',
          'Change Request': '変更依頼',
          'others': 'その他',
        },
        Product: '商品',
        Description: 'お問い合わせの詳細',
        Document: 'ファイル添付',
        helperText: {
          'Optional Message': '500文字以内で入力ください',
        },
        file_upload: {
          'file Size':
            'ファイルが大きすぎます。許可される最大サイズは次のとおりです $maxSize MB. 現在のファイルには $size MB.',
          'image Type': 'ファイル形式はサポートされていません。',
        },
      },
      buttons: {
        'Send Request': '送信',
        'Cancel': 'キャンセル',
        'Reset': 'リセット',
      },
    },
    Documentation: {
      'Documentation': 'ドキュメント',
      'Latest': '最新',
      'Archieved': 'アーカイブ済み',
      Links: {
        'API Integration Manual': 'APIインテグレーションマニュアル ',
        'User Guide Manual': 'ユーザーガイドマニュアル- ',
        'Release Notes': 'リリースノート/変更ログ',
      },
    },
  },
  SalesLead: {
    'Heading': '加盟店登録',
    'PartnerHeading': 'パートナー登録',
    'Status': 'アクション:',
    'RegisterationNumber': '申請参照ID:',
    BreadCrumb: {
      'Home': 'ホーム',
      'Application': '加盟店手続き',
      'PartnerApplication': 'パートナーのオンボーディング',
    },
    AccountsTab: {
      'MerchantAccount': '加盟店申請',
      'PartnerAccount': 'パートナー申請',
      'ComingSoon': 'Coming Soon',
    },
    columnDefs: {
      'Action': 'アクション',
      'RegisterationNumber': '申請参照ID',
      'ApplicationDate': '申請日',
      'CustomerLegalName': '加盟店アカウント',
      'BusinessLocation': '事業所所在地',
      'Email': 'メールアドレス',
      'RegistrationType': '登録タイプ',
      'Status': 'ステータス',
      'Products': '製品',
      'MerchantAccount': '加盟店アカウント',
      'PartnerName': 'パートナー名',
    },
    StatusType: {
      'PENDING': '保留中',
      'APPROVED': '承認済み',
      'REJECTED': '却下',
      'NOTSUPPORTEDCOUNTRY': '未対応国',
      'APPROVALINPROGRESS': '承認中',
      'INPROGRESS': '進行中',
      'PENDINGFORDELETION': '削除申請中',
      'INPROGRESS_REG_NOT_COMPLETED': 'NOT SUBMITTED'
    },
    OnBoarding_Content: {
      'APPROVE': '承認',
      'REJECT': '拒否',
      'ADD': '価格を設定する',
      'VIEW': '価格を見る',
    },
    RegisterationType: {
      'REFERRAL': '紹介',
      'SELF': '自身',
    },
    PricingContent: {
      'heading': '新しい価格を設定する',
      'PricingHeading': '価格詳細',
      FormFields: {
        'MCC': '加盟店カテゴリーコード',
        'MDR_CARD': 'ブレンド手数料割引率',
        'SETUP_FEE': 'セットアップ料金',
        'SUPPORT_FEE_FREQUENCY': 'メンテナンス・サポート料金 頻度',
        ANNUAL_FEE: {
          'MONTHLY': '毎月',
          'ANNUAL': '毎年',
        },
        'ANNUAL_MONTHLY_FEE': '年会費/月会費',
        'TRANSACTION_FEE': '取引手数料',
        'REFUND_PROCESSING_FEE': '返金手数料',
        'CHARGEBACK_PROCESSING_FEE': 'チャージバック手数料',
        'DECLINE_FEE': '取引拒否手数料',
        'RETRIEVAL_REQUEST_FEE': 'リトリーバルリクエスト手数料',
        'PRE_ARBITRATION_FEE': '仲裁手数料',
        'REPRESENTMENT_FEE': '代理手数料',
        'FRAUD_MONITORING_FEE': '不正検知手数料',
        'StandardMDRRate': '標準MDRレート',
        'MicroMDRRate': 'マイクロMDRレート',
        Buttons: {
          'Submit': '送信',
          'Cancel': 'キャンセル',
        },
      },
    },
    SubmitPricing: {
      title: '価格設定の送信',
      heading: '価格が設定されていません。',
      content:
        '送信する前に、決済方法タブで選択した商品の価格を設定してください。',
      ok: 'OK',
      goToPaymentMethods: "決済方法へ"
    },
    ApprovePopup: {
      title: '承認',
      heading: '本当によろしいですか？',
      content:
        'あなたは、アプリケーションを承認したいと思いますか？ このプロセスは元に戻すことはできません。',
      message: {
        settlementFailed: 'Application Approval failed..!',
        settlementSuccess: 'Application is Approved..!',
      },
      button: {
        cancel: 'キャンセル',
        submit: '承認',
      },
    },
    RejectPopup: {
      title: '拒否',
      heading: '本当によろしいですか？',
      content:
        'あなたは、アプリケーションを拒否してもよろしいですか？ このプロセスは元に戻すことはできません。',
      message: {
        settlementFailed: 'Application rejection failed..!',
        settlementSuccess: 'Application is Rejected..!',
      },
      button: {
        cancel: 'キャンセル',
        submit: '拒否',
      },
    },
    warningMessage:
      '一部の価格が設定されていません。',
  },
  languagecode: 'ja',
  "API_STATUS_MESSAGE": {
    "INFO0000": "成功しました。",
    "INFO0001": "金額が正常にキャプチャされました。",
    "INFO0002": "金額が正常に返金されました。",
    "INFO0003": "承認が正常にキャンセルされました。",
    "INFO0004": "取引のステータスが正常に更新されました。",
    "INFO0005": "全てのチャージバックチケットの詳細を見る。",
    "INFO0006": "一つのチャージバックチケットの詳細を見る。",
    "INFO0007": "ステータスが正常に更新されました。",
    "INFO0008": "申請は既に提出されています。",
    "INFO0009": "下書きとして保存されました。",
    "INFO0010": "申請が正常に提出されました。",
    "INFO0011": "ドキュメントがダウンロードされました。",
    "INFO0012": "申請の詳細。",
    "INFO1001": "トークンが更新されました。",
    "INFO1002": "パスワードが正常にリセットされました。",
    "INFO3000": "サブスクリプションが更新されました。",
    "INFO20000": "成功しました。",
    "INFO3001": "取引を処理中です",
    "INFO3002": "取引が失敗しました。もう一度お試しください。",
    "INFO3003": "取引が完了しました。",
    "INFO4000": "プリセットフィルターが正常に追加されました。",
    "INFO4001": "プリセットフィルターが正常に更新されました。",
    "INFO4002": "プリセットフィルターが正常に削除されました。",
    "INFO4003": "プリセットフィルターを正常に取得しました。",
    "INFO4004": "プリセットフィルターを正常に取得しました。",
    "INFO4010": "レポート設定が正常に追加されました。",
    "INFO4011": "レポート設定が正常に更新されました。",
    "INFO4012": "レポート設定が正常に削除されました。",
    "INFO4013": "レポート設定一覧を正常に取得しました。",
    "INFO4014": "レポート設定を正常に取得しました。",
    "INFO4020": "トランザクションのダウンロードスケジュールが正常に追加されました。",
    "INFO4021": "トランザクションのダウンロードスケジュールが正常に更新されました。",
    "INFO4022": "トランザクションのダウンロードスケジュールが正常に削除されました。",
    "INFO4023": "トランザクションのダウンロードスケジュール一覧を正常に取得しました。",
    "INFO4024": "トランザクションのダウンロードスケジュールを正常に取得しました。",
    "INFO4030": "取引カラム設定が正常に追加されました。",
    "INFO4031": "取引カラム設定が正常に更新されました。",
    "INFO4032": "取引カラム設定が正常に削除されました。",
    "INFO4033": "取引カラム設定一覧を正常に取得しました。",
    "INFO4034": "取引カラム設定を正常に取得しました。",
    "INFO_FS_O0050": "明細設定が正常に追加されました。",
    "INFO_FS_O0051": "明細設定が正常に更新されました。",
    "INFO_FS_O0052": "明細設定が正常に削除されました。",
    "INFO_FS_O0053": "明細設定一覧を正常に取得しました。",
    "INFO_FS_O0054": "明細設定を正常に取得しました。",
    "INFO_FS_O0056": "異議申し立て設定が正常に追加されました。",
    "INFO_FS_O0057": "異議申し立て設定が正常に更新されました。",
    "INFO_FS_O0058": "異議申し立て設定が正常に削除されました。",
    "INFO_FS_O0059": "異議申し立て設定の取得に成功しました。",
    "INFO_FS_O0060": "異議申し立て設定の取得に成功しました。",
    "INFO_AB_0000": "成功しました。",
    "INFO_AB_0001": "OTPがメールに送信されました。",
    "INFO_AB_0002": "OTPが確認されました。",
    "INFO_AB_0003": "OTPがメールに再送されました。",
    "INFO_AB_0004": "アカウントが作成されました。登録を完了するには、引き続き必要事項をご入力ください。",
    "INFO_AB_0005": "OTPが確認されました。",
    "INFO_AB_0006": "アカウントが作成されました。ログインに技術的な問題が発生しております。ログインして登録を完了してください。",
    "INFO_AB_0007": "申請の詳細が見つかりません。",
    "INFO_AB_0008": "申請は既に提出されています。",
    "INFO_AB_0009": "削除済み",
    "INFO_AB_0010": "申請が正常に提出されました。",
    "INFO_AB_0011": "ドキュメントがダウンロードされました。",
    "INFO_AB_0012": "申請の詳細。",
    "INFO_AB_0013": "削除されました。",
    "INFO_AB_0014": "申請が承認されました。",
    "INFO_AB_0015": "申請が拒否されました。",
    "INFO_AB_0016": "アプリケーションは(x)日後に削除されます。",
    "INFO_AB_0017": "申請の提出が進行中です。しばらくしてから申請を更新してください。",
    "INFO_AB_0018": "価格が正常に入力されました。",
    "INFO_AB_0026": "Myinfo Business の取得を開始しました。",
    "INFO_AB_0027": "Myinfo Business の取得状況。",
    "INFO_AB_0028": "Singpass 認証を開始しました。",
    "INFO_AB_0029": "Singpass 認証の状況。",
    "INFO_AB_0030": "Singpass 認証リンクを送信しました。",
    "INFO_AB_0031": "Singpass 認証の招待。",
    "INFO_AB_0032": "Singpass 認証のコールバック処理が完了しました。",
    "INFO_AB_0033": "法人確認のコールバック処理が完了しました。",
    "INFO_ACQ_0000": "完了",
    "INFO_ACQ_0001": "アクワイアラ加盟店IDが作成されました。",
    "INFO_ACQ_0002": "アクワイアラ加盟店IDが更新されました。",
    "INFO_ACQ_0003": "アクワイアラが作成されました。",
    "INFO_ACQ_0004": "アクワイアラの詳細。",
    "INFO_ACQ_0005": "アクワイアラリスト",
    "INFO_ACQ_0006": "アクワイアラが更新されました。",
    "INFO_AUTH_0000": "成功しました。",
    "INFO_AUTH_0001": "トークンが更新されました。",
    "INFO_AUTH_0002": "パスワードが正常にリセットされました。",
    "INFO_AUTH_0003": "OTPがメールアドレス宛に再送されました。",
    "INFO_AUTH_0005": "OTP があなたのメールアドレスに送信されました",
    "INFO_CONFIG_0000": "成功しました。",
    "INFO_CONFIG_0001": "作成されました。",
    "INFO_CONFIG_0002": "更新されました。",
    "INFO_CONFIG_0003": "削除されました。",
    "INFO_FS_O0000": "ファイルのアップロードに成功しました。新しいレコードを処理中で、まもなく表示されます。",
    "INFO_FS_O0001": "明細書の更新が成功しました。",
    "INFO_FS_O0002": "明細書リスト",
    "INFO_FS_O0003": "OTPがメールアドレス宛に再送されました。",
    "INFO_FS_O0004": "チャージバックチケットが正常に作成されました。",
    "INFO_FS_O0005": "全てのチャージバックチケットの詳細を見る",
    "INFO_FS_O0006": "一つのチャージバックチケットの詳細を見る",
    "INFO_FS_O0007": "ステータスが正常に更新されました。",
    "INFO_FS_O0008": "チャージバック記録のINFO_FS_oを見る。",
    "INFO_FS_O0009": "チャージバックケースが正常に更新されました。",
    "INFO_FS_O0010": "チャージバックメッセージの詳細を見る。",
    "INFO_FS_O0011": "チャージバック履歴の詳細を見る。",
    "INFO_FS_O0012": "ファイルが正常にアップロードされました。",
    "INFO_FS_O0013": "同じ注文コードの未処理のケースを閉じてください。",
    "INFO_FS_O0014": "ファイルが正常にダウンロードされました。",
    "INFO_FS_O0015": "重複するARNが見つかりました。もう一度試してください。",
    "INFO_FS_O0016": "ファースト・チャージバックはセカンド・チャージバックの前に発行されるべきです。",
    "INFO_FS_O0017": "有効なDASMIDを入力してください。",
    "INFO_FS_O0018": "有効なケースIDを入力してください。",
    "INFO_FS_O0019": "有効なステータスを入力してください。",
    "INFO_FS_O0020": "ホリデーリストの詳細",
    "INFO_FS_O0021": "ホリデーリストの詳細が正常に生成されました。",
    "INFO_FS_O0022": "明細書が正常に再生成されました。",
    "INFO_FS_O0023": "ホリデーリストのメールが正常に送信されました。",
    "INFO_FS_O0025": "AutoRepresentment チャージバックを作成してください",
    "INFO_FS_O0026": "ダウンロードリクエストが開始されました",
    "INFO_FS_O0028": "すべての明細取引の詳細",
    "INFO_FS_O0029": "取引同期",
    "INFO_FS_O0031": "ハッシュカードが更新されました",
    "INFO_FS_O0034": "ハッシュカードが正常に追加されました",
    "INFO_FS_O1000": "ダウンロードが正常に開始されました",
    "INFO_MS_0000": "成功しました。",
    "INFO_MS_0001": "明細書の更新が成功しました。",
    "INFO_MS_0002": "明細書リスト",
    "INFO_MS_0003": "OTPがメールアドレス宛に再送されました。",
    "INFO_MS_0004": "ステータスが正常に更新されました。",
    "INFO_MS_0005": "お問い合わせいただきありがとうございます。",
    "INFO_MS_0006": "サポートのための製品詳細を見る。",
    "INFO_MS_0007": "有効な製品タイプを選択してください。",
    "INFO_MS_0008": "与えられたDASMID／加盟店IDに対する製品が見つかりません。",
    "INFO_MS_0009": "加盟店の特定のDASMIDのステータスが更新されました。",
    "INFO_MS_0010": "定期購入プランが正常に取得されました。",
    "INFO_MS_0011": "プランの詳細が正常に取得されました。",
    "INFO_MS_0012": "有効なプランIDを入力してください。",
    "INFO_MS_0013": "プランが正常に作成されました。",
    "INFO_MS_0014": "プランが正常に更新されました。",
    "INFO_MS_0015": "サブスクリプションの詳細",
    "INFO_MS_0016": "サブスクリプションが正常に編集されました。",
    "INFO_MS_0017": "有効なサブスクリプションIDを入力してください。",
    "INFO_MS_0018": "サブスクリプションはすでに存在します。",
    "INFO_MS_0019": "サブスクリプションが正常にキャンセルされました。",
    "INFO_MS_0020": "サブスクリプションが見つかりません。",
    "INFO_MS_0021": "サブスクリプションプランはすでに存在します。",
    "INFO_MS_0022": "契約者の詳細。",
    "INFO_MS_0023": "契約者が見つかりません。",
    "INFO_MS_0024": "契約者のメールアドレスはすでに存在します。",
    "INFO_MS_0025": "契約者が正常に作成されました。",
    "INFO_MS_0026": "契約者の詳細を見る。",
    "INFO_MS_0027": "利用可能なサブスクリプションのプランを更新することはできません。",
    "INFO_MS_0028": "加盟店と加盟店設定の詳細を見る。",
    "INFO_MS_0029": "サブスクリプションは編集できません。",
    "INFO_MS_0030": "有効なDASMIDを入力してください。",
    "INFO_MS_0031": "利用可能なサブスクリプションのプランを削除することはできません。",
    "INFO_MS_0032": "プランが正常に削除されました。",
    "INFO_MS_0033": "メールが正常に送信されました",
    "INFO_MS_0034": "現在契約中のようです。",
    "INFO_MS_0035": "契約者が正常に削除されました。",
    "INFO_MS_0036": "サブスクリプションプランが見つかりません。",
    "INFO_MS_0037": "ユーザーが正常に作成されました。",
    "INFO_MS_0038": "全てのユーザーの詳細",
    "INFO_MS_0039": "ユーザーの詳細",
    "INFO_MS_0040": "ユーザーが見つかりません。",
    "INFO_MS_0041": "ユーザーはすでに存在しています。",
    "INFO_MS_0042": "ユーザーが正常に削除されました。",
    "INFO_MS_0043": "ユーザーが正常に有効／無効化されました。",
    "INFO_MS_0044": "ユーザーが正常に更新されました。",
    "INFO_MS_0045": "契約者の詳細が更新されました。",
    "INFO_MS_0046": "契約者の詳細が更新されました。",
    "INFO_MS_0047": "作成されました。",
    "INFO_MS_0048": "更新されました。",
    "INFO_MS_0049": "削除されました。",
    "INFO_MS_0050": "製品の詳細",
    "INFO_MS_0051": "パスワードのリセットが正常に完了しました",
    "INFO_MS_0052": "アカウントを切り替えるには、ログアウトしてログインしてください",
    "INFO_MS_0055": "カテゴリが正常に作成されました",
    "INFO_MS_0056": "カテゴリが正常に更新されました",
    "INFO_MS_0057": "カテゴリが正常に削除されました",
    "INFO_MS_0059": "製品が正常に作成されました",
    "INFO_MS_0060": "製品が正常に更新されました",
    "INFO_MS_0061": "製品が正常に削除されました",
    "INFO_MS_0063": "Webhookが正常に作成されました",
    "INFO_MS_0064": "Webhookが正常に更新されました",
    "INFO_MS_0065": "Webhookリスト",
    "INFO_MS_0066": "加盟店IPリスト",
    "INFO_MS_0067": "加盟店IPが正常に作成されました",
    "INFO_MS_0068": "加盟店IPが正常に更新されました",
    "INFO_MS_0069": "加盟店IPが正常に削除されました",
    "INFO_MS_0070": "加盟店のIPデータ",
    "INFO_MS_0072": "マーチャントのキーペアステータス",
    "INFO_PBL_0000": "成功しました。",
    "INFO_PBL_0001": "リンク経由で支払うための新しい注文が作成されました。",
    "INFO_PBL_0002": "リンクでの支払いが更新されました",
    "INFO_PBL_0003": "作成されました。",
    "INFO_PBL_0004": "削除されました。",
    "INFO_PBL_0005": "注文リンクが無効化されました。",
    "INFO_PBL_0006": "画像がアップロードされました。",
    "INFO_DX_0000": "成功しました。",
    "ERR0000": "アクセスが拒否されました。",
    "ERR0001": "もう一度お試しください。",
    "ERR0002": "もう一度試してください。",
    "ERR0003": "接続が確立されていません...！もう一度試してください。",
    "ERR0004": "OTPが期限切れです。",
    "ERR0005": "再試行回数を超えました。OTPを再生成してください。",
    "ERR0006": "無効なOTPです。",
    "ERR0007": "最大再試行回数を超えました。サポートに連絡してください。",
    "ERR0008": "メールアドレスが認証されていません。",
    "ERR0009": "Payment Optionsのメール識別子が見つかりました。",
    "ERR0010": "アプリケーションが処理されていません。",
    "ERR0011": "アップロードに失敗しました。",
    "ERR0012": "ダウンロードに失敗しました。",
    "ERR0013": "ファイルを削除できません。",
    "ERR0014": "アプリケーションの詳細の取得に失敗しました。",
    "ERR0015": "アプリケーションの詳細が見つかりません。",
    "ERR0016": "対応していない国です。",
    "ERR0017": "無効なユーザーIDです。",
    "ERR0018": "無効なユーザーIDです。",
    "ERR0019": "データが見つかりません。",
    "ERR0020": "詳細の取得に失敗しました。",
    "ERR0024": "ユーザーは存在しません。",
    "ERR0025": "非アクティブなユーザーのパスワードをリセットすることはできません。",
    "ERR0030": "This email address has already been added.",
    "ERR0100": "許可された限度を超える金額です。",
    "ERR0101": "無効なカードです。",
    "ERR0102": "カードの有効期限が切れています。",
    "ERR0103": "カードはサポートされていません。",
    "ERR0104": "セキュリティ違反です。",
    "ERR0105": "定期的な承認は許可されていません。",
    "ERR0106": "支払い情報が無効です。",
    "ERR0107": "FraudWallが取引をブロックしました。",
    "ERR0108": "支払いリクエストにサブスクリプションの詳細がありません。",
    "ERR0109": "無効なサブスクリプションIDです。",
    "ERR0110": "dfReferenceIdがありません。",
    "ERR0201": "キャプチャのための有効な金額を入力してください。",
    "ERR0202": "キャプチャのための十分な金額がありません。",
    "ERR0203": "値は小数点以下にしてはいけません。",
    "ERR0204": "払い戻しのための残高がありません。",
    "ERR0205": "無効なトランザクションIDです。",
    "ERR0206": "取引のステータスは現在のステータスと同じに更新することはできません。",
    "ERR0207": "キャプチャに有効な取引ではありません。",
    "ERR0208": "無効なDASMIDです。",
    "ERR0213": "払い戻しの許容量制限を超えました。さらにサポートが必要な場合は、サポート チームにお問い合わせください。",
    "ERR0214": "この名前のプリセットフィルタは、このユーザーのために既に存在します。",
    "ERR0222": "トランザクションダウンロードスケジュールの最大数に達しました",
    "ERR1000": "APIは実装されていません。",
    "ERR1001": "ユーザー名またはパスワードが正しくありません。",
    "ERR1002": "無効なユーザーセッションです。",
    "ERR1003": "リフレッシュトークンが期限切れ、またはユーザーがアプリケーションからサインアウトしました。",
    "ERR1004": "Payment Optionsのメール。サポートに連絡してください。",
    "ERR1005": "ユーザーは当社に登録されていません。",
    "ERR1006": "入力されたOTPは無効です。",
    "ERR1007": "無効なコードが入力されました。もう一度コードをリクエストしてください。",
    "ERR1008": "試行回数の制限を超えました。しばらくしてからもう一度お試しください。",
    "ERR1009": "無効なリクエストです。",
    "ERR1010": "ユーザーは無効です。サポートチームに連絡してください。",
    "ERR10000": "無効なURLです。",
    "ERR10001": "無効な金額です。",
    "ERR10002": "無効なサブスクリプションまたはサブスクリプションの詳細がありません。",
    "ERR10003": "リンク上の詳細が見つかりません。",
    "ERR3000": "サブスクリプションDASMIDが無効です。",
    "ERR3001": "無効なトランザクションIDです。",
    "ERR3002": "一時停止を許可されているのはアクティブなサブスクリプションのみです。",
    "ERR3003": "サブスクリプションのキャンセルに失敗しました。",
    "ERR3004": "サブスクリプションを再開できません。",
    "ERR3019": "払い戻し残高が不足しています",
    "ERR3020": "払い戻し残高が不足しています",
    "ERR0211": "払い戻しはできません。",
    "ERR0223": "この名前の取引カラム設定は既にこのユーザーに存在します",
    "ERR0224": "この取引カラム設定を管理する権限がありません",
    "ERR0225": "指定されたUUIDの取引カラム設定が見つかりません",
    "ERR_FS_O0020": "この名前の明細設定はすでにこのユーザーに存在します。",
    "ERR_FS_O0021": "この明細設定を管理する権限がありません。",
    "ERR_FS_O0022": "指定されたUUIDの明細設定が見つかりません。",
    "ERR_FS_O0025": "このユーザーには同じ名前の異議申し立て設定が既に存在します。",
    "ERR_FS_O0026": "この異議申し立て設定を管理する権限がありません。",
    "ERR_FS_O0027": "指定されたUUIDの異議申し立て設定が見つかりません。",
    "ERR_ACQ_0001": "アクワイアラ名を入力してください。",
    "ERR_ACQ_0002": "アクワイアラは既に存在します。",
    "ERR_ACQ_0003": "アクワイアラが見つかりません。",
    "ERR_ACQ_0004": "アクワイアララMIDは存在しません。",
    "ERR_ACQ_0005": "ユニークなアクワイアラMIDを入力してください。",
    "ERR_AUTH_0001": "ユーザー名またはパスワードが正しくありません。",
    "ERR_AUTH_0002": "無効なユーザーセッションです。",
    "ERR_AUTH_0003": "リフレッシュトークンが期限切れ、またはユーザーがアプリケーションからサインアウトしました。",
    "ERR_AUTH_0004": "Payment Optionsのメール。サポートに連絡してください。",
    "ERR_AUTH_0005": "ユーザーは当社に登録されていません。",
    "ERR_AUTH_0006": "入力されたOTPは無効です。",
    "ERR_AUTH_0007": "無効なコードが入力されました。もう一度コードをリクエストしてください。",
    "ERR_AUTH_0008": "試行回数の制限を超えました。しばらくしてからもう一度お試しください。",
    "ERR_AUTH_0009": "無効なリクエストです。",
    "ERR_AUTH_0010": "ユーザーは無効です。サポートチームに連絡してください。",
    "ERR_AUTH_0011": "無効なパスワードポリシーです。",
    "ERR_AUTH_0012": "ユーザーは既にプールに存在します。",
    "ERR_AUTH_0013": "無効なメールアドレスです。",
    "ERR_AUTH_0014": "ユーザー属性のエラーです。",
    "ERR_AUTH_0015": "このユーザーは既に存在しています。",
    "ERR_AUTH_0016": "新しいパスワードは現在のパスワードと同じにはできません。",
    "ERR_AUTH_0018": "アカウントはロックされています。しばらくしてからもう一度お試しください。",
    "ERR_AUTH_0019": "The code you entered is incorrect or has expired.",
    "ERR_CONFIG_0000": "",
    "ERR_CONFIG_0001": "重複したルールです。",
    "ERR_FS_O0000": "実装されていません。",
    "ERR_FS_O0001": "すでに同日に緊急休暇が設定されている。別の日付を選択してください",
    "ERR_FS_O0002": "指定された日付には、同じ名前の休日がすでに予定されています。別の日付を選択してください",
    "ERR_MS_0021": "提供されたプランIDは無効です。",
    "ERR_MS_0022": "プランは同じMIDに属している必要があります。",
    "ERR_MS_0023": "アクティブなプランではありません。",
    "ERR_MS_0024": "サブスクリプションは編集できません。",
    "ERR_MS_0025": "無効なリクエストです。",
    "ERR_MS_0026": "ユーザー名またはメールアドレスは既に存在します。",
    "ERR_MS_0027": "サブスクリプションプランは既に存在します。",
    "ERR_MS_0028": "利用可能なサブスクリプションのプランを更新することはできません。",
    "ERR_MS_0029": "サポートチームに連絡してください。プランを削除できません。",
    "ERR_MS_0030": "契約者を削除できません。",
    "ERR_MS_0034": "このメールはすでに登録されています。",
    "ERR_MS_0036": "利用可能なすべての DASMID を入力してください",
    "ERR_MS_0037": "加盟店IPはすでに存在します。",
    "ERR_PBL_0001": "正しいDASMIDを入力してください。",
    "ERR_PBL_0002": "すべての製品は同じ通貨でなければなりません。",
    "ERR_PBL_0004": "カートの金額がこの通貨の上限を超えています。最大金額の上限 : 9999999",
    "ERR_PBL_0005": "カートの金額がこの通貨の上限を超えています。最大金額の上限 : 9999999.99",
    "ERR_PBL_0006": "カートの金額がこの通貨の下限を下回っています。最小金額の下限 : 1",
    "ERR_PBL_0007": "カートの金額がこの通貨の下限を下回っています。最小金額の下限 : 0.01",
    "ERR_AB_0000": "アクセスが拒否されました。",
    "ERR_AB_0001": "もう一度お試しください。",
    "ERR_AB_0002": "このメールアドレスはすでに登録されています。",
    "ERR_AB_0003": "ユーザーの詳細が見つかりません。",
    "ERR_AB_0004": "OTPが期限切れです。",
    "ERR_AB_0005": "再試行回数を超えました。OTPを再生成してください。",
    "ERR_AB_0006": "無効なOTPです。",
    "ERR_AB_0007": "最大再試行回数を超えました。サポートに連絡してください。",
    "ERR_AB_0008": "メールが認証されていません。",
    "ERR_AB_0009": "Payment Optionsのメール識別子が見つかりました。",
    "ERR_AB_0010": "アプリケーションが処理されていません。",
    "ERR_AB_0011": "アップロードに失敗しました。",
    "ERR_AB_0012": "ダウンロードに失敗しました。",
    "ERR_AB_0013": "ファイルを削除できません。",
    "ERR_AB_0014": "アプリケーションの詳細の取得に失敗しました。",
    "ERR_AB_1000": "APIは実装されていません。",
    "ERR_AB_0015": "アプリケーションの詳細が見つかりません。",
    "ERR_AB_0016": "対応していない国です。",
    "ERR_AB_0017": "無効なユーザーIDです。",
    "ERR_AB_0018": "アプリケーションが無効です。",
    "ERR_AB_0019": "アプリケーションに不備があります。",
    "ERR_AB_0020": "少なくとも一名のステークホルダーの詳細を入力してください。",
    "ERR_AB_0021": "少なくとも一名の権限のある署名者が必要です。",
    "ERR_AB_0022": "重複した法人番号または名称があります。",
    "ERR_AB_0023": "少なくとも一名のUBOを入力してください。",
    "ERR_AB_0024": "アプリケーションは既に処理されています。",
    "ERR_AB_0025": "選択された支払いタイプに価格を追加することは許可されていません。",
    "ERR_AB_0026": "顧客がアプリケーションを完了していません。",
    "ERR_AB_0027": "アプリケーションをDASPOSにプッシュすることができません。",
    "ERR_AB_0028": "無効な紹介コードです。",
    "ERR_AB_0029": "通信エラーです。",
    "ERR_AB_0030": "メールアドレスは提供されたプライマリメールアドレスと同じにすることはできません。",
    "ERR_AB_0031": "主要な連絡先を複数持つことはできません。",
    "ERR_AB_0032": "変更不可。",
    "ERR_AB_0033": "THIRDPARTYユーザーのアプリケーションIDが必要です。",
    "ERR_AB_0034": "メールアドレスを再確認してください。",
    "ERR_AB_0035": "外部セールス'の変更は許可されていません。",
    "ERR_AB_0036": "ユーザーはこの製品を選択していません。",
    "ERR_AB_0037": "このアプリケーションに対する追加情報のリクエストは許可されていません。",
    "ERR_AB_0038": "追加情報のリクエストが完了していません。",
    "ERR_AB_0039": "このリクエストは既に満たされています。",
    "ERR_AB_0040": "サードパーティのアプリケーションには価格設定は許可されていません。",
    "ERR_AB_0041": "紹介コードは有効ではありません。",
    "ERR_AB_0042": "アプリケーションの承認は既に進行中です。",
    "ERR_AB_0043": "無効なパスワードポリシーです。",
    "ERR_AB_0044": "価格が設定されていません。",
    "ERR_AB_0045": "営業チームによるリセラーの申請が承認されていません。",
    "ERR_AB_0049": "この申請では Myinfo Business の取得を利用できません。",
    "ERR_AB_0050": "Myinfo Business の取得を開始できませんでした。もう一度お試しいただくか、手動で入力してください。",
    "ERR_AB_0051": "Myinfo Business の取得を完了できませんでした。もう一度お試しいただくか、手動で入力してください。",
    "ERR_AB_0052": "この Myinfo Business 取得リンクは期限切れか無効です。",
    "ERR_AB_0053": "このステークホルダーには Singpass 認証を利用できません。",
    "ERR_AB_0054": "Singpass 認証を開始できませんでした。もう一度お試しいただくか、Onfido で認証してください。",
    "ERR_AB_0055": "Singpass 認証を完了できませんでした。もう一度お試しいただくか、Onfido で認証してください。",
    "ERR_AB_0056": "Singpass 認証を利用するには、ステークホルダーに国民登録番号(NRIC/FIN)の登録が必要です。",
    "ERR_AB_0057": "KYC リンクを送信するには、ステークホルダーにメールアドレスの登録が必要です。",
    "ERR_AB_0058": "この確認リンクは無効です。",
    "ERR_AB_0059": "この確認リンクの有効期限が切れています。新しいリンクをご請求ください。",
    "ERR_AB_0060": "この確認はすでに完了しています。",
    "VAL1001": "トークンの詳細が必要です。",
    "VAL1002": "アクセストークンが必要です。",
    "VAL1003": "Idトークンが必要です",
    "VAL1004": "リフレッシュトークンが必要です。",
    "VAL1005": "OTPが必要です。",
    "VAL1006": "パスワードの不一致。",
    "VAL1007": "パスワードを確認してください。",
    "VAL1008": "OTP が長すぎます。",
    "VAL0001": "金額が無効です。",
    "VAL0002": "通貨が無効です。",
    "VAL0003": "auto_captureが必要です。",
    "VAL0004": "カスタマーIPが無効です。",
    "VAL0005": "カードの詳細がありません。",
    "VAL0006": "請求先国がありません。",
    "VAL0007": "有効なメールアドレスを入力してください。",
    "VAL0008": "有効な電話番号を入力してください。",
    "VAL0009": "住所が入力されていません。",
    "VAL0010": "住所2が入力されていません。",
    "VAL0011": "市が入力されていません。",
    "VAL0012": "都道府県が入力されていません。",
    "VAL0013": "郵便番号が入力されていません。",
    "VAL0014": "サブスクリプションプラン名が無効です。",
    "VAL0015": "サブスクリプションプランタイプが無効です。",
    "VAL0016": "サブスクリプションプランの期間が無効です。",
    "VAL0017": "サブスクリプションプランの周期が無効です。",
    "VAL0018": "MIDがありません。",
    "VAL0019": "サブスクリプションプランの説明が無効です。",
    "VAL0020": "法人設立日が必要です。",
    "VAL0021": "サブスクリプションサイクルタイプが無効です。",
    "VAL0022": "",
    "VAL0023": "サブスクリプション終了タイプが無効です。",
    "VAL0024": "サブスクリプション間隔サイクルが無効です。",
    "VAL0025": "Max_cycle_countがありません/有効ではありません。",
    "VAL0026": "トライアル期間のブール値を期待します。",
    "VAL0027": "トライアル期間タイプが無効です。",
    "VAL0028": "トライアル期間タイプではありません。",
    "VAL0029": "割引があるブール値を期待します",
    "VAL0030": "ステークホルダーIDが無効です。",
    "VAL0031": "有効な割引期間ではありません。",
    "VAL0032": "無効なCVCです。",
    "VAL0033": "失効月が無効です。",
    "VAL0034": "失効年が無効です。",
    "VAL0035": "カード保持者名が無効です。",
    "VAL0036": "カード番号が無効です。",
    "VAL0037": "ステークホルダーUBOが無効です。",
    "VAL0038": "加盟店取引コードが45文字の制限を超えました。",
    "VAL0039": "加盟店IDが無効です。",
    "VAL0040": "ウェブフックURLが無効です。",
    "VAL0041": "サクセスURLが無効です。",
    "VAL0042": "拒否URLが無効です。",
    "VAL0043": "セッションIDが無効です。",
    "VAL0044": "有効な整数ではありません。",
    "VAL0045": "有効な数値ではありません。",
    "VAL0046": "有効なPaymentmethod.typeではありません。",
    "VAL0047": "subscription_idが無効です。",
    "VAL0048": "無効なPaymentMethod.hasServerApi",
    "VAL0049": "無効なPaymentMethod.hasQR",
    "VAL0050": "無効なPaymentMethod.hasPBL",
    "VAL0051": "無効なPaymentMethod.hasVISA",
    "VAL0052": "無効なPaymentMethod.hasMastercard",
    "VAL0053": "無効なPaymentMethod.hasJCB",
    "VAL0054": "無効なPaymentMethod.hasAMEX",
    "VAL0055": "無効なPaymentMethod.hasUPI",
    "VAL0056": "無効なPaymentMethod processingCurrency",
    "VAL0057": "無効なPaymentMethod integrationType",
    "VAL0058": "無効なPaymentMethod describeProduct",
    "VAL0059": "無効なPaymentMethod transactionalCountries",
    "VAL0060": "無効なPaymentMethod averageTransactionAmount",
    "VAL0061": "無効なPaymentMethod averageTransactionCcy",
    "VAL0062": "無効なPaymentMethod maximumTransactionAmount",
    "VAL0063": "無効なPaymentMethod maximumTransactionCcy",
    "VAL0064": "無効なPaymentMethod totalAnnualProjectionAmount",
    "VAL0065": "無効なPaymentMethod totalAnnualProjectionCcy",
    "VAL0066": "無効なPaymentMethod website",
    "VAL0067": "無効なPaymentMethod.isCreditInformationStored",
    "VAL0068": "無効なPaymentMethod.isCardTransaction",
    "VAL0069": "無効なPaymentMethod refundRate",
    "VAL0070": "無効なPaymentMethod averageRefund",
    "VAL0071": "無効なPaymentMethod chargebackRate",
    "VAL0072": "無効なPaymentMethod averageChargeback",
    "VAL0073": "無効なPaymentDetail id",
    "VAL0074": "無効なPaymentDetail accountNumber",
    "VAL0075": "無効なPaymentDetail settlementCurrency",
    "VAL0076": "無効なPaymentDetail bankName",
    "VAL0077": "無効なPaymentDetail bankCountry",
    "VAL0078": "無効なPaymentDetail paymentFrequency",
    "VAL0079": "無効なPaymentDetail delete docs option",
    "VAL0080": "ステークホルダー書類削除オプションが無効です。",
    "VAL0081": "ビジネス書類削除オプションが無効です。",
    "VAL0082": "ステークホルダー削除オプションが無効です。",
    "VAL0083": "無効なPaymentMethod.hasRecurring",
    "VAL0084": "居住国が無効です。",
    "VAL0085": "IBANが無効です。",
    "VAL0086": "Business.doingBusinessAsは必須です。",
    "VAL0087": "Business.hasMailingAddressは必須です。",
    "VAL0088": "Business.mailAddressは必須です。",
    "VAL0089": "Business.mailCityは必須です。",
    "VAL0090": "Business.mailCountryは必須です。",
    "VAL0091": "Business.mailPostcodeは必須です。",
    "VAL0092": "PaymentMethod.hasTechnologicalArchitectureは必須です。",
    "VAL0093": "無効なPaymentDetail bankAccountName",
    "VAL0094": "無効なPaymentDetail swiftCode",
    "VAL0095": "無効なBusiness.isBusinessLicenseRequired",
    "VAL0096": "無効な mcc",
    "VAL0097": "決済タイプが無効です。",
    "VAL0098": "頻度タイプが無効です。",
    "VAL0099": "mdrカード割引率が無効です。",
    "VAL0100": "セットアップ料金が無効です。",
    "VAL0101": "取引手数料が無料です。",
    "VAL0102": "返金処理手数料が無料です。",
    "VAL0103": "チャージバック処理手数料が無料です。",
    "VAL0104": "取引拒否手数料が無効です。",
    "VAL0105": "リトリーバルリクエスト手数料が無効です。",
    "VAL0106": "仲裁手数料が無効です。",
    "VAL0107": "代理手数料が無効です。",
    "VAL0108": "不正検知手数料が無効です。",
    "VAL0109": "ステータスが無効です。",
    "VAL0147": "有効なPaymentmethod.storePaymentMethodではありません。",
    "VAL0148": "有効なPaymentmethod.storedPaymentMethodIdではありません。",
    "VAL_AB_0001": "メールアドレスが無効です。",
    "VAL_AB_0002": "メールアドレスが長すぎます。",
    "VAL_AB_0003": "IDを入力してください。",
    "VAL_AB_0004": "有効なIDではありません。",
    "VAL_AB_0005": "OTPを入力してください。",
    "VAL_AB_0006": "名前を入力してください。",
    "VAL_AB_0007": "姓を入力してください。",
    "VAL_AB_0008": "電話番号を入力してください。",
    "VAL_AB_0009": "事業所所在地を入力してください。",
    "VAL_AB_0010": "パスワードを入力してください。",
    "VAL_AB_0011": "パスワードの長さが短すぎる/長すぎる。",
    "VAL_AB_0012": "OTPには数値を入力してください。",
    "VAL_AB_0013": "ユーザーIDがを入力してください。",
    "VAL_AB_0014": "ユーザーIDが無効です。",
    "VAL_AB_0015": "事業所所在地を入力してください。",
    "VAL_AB_0016": "会社名を入力してください。",
    "VAL_AB_0017": "法人番号を入力してください。",
    "VAL_AB_0018": "会社形態を入力してください。",
    "VAL_AB_0019": "その他会社形態を入力してください。",
    "VAL_AB_0020": "設立日を入力してください。",
    "VAL_AB_0021": "登録住所を入力してください。",
    "VAL_AB_0022": "ビジネスの郵便番号を入力してください。",
    "VAL_AB_0023": "ビジネスの都市を入力してください。",
    "VAL_AB_0024": "アプリケーションIDが無効です。",
    "VAL_AB_0025": "ドキュメントIDが無効です。",
    "VAL_AB_0026": "ドキュメントのファイル名を入力してください。",
    "VAL_AB_0027": "ドキュメントのデータを入力してください。",
    "VAL_AB_0028": "ドキュメントのファイルタイプを入力してください。",
    "VAL_AB_0029": "ビジネスIDが無効です。",
    "VAL_AB_0030": "ステークホルダーIDが無効です。",
    "VAL_AB_0031": "ステークホルダーのプライマリが無効／不足しています。 ",
    "VAL_AB_0032": "ステークホルダーの名前が不足しています。",
    "VAL_AB_0033": "ステークホルダーの姓が無効です。",
    "VAL_AB_0034": "ステークホルダーの生年月日が無効です。 ",
    "VAL_AB_0035": "ステークホルダーの電話番号が無効です。",
    "VAL_AB_0036": "ステークホルダーのメールが無効です。 ",
    "VAL_AB_0037": "ステークホルダーUBOが無効です。 ",
    "VAL_AB_0038": "ステークホルダーの所有率が無効です。",
    "VAL_AB_0039": "ステークホルダーの承認が無効です。",
    "VAL_AB_0040": "ステークホルダーの識別IDが無効です。",
    "VAL_AB_0041": "ステークホルダーの役職が無効です。",
    "VAL_AB_0042": "ステークホルダーの住所が無効です。",
    "VAL_AB_0043": "ステークホルダーの郵便番号が無効です。 ",
    "VAL_AB_0044": "ステークホルダーの都市が無効です。",
    "VAL_AB_0045": "ステークホルダーの国籍が無効です。",
    "VAL_AB_0046": "支払い方法IDが無効です。",
    "VAL_AB_0047": "支払い方法.hasHppが無効です。",
    "VAL_AB_0048": "支払い方法.hasServerApiが無効です。",
    "VAL_AB_0049": "支払い方法.hasQRが無効です。",
    "VAL_AB_0050": "支払い方法.hasPBLが無効です。",
    "VAL_AB_0051": "支払い方法.hasVISAが無効です。",
    "VAL_AB_0052": "支払い方法.hasMastercardが無効です。",
    "VAL_AB_0053": "支払い方法.hasJCBが無効です。",
    "VAL_AB_0054": "支払い方法.hasAMEXが無効です。",
    "VAL_AB_0055": "支払い方法.hasUPIが無効です。",
    "VAL_AB_0056": "支払い方法の処理通貨が無効です。",
    "VAL_AB_0057": "支払い方法の統合タイプが無効です。",
    "VAL_AB_0058": "支払い方法の製品説明が無効です。",
    "VAL_AB_0059": "支払い方法の取引国が無効です。",
    "VAL_AB_0060": "支払い方法の平均取引額が無効です。",
    "VAL_AB_0061": "支払い方法の平均取引通貨が無効です。",
    "VAL_AB_0062": "支払い方法の最大取引額が無効です。",
    "VAL_AB_0063": "支払い方法の最大取引通貨が無効です。",
    "VAL_AB_0064": "支払い方法の年間予測総額が無効です。",
    "VAL_AB_0065": "支払い方法の年間予測通貨が無効です。",
    "VAL_AB_0066": "支払い方法のウェブサイトが無効です。",
    "VAL_AB_0067": "支払い方法.hasCreditInformationStoredが無効です。",
    "VAL_AB_0068": "支払い方法.hasCardTransactionが無効です。",
    "VAL_AB_0069": "支払い方法 refundRateが無効です。",
    "VAL_AB_0070": "支払い方法 averageRefundが無効です。",
    "VAL_AB_0071": "支払い方法 chargebackRateが無効です。",
    "VAL_AB_0072": "支払い方法 averageChargebackが無効です。",
    "VAL_AB_0073": "支払い方法の詳細IDが無効です。",
    "VAL_AB_0074": "支払い方法の口座番号が無効です。",
    "VAL_AB_0075": "決済通貨が無効です。",
    "VAL_AB_0076": "支払い方法の銀行名が無効です。",
    "VAL_AB_0077": "支払い方法の銀行所在国が無効です。",
    "VAL_AB_0078": "支払い方法の支払い頻度が無効です。",
    "VAL_AB_0079": "支払い方法の書類削除オプションが無効です。",
    "VAL_AB_0080": "ステークホルダーの書類削除オプションが無効です。",
    "VAL_AB_0081": "ビジネスの書類削除オプションが無効です。",
    "VAL_AB_0082": "ステークホルダーの削除オプションが無効です。",
    "VAL_AB_0083": "支払い方法.hasRecurringが無効です。",
    "VAL_AB_0084": "居住国が無効です。",
    "VAL_AB_0085": "無効なIBANです。",
    "VAL_AB_0086": "ビジネス.doingBusinessAsを入力してください。",
    "VAL_AB_0087": "ビジネス.hasMailingAddressを入力してください。",
    "VAL_AB_0088": "ビジネス.mailingAddressを入力してください。",
    "VAL_AB_0089": "ビジネス.mailingCityを入力してください。",
    "VAL_AB_0090": "ビジネス.mailingCountryを入力してください。",
    "VAL_AB_0091": "ビジネス.mailingPostcodeを入力してください。",
    "VAL_AB_0092": "支払い方法.hasPCIDSSを入力してください。",
    "VAL_AB_0093": "支払い方法の銀行口座名が無効です。",
    "VAL_AB_0094": "支払い方法のSWIFTコードが無効です。",
    "VAL_AB_0095": "ビジネス.isBusinessLicenseRequiredが無効です。",
    "VAL_AB_0096": "無効なMCCです。",
    "VAL_AB_0097": "無効な支払いタイプです。",
    "VAL_AB_0098": "無効な頻度タイプです。",
    "VAL_AB_0099": "無効なMDRカード割引率です。",
    "VAL_AB_0100": "無効なセッティング料です。",
    "VAL_AB_0101": "無効な取引手数料です。",
    "VAL_AB_0102": "無効な返金処理手数料です。",
    "VAL_AB_0103": "無効なチャージバック処理手数料です。",
    "VAL_AB_0104": "無効な取引拒否手数料料です。",
    "VAL_AB_0105": "無効なリトリーバルリクエスト料です。",
    "VAL_AB_0106": "無効な仲裁手数料です。",
    "VAL_AB_0107": "無効な代理人手数料です。",
    "VAL_AB_0108": "無効な不正検知手数料です。",
    "VAL_AB_0109": "無効なステータスです。",
    "VAL_AB_0110": "無効なメインテナンスおよびサポート手数料です。",
    "VAL_AB_0111": "無効な紹介コードです。",
    "VAL_AB_0112": "ユーザータイプを提供してください。",
    "VAL_AB_0113": "紹介コードはTHIRDPARTYには適用されません。",
    "VAL_AB_0114": "無効なユーザータイプです。",
    "VAL_AB_0115": "コメントを入力してください。",
    "VAL_AB_0116": "無効なドキュメントタイプです。",
    "VAL_AB_0117": "無効な情報IDです。",
    "VAL_AB_0118": "無効なドキュメントタイプです。",
    "VAL_AB_0119": "無効な事業内容です。",
    "VAL_AB_0120": "無効なサードパーティタイプです。",
    "VAL_AB_0121": "無効な3PL加盟店エンティティリストです。",
    "VAL_AB_0122": "PaymentMethod.settlementCurrencyForHppのための無効なCCYが渡されました。",
    "VAL_AB_0123": "PaymentMethod.settlementCurrencyForRecurringのための無効なCCYが渡されました。",
    "VAL_AB_0124": "PaymentMethod.settlementCurrencyForServerApiのための無効なCCYが渡されました。",
    "VAL_AB_0125": "PaymentMethod.settlementCurrencyForQRのための無効なCCYが渡されました。",
    "VAL_AB_0126": "PaymentMethod.settlementCurrencyForPBLのための無効なCCYが渡されました。",
    "VAL_AB_0127": "無効な企業ウェブサイトです。",
    "VAL_AB_0128": "無効なステークホルダーの識別タイプです。",
    "VAL_AB_0129": "無効な株式コードです。",
    "VAL_AB_0130": "ミドルネームが不足しています。",
    "VAL_AB_0131": "その他のビジネスの性質が無効です。",
    "VAL_AB_0132": "その他のサードパーティタイプが無効です。",
    "VAL_AB_0133": "無効な'従業員数'です。",
    "VAL_AB_0134": "無効な紹介リクエストIDです。",
    "VAL_AB_0135": "紹介リクエストのメールが無効です。",
    "VAL_AB_0136": "紹介リクエストの会社名を入力してください。",
    "VAL_AB_0137": "紹介リクエストの連絡先名が無効です。",
    "VAL_AB_0138": "紹介リクエストのメッセージが無効です。",
    "VAL_AB_0139": "紹介リクエストの紹介リンクを入力してください。",
    "VAL_AB_0140": "紹介リクエストのリセラー名を入力してください。",
    "VAL_AB_0141": "紹介リクエストの紹介コードを入力してください。",
    "VAL_AB_0142": "紹介リクエストの標準MDRを入力してください。",
    "VAL_AB_0143": "紹介リクエストの少額MDRを入力してください。",
    "VAL_AB_0144": "無効な支払い方法の支店コードです。",
    "VAL_AB_0145": "無効な支払い方法の銀行コードです。",
    "VAL_AB_0146": "紹介リクエストの言語を入力してください。",
    "VAL_AB_0147": "無効なファイルです.",
    "VAL_ACQ_0000": "",
    "VAL_AUTH_0001": "メールアドレスが無効です。",
    "VAL_AUTH_0002": "IDを入力してください。",
    "VAL_AUTH_0003": "パスワードが一致しません。",
    "VAL_AUTH_0004": "有効なIDではありません。",
    "VAL_AUTH_0005": "OTPを入力してください。",
    "VAL_AUTH_0010": "パスワードを入力してください。",
    "VAL_AUTH_0011": "パスワードの長さが短すぎる/長すぎる。",
    "VAL_AUTH_0012": "OTPには数値が期待されます。",
    "VAL_AUTH_0013": "ユーザーIDを入力してください。",
    "VAL_AUTH_0014": "ユーザーIDが無効です。",
    "VAL_AUTH_0015": "トークンの詳細を入力してください。",
    "VAL_AUTH_0016": "アクセストークンを入力してください。",
    "VAL_AUTH_0017": "IDトークンを入力してください。",
    "VAL_AUTH_0018": "リフレッシュトークンを入力してください。",
    "VAL_AUTH_0019": "OTPを入力してください。",
    "VAL_AUTH_0020": "パスワードが一致しません。",
    "VAL_AUTH_0021": "確認用のパスワードを入力してください。",
    "VAL_AUTH_0022": "OTPの長さが無効です。",
    "VAL_CONFIG_0000": "",
    "VAL_DP_0001": "無効な金額です。",
    "VAL_DP_0002": "無効な通貨です。",
    "VAL_DP_0003": "自動キャプチャを入力してください。",
    "VAL_DP_0004": "顧客のIPが無効です。",
    "VAL_DP_0005": "カードの詳細が不足しています。",
    "VAL_DP_0006": "請求国が不足しています。",
    "VAL_DP_0007": "有効なメールアドレスを提供してください。",
    "VAL_DP_0008": "有効な電話番号を提供してください。",
    "VAL_DP_0009": "住所が不足しています。",
    "VAL_DP_0010": "住所2が不足しています。",
    "VAL_DP_0011": "市区町村が不足しています。",
    "VAL_DP_0012": "州が不足しています。",
    "VAL_DP_0013": "郵便番号が不足しています。",
    "VAL_DP_0014": "サブスクリプションプラン名が無効です。",
    "VAL_DP_0015": "サブスクリプションプランタイプが無効です。",
    "VAL_DP_0016": "サブスクリプションプランの期間が無効です。",
    "VAL_DP_0017": "サブスクリプションプランのサイクルが無効です。",
    "VAL_DP_0018": "MIDが不足しています。",
    "VAL_DP_0019": "サブスクリプションプランの説明が無効です。",
    "VAL_DP_0020": "",
    "VAL_DP_0021": "サブスクリプションプランの説明が無効です。",
    "VAL_DP_0022": "",
    "VAL_DP_0023": "サブスクリプションの終了タイプが無効です。",
    "VAL_DP_0024": "サブスクリプションの間隔サイクルが無効です。",
    "VAL_DP_0025": "最大サイクル回数が不足しているか/無効です。",
    "VAL_DP_0026": "試用期間があるかどうかにはブーリアンが期待されます。",
    "VAL_DP_0027": "試用期間の期間タイプが無効です。",
    "VAL_DP_0028": "試用期間の期間ではありません。",
    "VAL_DP_0029": "割引があるかどうかにはブーリアンが期待されます。",
    "VAL_DP_0030": "割引率が無効です。",
    "VAL_DP_0031": "割引期間が無効です。",
    "VAL_DP_0032": "CVCが無効です。",
    "VAL_DP_0033": "有効期限の月が無効です。",
    "VAL_DP_0034": "有効期限の年が無効です。",
    "VAL_DP_0035": "カード保持者の名前が無効です。",
    "VAL_DP_0036": "カード番号が無効です。",
    "VAL_DP_0037": "加盟店トランザクション参照を入力してください。",
    "VAL_DP_0038": "加盟店トランザクション参照が45文字の制限を超えています。",
    "VAL_DP_0039": "加盟店IDが無効です。",
    "VAL_DP_0040": "ウェブフックURLが無効です。",
    "VAL_DP_0041": "成功URLが無効です。",
    "VAL_DP_0042": "拒否URLが無効です。",
    "VAL_DP_0043": "セッションIDが無効です。",
    "VAL_DP_0044": "無効な整数です。",
    "VAL_DP_0045": "無効な数字です。",
    "VAL_DP_0047": "サブスクリプションIDが無効です。",
    "VAL_DP_0048": "有効なPaymentmethod.typeではありません。",
    "VAL_DP_0049": "有効なPaymentmethod.storePaymentMethodではありません。",
    "VAL_DP_0050": "有効なPaymentmethod.storedPaymentMethodIdではありません。",
    "VAL_DP_0051": "無効な製品です。",
    "VAL_DP_0052": "無効なDASMIDです。",
    "VAL_MS_0085": "subscription.subscriberを入力してください。",
    "VAL_MS_0086": "契約者のメールを入力してください。",
    "VAL_MS_0087": "契約者の名前を入力してください。",
    "VAL_MS_0088": "契約者の姓を入力してください。",
    "VAL_MS_0089": "プランIDを入力してください。",
    "VAL_MS_0090": "サブスクリプションタイプが無効です。",
    "VAL_MS_0091": "サブスクリプションの終了時が無効です。",
    "VAL_MS_0092": "サブスクリプションの開始時が無効です。",
    "VAL_MS_0093": "最大サイクル回数が無効です。",
    "VAL_MS_0094": "Dasmidを入力してください。",
    "VAL_MS_0095": "契約者の詳細が不足しています。",
    "VAL_MS_0096": "リンクの有効期限が無効です。",
    "VAL_MS_0097": "選択した通貨で許可されている金額の範囲外です",
    "VAL_PBL_0000": "",
    "VAL_FS_O0008": "ROLLING_RESERVE_HELDの値が有効ではありません。",
    "VAL_FS_O0006": "ROLLING_RESERVE_RELEASEDの値が有効ではありません。",
    "VAL_FS_O0004": "FixedDepositHeldYTDAmountの値が有効ではありません。",
    "VAL_FS_O0002": "AdjustmentsAmountの値が有効ではありません。",
    "VAL_FS_O0003": "NetSalesは有効な値ではありません。",
    "VAL_FS_O0001": "TotalFeesの値が有効ではありません。",
    "defaultErrorMsg": "内部サーバーエラー",
    "CUSTOM_ERR001": "ファイルは2MBより小さくなければなりません",
    "ACTION_STATEMENTUPDATE": "明細書の更新が成功しました。.",
    "ACTION_STATEMENTUPDATEFAILED": "明細の更新に失敗しました。",
    "ADD_NEW_FILTER_ERROR": "フィルターする値を入力してください",
    "INFO_FS_O0032": "ハッシュカードはすでに存在します",
    "INFO_FS_O0033": "Transaction whitelist updated successfully.",
    "INFO_FS_O0038": "Hashcard Already Whitelisted",
    "INFO_FS_O0039": "Hashcard Not Whitelisted",
    "ERR_MS_0039": "商品SKUまたはコードはすでに登録されています",
    "ERR_MS_0040": "カテゴリ名はすでに登録されています",
    "ERR_MS_0046": "マーチャントのキーペアはすでに存在します。",
    "ERR_MS_0047": "加盟店のキーペアが見つかりません。",
    "ERR_MS_0052": "税設定のマッピングが見つかりません",
    "ERR_MS_0053": "指定されたマーチャントの税設定マッピングが見つかりません",
    "ERR_MS_0054": "指定されたマーチャントの子会社の税設定が見つかりません",
    "VAL100001": "データ形式が無効です。データを確認してもう一度お試しください。",
    "ERR_9000": 'リクエストが多すぎます',
    "INVALID_FILTER_ERROR": "フィルターする値を入力してください",
    "INFO_MS_0073": "マーチャントのキーペアが生成されました",
    "INFO_MS_0076": "マーチャントの税設定を取得しました",
    "INFO_MS_0077": "マーチャント税設定のステータスが更新されました",
  },
  TermsAndConditionsHeading: '利用規約',
  TermsAndCondtions: {
    BeforeLinkDescription:
      'このウェブサイトを閲覧・使用する場合、お客様は以下の利用規約を遵守し、これに拘束されることに同意するものとします。この利用規約は、当社のプライバシーポリシーとともに、このウェブサイトに関連するお客様とPayment Optionsとの関係を規定するものです。\n\nこれらの利用規約（以下「規約」）は、当社が随時改訂することにより、お客様が',
    AfterLinkDescription:
      '（以下「ウェブサイト」）のウェブサイトを利用する際の原則を定め、当社がサービスを提供する方法についての重要な情報を提供するものです。\n\n当ウェブサイトにアクセスすることにより、お客様はこの条件に法的に拘束されることに同意したものとみなされます。条件に完全に同意されない場合は、ウェブサイトを使用することはできません。\n\n本ウェブサイトは、Payment Options Pte Ltd（以下、「Payment Options」）によって所有・運営されています。\n\nPayment Optionsまたは「当社」という用語は、本ウェブサイトの所有者を指します。「お客様」とは、当ウェブサイトの利用者または閲覧者を指します。',
    DeclerationFirst: '1.免責事項',
    DeclerationFirstDetails:
      '本ウェブサイトおよびそのコンテンツは、一般的な情報提供のみを目的としており、本ウェブサイトまたはそのコンテンツのいかなる部分も、法律的、データ保護コンプライアンス的、またはその他の専門的なアドバイスを提供することを意図したものではありません。当社は、本ウェブサイトに掲載された情報または資料を信頼したことにより生じたいかなる損失に対しても、一切の責任を負いません。\n\n適用される法律が許容する範囲において、当社は、お客様または第三者がこのウェブサイトおよびそのコンテンツにアクセスまたは使用することに関連するいかなる事項についても、責任を負わないものとします。',
    DeclerationSecond: '2.著作権および商標権',
    DeclerationSecondDetails:
      '本ウェブサイト、ウェブサイトのコンテンツ、ウェブサイトコード、ドメイン名、およびすべての著作権、商標、会社名、その他すべての知的財産または財産は、ウェブサイト運営者、ライセンサー、コンテンツプロバイダーが完全に所有し、適用される国内外の知的財産法およびその他の法律によって保護されています。\n\nウェブサイト運営者が明示的に許可した場合を除き、お客様は、ウェブサイト、ウェブサイトコンテンツまたはウェブサイトコードの全部または一部を、いかなる形式または手段によっても、コピー、キャプチャ、複製、実行、譲渡、販売、ライセンス化、修正、派生物の作成、再発行、提出、編集、投稿、送信、公に表示、フレーム化、配布、利用しないこととします。\n\nただし、本サイトに含まれる商標またはロゴは、Payment Optionsの書面による事前の同意なしに、複製、出版、配布またはその他の方法で使用することはできません',
    DeclerationThird: '3.使用許諾',
    DeclerationThirdDetails:
      '本サイト運営者は、お客様が本規約を完全に遵守することを条件に、本サイトおよび本サイトのコンテンツにアクセスし使用するための非独占的、譲渡不能な限定的権利およびライセンスをお客様に付与します。お客様は、当ウェブサイトを妨害したり、混乱させたり、法的要件に背いたりしないことに同意するものとします。',
    DeclerationFourth: '4.準拠法および管轄裁判所',
    DeclerationFourthDetails:
      '本規約は、適用法に準拠して解釈されるものとします。',
    DeclerationFifth: '5.変更',
    DeclerationFifthDetails:
      'Payment Optionsは、独自の判断により、本ウェブサイト、本ウェブサイトのコンテンツおよび/または本規約の全部または一部をいつでも変更、修正、追加または削除することができるものとします。本規約の変更は、掲載された時点から有効となります。お客様は、本規約の変更箇所を認識するために、本規約を定期的に確認することに同意するものとします。',
    DeclerationSixth: '6.ウェブサイト閲覧情報',
    DeclerationSixthDetails:
      'Payment Optionsは、クッキーなどの一般的に使用される情報収集ツールを使用して、お客様が当社のウェブサイトを閲覧する際に情報を収集します。(以下「ウェブサイト閲覧情報」といいます。） 本項では、ウェブサイト上で収集される可能性のあるウェブサイト閲覧情報の種類と、この情報がどのように使用されるかを説明します。',
    SixthSubDetailsContainer: {
      SixthSubDetailOne: '6.1 クッキー',
      SixthSubDetailOneDescription:
        'Payment Optionsは、ウェブサイトとのインタラクションを容易かつ有意義なものにするためにクッキーを使用しています。お客様が当社のウェブサイトにアクセスすると、Payment Optionsのサーバーはお客様のコンピュータにクッキーを送信します。このようなクッキーは、お客様を個人的に識別するものではなく、単純にお客様のウェブブラウザを認識するためだけのものです。お客様が口座開設やウェブフォーム（「お問い合わせ」等）に記入することにより、Payment Optionsに対して個人の特定を可能にすることを選択しない限り、お客様は当社に対して匿名のままです。 Payment Optionsは、セッション・ベースとパーシステント・ベースのクッキーを使用します。セッション・クッキーは、1つのセッションの間のみ存在します。ブラウザソフトを閉じるか、コンピュータの電源をオフにすると、コンピュータから消去されます。パーシステントクッキーは、お客様がブラウザソフトウェアを閉じたり、コンピュータの電源を切ったりした後も、お客様のコンピュータに残ります。\n\nお客様がPayment Optionsに対して個人の特定を可能にすることを選択した場合、当社は暗号化された情報を含むセッションクッキーを使用し、当社がお客様を特定できるようにします。お客様が本サービスに関連してウェブアカウントにログインするたびに、ウェブアカウントに結びついた暗号化された一意の識別子を含むセッションクッキーがお客様のブラウザに置かれます。これらのセッションクッキーは、お客様が本サービスにログインした際に、当社がお客様を一意に識別し、お客様のオンライン取引や要求を処理することを可能にします。セッションクッキーは、本サービスを利用するために必要です。\n\nPayment Optionsは、当社のみが読み取ることができるパーシステントクッキーを使用し、以前に当社のウェブサイトを訪れたことのあるブラウザを識別するために使用します。お客様が本サービスを購入された場合、または当社に個人データを提供された場合、お客様に一意の識別子が割り当てられます。この一意の識別子は、当社がお客様のウェブブラウザに配置するパーシステントクッキーに関連付けられます。当社は、パーシステントクッキーに保存される情報のセキュリティと機密性に関して特に注意を払っています。例えば、当社は、パーシステントクッキーにアカウント番号やパスワードを保存しません。お客様のウェブブラウザがクッキーを受け入れる機能を無効にした場合、お客様は当社のウェブサイトを閲覧することはできますが、サービスを正常に利用することはできません。\n\nPayment Optionsは、Payment Options及び本サービスに関する情報をお客様に提供するために、セッションクッキー及びパーシステントクッキーからの情報を、当社のお客様に関する匿名化された個人データと組み合わせて使用することがあります。',
      SixthSubDetailTwo: '6.2 フラッシュクッキー',
      SixthSubDetailTwoDescription:
        'Payment Optionsは、フラッシュ・クッキーとして知られるローカル共用オブジェクトを使用して、お客様の好みを保存したり、お客様が当社のウェブサイト上で閲覧した内容に基づいてコンテンツを表示し、お客様のご利用体験をパーソナライズすることがあります。Payment Optionsが提携する第三者が、当社のウェブサイト上で特定の機能を提供したり、お客様のウェブ閲覧状況に基づいて広告を表示したりする場合、フラッシュクッキーを使用して情報を収集し保存します。',
      SixthSubDetailThree: '6.3 IPアドレス',
      SixthSubDetailThreeDescription:
        'お客様が当社ウェブサイトを閲覧する際、当社はお客様のインターネットプロトコル（以下「IP」）アドレスを収集し、非個人データを追跡・集計しています。例えば、Payment Optionsは、お客様や訪問者が当社のウェブサイトを閲覧した地域を監視するためにIPアドレスを使用します。',
      SixthSubDetailFour: '6.4 サードパーティクッキー',
      SixthSubDetailFourDescription:
        'Payment Optionsは、随時、第三者に対し、当社のウェブサイトを訪問する個人の利用状況や数量に関する統計情報を追跡・分析を依頼しています。第三者に提供される情報には個人情報は含まれませんが、当社が情報を受け取った後、その情報を個人情報と再度関連付けすることがあります。',
      SixthSubDetailFive: '6.5 他のウェブサイトへのリンク',
      SixthSubDetailFiveDescription:
        '当社のウェブサイトには、関心があると思われる他のウェブサイトへのリンクが含まれている場合があります。しかし、お客様がこれらのリンクを使用して当社のウェブサイトを離れた後は、当社はそのような第三者のウェブサイトを管理する権限を有しませんのでご注意ください。したがって、当社は、お客様が第三者のウェブサイトを閲覧する際に提供される個人データのプライバシー保護について責任を負うものではありません。お客様は、お客様の個人情報を当該第三者に開示する前に、当該第三者のウェブサイトのプライバシーポリシーを確認し、注意を払う必要があります。',
    },
    DeclerationSeven: '7.連絡先',
    DeclerationSevenOneDetails:
      'Payment Optionsが提供するウェブサイトおよびサービスに関するお問い合わせは、',
    DeclerationSevenTwoDetails: '  までお願いしま',
    DeclerationEight: '言語',
    DeclerationEightDetails:
      '本利用規約について紛争が生じた場合には、英語版が優先されるものとします。本利用規約の英語版は、すべての点で支配的であり、翻訳版との間に矛盾がある場合には、英語版が優先するものとします。 本利用規約のいかなる条項も、適用法に基づくお客様の権利を制限するものではありません。',
  },
  PrivacyPolicyHeading: 'プライバシーポリシー',
  ResellerAccount: {
    breadcrumbs: {
      Home: 'ホーム',
      Partner: 'パートナー',
    },
    tabs: {
      Account: 'パートナーアカウント',
      Statements: '手数料明細',
    },
    button: {
      CREATE_ACCOUNT: 'アカウントを作成する',
    },
    Heading: 'パートナーアカウントを作成する',
    fields: {
      RefferalCode: '紹介コード',
    },
    ReferralDetails: {
      label: 'Referral Details',
      ReferralCode: '紹介コード',
      ReferralLink: '紹介リンク',
    },
    columnDefs: {
      Action: 'アクション',
      ResellerName: 'パートナー名',
      ResellerNameInEnglish: 'パートナー名（英語）',
      ContactPerson: '担当者',
      Email: 'メールアドレス',
      Date: '作成日',
      ReferredMerchants: '紹介された加盟店',
      STATUS: 'ステータス',
      Country: ' 国',
    },
    MERCHANT: 'MERCHANT',
    THIRDPARTY: 'THIRDPARTY',
    TypeOfThirdParty: {
      EXTSALS: 'エージェント',
      RESELLER: 'パートナー',
      REFERRAL: 'リファーラル',
      INDIVIDUAL: '個人',
      OTHER: 'その他',
    },
  },
  ResellerDetails: {
    breadcrumbs: {
      'Home': 'ホーム',
      'Partner': 'パートナー',
      'Partner Details': 'パートナー詳細',
    },
    AllDetails: {
      label: 'パートナー詳細',
      PersonalDetails: {
        'Partner Name': 'パートナー名',
        'Partner Name English': 'パートナー名英語',
        'Address': '住所',
        'City': '市区町村',
        'Country': '国',
      },
      ContactDetails: {
        'Contact Details': '連絡先詳細',
        'First Name': '名',
        'Middle Name': 'ミドルネーム',
        'Last Name': '姓',
        'Telephone Number': '電話番号',
        'Email': 'メールアドレス',
      },
      ReferralDetails: {
        'Referral Details': '紹介詳細',
        'Referral Code': '紹介コード',
        'Referral Link': '紹介リンク',
      },
      ReferredMerchants: {
        'Referral Merchants': '紹介された加盟店',
      },
      ResellerCommissionRates: {
        label: 'リセラー手数料率',
        columnDefs: {
          MdrToMerchant: '加盟店決済手数料',
          Commission: '手数料明細',
        },
      },
    },
    SendReferralLinkViaEmail: {
      'Create Email': 'メール作成',
      'Description Text':
        'メールで紹介リンクを送信するためにフォームに記入してください。',
      'Email Address': 'メールアドレス',
      'Company Name': '会社名',
      'Contact Person Name': '連絡担当者名',
      'Message': 'メッセージ',
      'Referral Link': '紹介リンク',
      'Send': '送信',
      'Standard MDR Rate': '標準MDRレート',
      'Micro MDR Rate': 'マイクロMDRレート',
      'Min Value': '値は0より大きい必要があります。',
      'Max Value': '値は100以下である必要があります。',
      'Language': '言語を選択する',
    },
    MERCHANT: 'MERCHANT',
    THIRDPARTY: 'THIRDPARTY',
    'Merchant': 'マーチャント',
    'Partner': 'パートナー',
    'MerchantRegistration': 'マーチャント登録',
    'PartnerRegistration': 'パートナー登録',
    'Onboarding': "オンボーディング"
  },

  Onfido_Message: {
    KYC_INVITE: {
      "Title": "本人確認を行う",
      "Greeting": "{{name}} 様",
      "Description": "お手続きを完了するため、本人確認が必要です。Singpass アカウントで約1分で完了します。",
      "Description_For": "{{business}}のお手続きを完了するため、本人確認が必要です。Singpass アカウントで約1分で完了します。",
      "Thanks_Title": "ありがとうございました",
      "Thanks_Body": "本人確認が完了しました。これ以上のお手続きは不要です。",
      "Review_Title": "ありがとうございました。以降は当社で対応します",
      "Review_Body": "ご提出内容を確認しています。追加のご連絡が必要な場合はご案内いたします。",
      "Error_Title": "本人確認を完了できませんでした",
      "Invalid": "この確認リンクは無効か、有効期限が切れています。新しいリンクをご依頼ください。",
      "Close_Tab": "このタブを閉じていただけます。",
      "Privacy_Note": "本人確認に必要な情報のみを取得します。",
      "Recipient": "送信先",
      "Recipient_Placeholder": "name@company.com",
      "Send": "送信",
      "Invalid_Email": "有効なメールアドレスを入力してください。",
      "Alternate_Note": "ステークホルダー情報に登録されたアドレスとは異なります。",
      "Use_Email": "メールでリンクを送信",
      "Email_Helper": "このステークホルダーのメールアドレスに Singpass 認証リンクを送信します。",
      "Sent": "{{email}} に認証リンクを送信しました",
      "Send_Failed": "認証リンクを送信できませんでした。"
    },
    KYC_REVIEW: {
      "Title": "Singpass 認証の詳細",
      "Description": "Singpass から返された情報と、本申請に登録されている情報を比較しています。",
      "Field": "項目",
      "On_Record": "登録情報",
      "From_Singpass": "Singpass の情報",
      Fields: {
        "nric": "NRIC/FIN",
        "name": "氏名",
        "dob": "生年月日",
        "nationality": "国籍"
      },
      "Masked_Note": "NRIC/FIN はマスク表示です。完全な値はステークホルダー情報に保持されます。",
      "Retrieved_At": "取得日時",
      "No_Data": "このステークホルダーの認証詳細はまだありません。",
      "Not_Returned": "Singpass から返されませんでした",
      "Load_Failed": "認証詳細を読み込めませんでした。"
    },
    KYC_METHOD: {
      "Not_Provisioned": "この Singpass アカウントには Myinfo プロフィールがないため、確認に必要な情報を取得できませんでした。Myinfo が利用可能な Singpass アカウントをご使用いただくか、Onfido で認証してください。",
      "Description_For": "{{name}} 様の本人確認方法をお選びください。",
      "Or": "または",
      "Singpass_Helper": "即時に完了します。Singpass の情報とステークホルダー情報を照合します。",
      "Onfido_Helper": "本人確認書類をアップロードし、自撮り写真を撮影します。通常は数分で審査されます。",
      "Title": "認証方法をお選びください",
      "Description": "Singpass アカウントで即座に認証する場合は Singpass を、本人確認書類をアップロードする場合は Onfido をお選びください。",
      "Use_Singpass": "確認",
      "Use_Onfido": "Onfido で認証",
      "Starting": "開始しています...",
      "Cancel": "キャンセル",
      "Singpass_Unavailable": "Singpass 認証には、ステークホルダー情報に NRIC/FIN が必要です。",
      "Review_Message": "Singpass の情報が登録内容と一致しませんでした。KYC は現在審査中です。",
      "Error_Message": "Singpass 認証を完了できませんでした。再試行するか、Onfido で認証してください。"
    },
    UPDATE_KYC: {
      "Title_Update_KYC": "本人確認を更新する",
      "POPUP_TEXT": "<p><strong>&quot;認証を開始&quot;</strong>をクリックして本人確認を開始してください。</p><p>または以下のリンクをコピーして共有してください。</p>",
      "VERIFY_YOUR_IDENTITY": "本人確認を行う",
      "BTN_CANCEL": "キャンセル",
      "BTN_START_KYC": "本人確認を開始",
    },
    KYC_Processing_STATUS: {
      "Thank You": "ありがとうございます",
      "Completed": "本人確認が正常に完了しました。",
      "Processing": "本人確認が進行中です。",
      "Review": "Your KYC Verification is Under Review.",
      "Failed": "本人確認に失敗しました。",
      "update": "更新には数秒かかる場合があります。",
      "Continue to Stakeholders": "ステークホルダーに進む"
    },
    "Document_List": "書類一覧",
    "Document_Name": "書類名",
    "Download": "ダウンロード",
    "Document_Type": "書類の種類",
    "Document_Side": "書類の表紙",
    "Uploaded_At": "アップロード日時",
    "Document_Refresh": "書類リストを更新する",
    "Complete_Your_KYC": "KYCを完了する",
    "Retry_Your_KYC": "KYCを再試行",
    Prompt_Message: {
      "requiredKYC": "すべてのスタックホルダーのKYCステータスを完了する必要があります",
      "Tooltip": "すべてのスタックホルダーのKYCステータスを完了する必要があります",
    },
    KYC_STATUS: {
      "Pending": "保留中",
      "Completed": "完了",
      "Rejected": "拒否されました",
      "Processing": "処理中",
      "Review": "レビュー中",
      "Manual KYC required": "手動KYCが必要です",
    },
  },
  "RISK_RULES": {
    "Action": "アクション",
    "Create Rule": "ルールを作成",
    "CreatedAt": "で作成された",
    "UpdatedAt": "で更新",
    "Assignments": "割り当て",
    "Conditions": "条件",
    "IsActive": "ステータス",
    "RuleType": "ルールタイプ",
    "Name": "ルール名",
    "Updated": "更新",
    "Created": "作成",
    "LevelDASMID": "レベル DASMID",
    "LevelMerchant": "レベル マーチャント",
    "LevelAcquirer": "レベル アクワイアラー",
    "LevelEntity": "レベル エンティティ",
    "Description": "説明",
    "Duration Unit": "期間単位",
    "Duration Value": "期間の値",
    "Duration": "時間枠",
    "Velocity Limit": "速度制限",
    "Timezone": "タイムゾーン",
    "Add Condition": "条件を追加",
    "Please Click On Add Button to Add Conditions": "条件を追加するには、追加ボタンをクリックしてください",
    "Add Level": "レベルを追加",
    "Please Click On Add Button to Add Assignments": "割り当てを追加するには、追加ボタンをクリックしてください",
    "Level Value": "レベル値",
    "Level Type": "レベルタイプ",
    "File Upload": "ファイルアップロード",
    "Value": "値",
    "Field": "フィールド",
    "Aggregate": "集計",
    "Operator": "演算子",
    "No items": "項目なし",
    "Whitelist": "ホワイトリスト",
    "Blacklist": "ブラックリスト",
    "Type to Search": "検索して入力...",
    "Column_Def": {
      "Assignments": "割り当て",
      "Conditions": "条件"
    },
    "Popup_Content": {
      "Confirm Rule Deletion": "ルール削除の確認",
      "Are you sure?": "本当によろしいですか？",
      "Do you really want to delete": "本当に削除しますか",
      "This process can not be undone.": "この操作は元に戻せません。"
    }
  },
  "HashCard": {
    "Add Hash Card": "ハッシュカードを追加",
    "Edit Hash Card": "ハッシュカードを編集",
    "Export to Excel": "エクセルにエクスポート",
    "Current Year Only": "エクセルにエクスポート（現在の年のみ）",
    "Previous Comments": "前回のコメント",
    "Hash Card Details": "カード詳細のハッシュ",
    "Column_Def": {
      "Hash Card Number": "ハッシュカード番号",
      "Status": "ステータス",
      "Created Date": "作成日",
      "Created By": "作成者",
      "Updated Date": "更新日",
      "Updated By": "更新者"
    },
    "Form_Fields": {
      "Hash Card Number": "ハッシュカード番号",
      "Status": "ステータス",
      "Comments": "コメント",
    },
    'ApprovePopup': {
      'titleAdd': 'ハッシュカードを追加',
      'titleEdit': 'ハッシュカードを更新',
      'heading': 'よろしいですか？',
      'contentAdd': 'ハッシュカード番号を追加しますか？',
      'contentEdit': 'ハッシュカードステータスを更新しますか？',
      'button': {
        'cancel': 'キャンセル',
        'submit': '送信',
      },
      "Validation": {
        "ExactLength": "ハッシュカード番号は正確に32文字でなければなりません",
        "MaxLength": "最大128文字まで。"
      },
    },
  },
  Transaction_Xray: {
    "Transaction X-Ray": "トランザクションX-Ray",
    "API Response": "APIレスポンス",
    "Please Select any service for the Api requests and responses": "APIリクエストとレスポンスのためにサービスを選択してください。",
    "Request": "リクエスト",
    "Processor": "プロセッサ",
    "Acquirer": "プロセッサ"
  },
  User_Settings: {
    "Select File Format": "レポート形式の選択",
    "default": "デフォルト",
    "Select Date Format": "日付形式の選択",
    "Select Currency": "选择聚合的货币",
    "Column Preference": "列の設定",
    "No previously selected list found": "以前に選択したリストが見つかりません",
    "Report Preference": "レポート設定",
    "Preference List error message": "名前は既に存在します。一意の名前を入力してください。",
    "Add Custom Preference List": "カスタム設定リストを追加",
    "Add Report Preference List": "レポート設定リストを追加",
    "Enter List Name": "リスト名を入力",
    "Custom Preference List": "カスタム設定リスト",
    "Custom Report Preference List": "レポート環境設定リストの選択",
    "Edit Column Preference List": "レポート環境設定リストの編集",
    "Do you really want to update the custom report preference list?": "レポート設定リストを更新してもよろしいですか？",
    "Add Statement Preference List": "明細の設定リストを追加",
    "Add Statement Preference": "明細の設定を追加",
    "Delete Statement Preference List": "Delete文環境設定リスト",
    "Edit Statement Preference List": "文の設定リストの編集",
    "Do you really want to update the statement preference list?": "文の設定リストを更新してもよろしいですか？",
    "Select Preferred Statement List": "優先文リストの選択",
    "Custom Statement Preference List": "Selectステートメント環境設定リスト",
    "Add Transaction Preference List": "取引環境設定リストの追加",
    "Add Transaction Preference": "取引環境設定リストの追加",
    "Transaction Preference": "取引設定リスト",
    "Statement Preference": "ステートメント設定リスト",
    "Select Preferred Transaction List": "優先取引リストを選択",
    "Custom Transaction Preference List": "取引環境設定リストの選択",
    "Select Preferred List": "希望するリストを選択",
    "Select Preferred Report List": "優先レポートリストを選択",
    "Delete Preference List": "環境設定リストの削除",
    "Delete Transaction Preference List": "トランザクション設定リストの削除",
    "Delete Report Preference List": "レポート環境設定リストの削除",
    "Edit Transaction Preference List": "取引設定リストの編集",
    "Download Started": "ダウンロード開始",
    'Are you sure?': '本当によろしいですか？',
    "Do you really want to delete this record? This process can not be undone": "このレコードを本当に削除しますか？この操作は元に戻せません。",
    "Do you really want to update the transaction preference list?": "トランザクション設定リストを更新してもよろしいですか？",
    "Email Notification": "メール通知",
    "Email Notification Settings": "メール通知設定",
    "Email Notification Settings Description": "主な連絡先の電子メール通知を選択/選択解除します。",
    "Default list applied": "デフォルトのリストが適用されます",
    "tabs": {
      "Report Format": "レポート形式のダウンロード",
      "Date Format": "日付形式",
      'Date Report Format': 'レポートと日付形式',
      "Email Notification": "メール通知",
      "Report Preference": "レポート設定",

    },
    "notifications": {
      "Chargeback": "チャージバック",
      "Statement": "ステートメント",
      "Emergency Holiday": "緊急休暇",
      "Monthly Public Holiday": "月次公休日"
    },
    "dateFormats": {
      "DATE_TIME_AM_PM": "DD 月 YYYY, hh:MM:SS 午前/午後 (例: 2024年11月21日, 午後2:04:28)",
      "DATE_TIME_DMY": "DD 月 YYYY, HH:MM:SS (例: 2024年11月21日, 14:04:28)",
      "DATE_TIME_YMD": "YYYY/MM/DD HH:MM:SS (例: 2024/11/21 14:04:28)"
    },
    "fileFormat": {
      "EXCEL": "エクセル",
      "CSV": "CSV"
    },
    buttons: {
      "Save": "送信",
      "Add": "追加"
    }
  },
  applicationApprovalLevel: {
    "0": "",
    "1": "閲覧のみ",
    "10": "入力者",
    "20": "マネージャー",
    "30": "部門長",
    "40": "代表取締役",
    "50": "グループ幹部",
    "60": "グループ代表取締役"
  },
  "DasPay_Receipts": {
    "tx": "取引番号",
    "Payment": "支払方法",
    "Total": "合計",
    "MID": "MID",
    "TID": "TID",
    "Batch": "バッチ",
    "Trace": "トレース番号",
    "RRN": "RRN",
    "ApprovalCode": "承認コード",
    "AdditionalInformation": "追加情報",
    "TransactionId": "取引ID",
    "STATE": "ステータス",
    "DateTime": "日時",
    "ATC": "ATC",
    "TVR": "TVR",
    "AppName": "アプリ名",
    "TSI": "TSI",
    "AID": "AID",
    "TC": "TC",
    Notes: 'メモ',
    TaxRegistrationNo: '税務登録番号',
    "DigitalSignature": "デジタル署名",
    "SignedAt": "署名日時",
    "ShareWithOthers": "他の人と共有",
    "Email": "メール",
    "Share": "共有",
    "PrintReceipt": "レシートを印刷",
    "TransactionType": "取引種別",
    TotalItems: '商品合計',
    TotalServiceFee: 'サービス料合計',
    AdditionalCharge: '追加料金',
    GST: '消費税',
  },
  "PresetFilter": {
    "Select Preset": "プリセットを選択",
    "Update": "更新",
    "Delete": "削除",
    "Save": "保存",
    "Enter Name": "名前を入力",
    "Update Name": "名前を更新",
    "Cancel": "キャンセル",
    "Add Preset": "プリセットを追加",
    "Update Preset": "プリセットを更新",
    "Confirm Delete": "プリセットフィルタの削除",
    "Are you sure you want to delete?": "あなたは本当にこのプリセットフィルタを削除しますか？ このプロセスは元に戻すことはできません。",
    "Name Already Exists": "プリセットフィルタは既に同じ名前で存在します。",
  },
  "Weekly": "毎週",
  "ScheduleReport": {
    "Add": "スケジュールレポートを追加",
    "Edit": "スケジュールレポートを編集",
    "Weekdays": {
      "Sunday": "日曜日",
      "Monday": "月曜日",
      "Tuesday": "火曜日",
      "Wednesday": "水曜日",
      "Thursday": "木曜日",
      "Friday": "金曜日",
      "Saturday": "土曜日"
    },
    "Column_Def": {
      "Name": "スケジュール名",
      "Status": "ステータス",
      "Report Name": "レポート名",
      "Reporting Timezone": "レポートタイムゾーン",
      "Reporting Period": "レポート期間",
      "Created By": "作成者",
      "Updated Date": "	更新日",
      "Updated By": "更新者",
      "Comments": "コメント",
      "Report Preference": "レポート設定",
    },
    "Form_Fields": {
      "Name": "スケジュール名",
      "Status": "ステータス",
      "Report Name": "レポート名",
      "Reporting Timezone": "レポートタイムゾーン",
      "Reporting Period": "レポート期間",
      "Reporting Preference": "レポート設定",
      "Preset Filter": "プリセットフィルター",
      "Include Sensitive Columns": "機密項目を含める",
      "Include Whitelist Transactions": "ホワイトリスト取引を含める",
      "Report Format": "レポート形式",
      "Reporting Time": "レポート作成時刻",
      "Report Day": "レポート曜日",
      "Report Monthly Date": "月日",
      "Comments": "コメント",
    },
    "ReportName": {
      "Transactions": "Transactions",
    },
    "ReportingPeriod":{
      "Today":"今日",
      "Yesterday":"昨日",
      "Weekly":"決済毎週",
      "Month to Date":"今月",
      "Month Start to Yesterday":"今月から昨日",
      "Previous_Month":"先月",
      "Last 30 Days":"過去30日",
      "Last 7 Days":"過去7日",
      "Years to Date":"今年",
    },
    "Validation":
    {
      "DuplicateName": "同じ名前のスケジュールレポートがすでに作成されています。別の名前を入力してください。"
    }
  },
};
export default common;
